import * as h from "react";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import "../styles/recovered-core.css";
import "../styles/document-lines.css";
import "../styles/panel-001.css";
import "../styles/ui-001.css";
import { PageHeader } from "../components/layout/PageHeader.jsx";
import { FeatureRouter } from "./FeatureRouter.jsx";
import { RecentActivity } from "../features/dashboard/RecentActivity.jsx";
import { TodayPanel } from "../features/dashboard/TodayPanel.jsx";
import { apiFetch as M } from "../api/client.js";
import { EditableCombobox } from "../components/forms/EditableCombobox.jsx";
import { calculateCommercialEconomics } from "../domain/commercialEconomics.js";
import { ASSET_CLASS, countAssetsByCenter, countAssetsByClass, filterAssets } from "../domain/assetFilters.js";
import { duplicateAssetDraft } from "../domain/assetDraft.js";
import { localDateTimeValue, validWorkOrderTiming, workOrderDuration } from "../domain/workOrderTiming.js";
import { openCommercialPrintPreview, openWorkOrderPrintPreview } from "../features/print/openPrintPreview.js";

const k = { jsx, jsxs, Fragment };
let l = (...e) => e.filter((e, t, n) => !!e && e.trim() !== `` && n.indexOf(e) === t).join(` `).trim(),
    u = e => e.replace(/([a-z0-9])([A-Z])/g, `$1-$2`).toLowerCase(),
    d = e => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()),
    f = e => {
        let t = d(e);
        return t.charAt(0).toUpperCase() + t.slice(1)
    },
    p = {
        xmlns: `http://www.w3.org/2000/svg`,
        width: 24,
        height: 24,
        viewBox: `0 0 24 24`,
        fill: `none`,
        stroke: `currentColor`,
        strokeWidth: 2,
        strokeLinecap: `round`,
        strokeLinejoin: `round`
    },
    m = e => {
        for (let t in e)
            if (t.startsWith(`aria-`) || t === `role` || t === `title`) return !0;
        return !1
    },
    g = (0, h.createContext)({}),
    _ = () => (0, h.useContext)(g),
    v = (0, h.forwardRef)(({
        color: e,
        size: t,
        strokeWidth: n,
        absoluteStrokeWidth: r,
        className: i = ``,
        children: a,
        iconNode: o,
        ...s
    }, c) => {
        let {
            size: u = 24,
            strokeWidth: d = 2,
            absoluteStrokeWidth: f = !1,
            color: g = `currentColor`,
            className: v = ``
        } = _() ?? {}, y = r ?? f ? Number(n ?? d) * 24 / Number(t ?? u) : n ?? d;
        return (0, h.createElement)(`svg`, {
            ref: c,
            ...p,
            width: t ?? u ?? p.width,
            height: t ?? u ?? p.height,
            stroke: e ?? g,
            strokeWidth: y,
            className: l(`lucide`, v, i),
            ...!a && !m(s) && {
                "aria-hidden": `true`
            },
            ...s
        }, [...o.map(([e, t]) => (0, h.createElement)(e, t)), ...Array.isArray(a) ? a : [a]])
    }),
    y = (e, t) => {
        let n = (0, h.forwardRef)(({
            className: n,
            ...r
        }, i) => (0, h.createElement)(v, {
            ref: i,
            iconNode: t,
            className: l(`lucide-${u(f(e))}`, `lucide-${e}`, n),
            ...r
        }));
        return n.displayName = f(e), n
    },
    b = y(`archive`, [
        [`rect`, {
            width: `20`,
            height: `5`,
            x: `2`,
            y: `3`,
            rx: `1`,
            key: `1wp1u1`
        }],
        [`path`, {
            d: `M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8`,
            key: `1s80jp`
        }],
        [`path`, {
            d: `M10 12h4`,
            key: `a56b0p`
        }]
    ]),
    x = y(`arrow-down`, [
        [`path`, {
            d: `M12 5v14`,
            key: `s699le`
        }],
        [`path`, {
            d: `m19 12-7 7-7-7`,
            key: `1idqje`
        }]
    ]),
    ee = y(`arrow-left`, [
        [`path`, {
            d: `m12 19-7-7 7-7`,
            key: `1l729n`
        }],
        [`path`, {
            d: `M19 12H5`,
            key: `x3x0zl`
        }]
    ]),
    S = y(`arrow-right`, [
        [`path`, {
            d: `M5 12h14`,
            key: `1ays0h`
        }],
        [`path`, {
            d: `m12 5 7 7-7 7`,
            key: `xquz4c`
        }]
    ]),
    C = y(`arrow-up`, [
        [`path`, {
            d: `m5 12 7-7 7 7`,
            key: `hav0vg`
        }],
        [`path`, {
            d: `M12 19V5`,
            key: `x0mq9r`
        }]
    ]),
    w = y(`boxes`, [
        [`path`, {
            d: `M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z`,
            key: `lc1i9w`
        }],
        [`path`, {
            d: `m7 16.5-4.74-2.85`,
            key: `1o9zyk`
        }],
        [`path`, {
            d: `m7 16.5 5-3`,
            key: `va8pkn`
        }],
        [`path`, {
            d: `M7 16.5v5.17`,
            key: `jnp8gn`
        }],
        [`path`, {
            d: `M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z`,
            key: `8zsnat`
        }],
        [`path`, {
            d: `m17 16.5-5-3`,
            key: `8arw3v`
        }],
        [`path`, {
            d: `m17 16.5 4.74-2.85`,
            key: `8rfmw`
        }],
        [`path`, {
            d: `M17 16.5v5.17`,
            key: `k6z78m`
        }],
        [`path`, {
            d: `M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z`,
            key: `1xygjf`
        }],
        [`path`, {
            d: `M12 8 7.26 5.15`,
            key: `1vbdud`
        }],
        [`path`, {
            d: `m12 8 4.74-2.85`,
            key: `3rx089`
        }],
        [`path`, {
            d: `M12 13.5V8`,
            key: `1io7kd`
        }]
    ]),
    te = y(`check`, [
        [`path`, {
            d: `M20 6 9 17l-5-5`,
            key: `1gmf2c`
        }]
    ]),
    ne = y(`chevron-down`, [
        [`path`, {
            d: `m6 9 6 6 6-6`,
            key: `qrunsl`
        }]
    ]),
    re = y(`clipboard-list`, [
        [`rect`, {
            width: `8`,
            height: `4`,
            x: `8`,
            y: `2`,
            rx: `1`,
            ry: `1`,
            key: `tgr4d6`
        }],
        [`path`, {
            d: `M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2`,
            key: `116196`
        }],
        [`path`, {
            d: `M12 11h4`,
            key: `1jrz19`
        }],
        [`path`, {
            d: `M12 16h4`,
            key: `n85exb`
        }],
        [`path`, {
            d: `M8 11h.01`,
            key: `1dfujw`
        }],
        [`path`, {
            d: `M8 16h.01`,
            key: `18s6g9`
        }]
    ]),
    ie = y(`copy`, [
        [`rect`, {
            width: `14`,
            height: `14`,
            x: `8`,
            y: `8`,
            rx: `2`,
            ry: `2`,
            key: `17jyea`
        }],
        [`path`, {
            d: `M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2`,
            key: `zix9uf`
        }]
    ]),
    ae = y(`download`, [
        [`path`, {
            d: `M12 15V3`,
            key: `m9g1x1`
        }],
        [`path`, {
            d: `M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4`,
            key: `ih7n3h`
        }],
        [`path`, {
            d: `m7 10 5 5 5-5`,
            key: `brsn70`
        }]
    ]),
    oe = y(`ellipsis`, [
        [`circle`, {
            cx: `12`,
            cy: `12`,
            r: `1`,
            key: `41hilf`
        }],
        [`circle`, {
            cx: `19`,
            cy: `12`,
            r: `1`,
            key: `1wjl8i`
        }],
        [`circle`, {
            cx: `5`,
            cy: `12`,
            r: `1`,
            key: `1pcz8c`
        }]
    ]),
    se = y(`file-pen-line`, [
        [`path`, {
            d: `M14.364 13.634a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506l4.013-4.009a1 1 0 0 0-3.004-3.004z`,
            key: `ukzhwg`
        }],
        [`path`, {
            d: `M14.487 7.858A1 1 0 0 1 14 7V2`,
            key: `1klhew`
        }],
        [`path`, {
            d: `M20 19.645V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l2.516 2.516`,
            key: `rxaxab`
        }],
        [`path`, {
            d: `M8 18h1`,
            key: `13wk12`
        }]
    ]),
    ce = y(`grip-vertical`, [
        [`circle`, {
            cx: `9`,
            cy: `12`,
            r: `1`,
            key: `1vctgf`
        }],
        [`circle`, {
            cx: `9`,
            cy: `5`,
            r: `1`,
            key: `hp0tcf`
        }],
        [`circle`, {
            cx: `9`,
            cy: `19`,
            r: `1`,
            key: `fkjjf6`
        }],
        [`circle`, {
            cx: `15`,
            cy: `12`,
            r: `1`,
            key: `1tmaij`
        }],
        [`circle`, {
            cx: `15`,
            cy: `5`,
            r: `1`,
            key: `19l28e`
        }],
        [`circle`, {
            cx: `15`,
            cy: `19`,
            r: `1`,
            key: `f4zoj3`
        }]
    ]),
    le = y(`log-out`, [
        [`path`, {
            d: `m16 17 5-5-5-5`,
            key: `1bji2h`
        }],
        [`path`, {
            d: `M21 12H9`,
            key: `dn1m92`
        }],
        [`path`, {
            d: `M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4`,
            key: `1uf3rs`
        }]
    ]),
    ue = y(`menu`, [
        [`path`, {
            d: `M4 5h16`,
            key: `1tepv9`
        }],
        [`path`, {
            d: `M4 12h16`,
            key: `1lakjw`
        }],
        [`path`, {
            d: `M4 19h16`,
            key: `1djgab`
        }]
    ]),
    T = y(`monitor-cog`, [
        [`path`, {
            d: `M12 17v4`,
            key: `1riwvh`
        }],
        [`path`, {
            d: `m14.305 7.53.923-.382`,
            key: `1mlnsw`
        }],
        [`path`, {
            d: `m15.228 4.852-.923-.383`,
            key: `82mpwg`
        }],
        [`path`, {
            d: `m16.852 3.228-.383-.924`,
            key: `ln4sir`
        }],
        [`path`, {
            d: `m16.852 8.772-.383.923`,
            key: `1dejw0`
        }],
        [`path`, {
            d: `m19.148 3.228.383-.924`,
            key: `192kgf`
        }],
        [`path`, {
            d: `m19.53 9.696-.382-.924`,
            key: `fiavlr`
        }],
        [`path`, {
            d: `m20.772 4.852.924-.383`,
            key: `1j8mgp`
        }],
        [`path`, {
            d: `m20.772 7.148.924.383`,
            key: `zix9be`
        }],
        [`path`, {
            d: `M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7`,
            key: `1tnzv8`
        }],
        [`path`, {
            d: `M8 21h8`,
            key: `1ev6f3`
        }],
        [`circle`, {
            cx: `18`,
            cy: `6`,
            r: `3`,
            key: `1h7g24`
        }]
    ]),
    E = y(`package-check`, [
        [`path`, {
            d: `M12 22V12`,
            key: `d0xqtd`
        }],
        [`path`, {
            d: `m16 17 2 2 4-4`,
            key: `uh5qu3`
        }],
        [`path`, {
            d: `M21 11.127V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.32-.753`,
            key: `kpkbpo`
        }],
        [`path`, {
            d: `M3.29 7 12 12l8.71-5`,
            key: `19ckod`
        }],
        [`path`, {
            d: `m7.5 4.27 8.997 5.148`,
            key: `9yrvtv`
        }]
    ]),
    de = y(`paperclip`, [
        [`path`, {
            d: `m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551`,
            key: `1miecu`
        }]
    ]),
    fe = y(`pencil`, [
        [`path`, {
            d: `M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z`,
            key: `1a8usu`
        }],
        [`path`, {
            d: `m15 5 4 4`,
            key: `1mk7zo`
        }]
    ]),
    D = y(`plus`, [
        [`path`, {
            d: `M5 12h14`,
            key: `1ays0h`
        }],
        [`path`, {
            d: `M12 5v14`,
            key: `s699le`
        }]
    ]),
    pe = y(`printer`, [
        [`path`, {
            d: `M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2`,
            key: `143wyd`
        }],
        [`path`, {
            d: `M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6`,
            key: `1itne7`
        }],
        [`rect`, {
            x: `6`,
            y: `14`,
            width: `12`,
            height: `8`,
            rx: `1`,
            key: `1ue0tg`
        }]
    ]),
    me = y(`rotate-ccw-clock`, [
        [`path`, {
            d: `M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8`,
            key: `1357e3`
        }],
        [`path`, {
            d: `M3 3v5h5`,
            key: `1xhq8a`
        }],
        [`path`, {
            d: `M12 7v5l4 2`,
            key: `1fdv2h`
        }]
    ]),
    O = y(`rotate-ccw`, [
        [`path`, {
            d: `M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8`,
            key: `1357e3`
        }],
        [`path`, {
            d: `M3 3v5h5`,
            key: `1xhq8a`
        }]
    ]),
    he = y(`search`, [
        [`path`, {
            d: `m21 21-4.34-4.34`,
            key: `14j7rj`
        }],
        [`circle`, {
            cx: `11`,
            cy: `11`,
            r: `8`,
            key: `4ej97u`
        }]
    ]),
    ge = y(`settings`, [
        [`path`, {
            d: `M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915`,
            key: `1i5ecw`
        }],
        [`circle`, {
            cx: `12`,
            cy: `12`,
            r: `3`,
            key: `1v7zrd`
        }]
    ]),
    _e = y(`shield-check`, [
        [`path`, {
            d: `M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z`,
            key: `oel41y`
        }],
        [`path`, {
            d: `m9 12 2 2 4-4`,
            key: `dzmm74`
        }]
    ]),
    ve = y(`signature`, [
        [`path`, {
            d: `m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284`,
            key: `y32ogt`
        }],
        [`path`, {
            d: `M3 21h18`,
            key: `itz85i`
        }]
    ]),
    ye = y(`trash-2`, [
        [`path`, {
            d: `M10 11v6`,
            key: `nco0om`
        }],
        [`path`, {
            d: `M14 11v6`,
            key: `outv1u`
        }],
        [`path`, {
            d: `M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6`,
            key: `miytrc`
        }],
        [`path`, {
            d: `M3 6h18`,
            key: `d0wm0j`
        }],
        [`path`, {
            d: `M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2`,
            key: `e791ji`
        }]
    ]),
    be = y(`truck`, [
        [`path`, {
            d: `M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2`,
            key: `wrbu53`
        }],
        [`path`, {
            d: `M15 18H9`,
            key: `1lyqi6`
        }],
        [`path`, {
            d: `M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14`,
            key: `lysw3i`
        }],
        [`circle`, {
            cx: `17`,
            cy: `18`,
            r: `2`,
            key: `332jqn`
        }],
        [`circle`, {
            cx: `7`,
            cy: `18`,
            r: `2`,
            key: `19iecd`
        }]
    ]),
    xe = y(`upload`, [
        [`path`, {
            d: `M12 3v12`,
            key: `1x0j5s`
        }],
        [`path`, {
            d: `m17 8-5-5-5 5`,
            key: `7q97r8`
        }],
        [`path`, {
            d: `M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4`,
            key: `ih7n3h`
        }]
    ]),
    Se = y(`users`, [
        [`path`, {
            d: `M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2`,
            key: `1yyitq`
        }],
        [`path`, {
            d: `M16 3.128a4 4 0 0 1 0 7.744`,
            key: `16gr8j`
        }],
        [`path`, {
            d: `M22 21v-2a4 4 0 0 0-3-3.87`,
            key: `kshegd`
        }],
        [`circle`, {
            cx: `9`,
            cy: `7`,
            r: `4`,
            key: `nufk8`
        }]
    ]),
    Ce = y(`wrench`, [
        [`path`, {
            d: `M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z`,
            key: `1ngwbx`
        }]
    ]),
    we = y(`x`, [
        [`path`, {
            d: `M18 6 6 18`,
            key: `1bl5f8`
        }],
        [`path`, {
            d: `m6 6 12 12`,
            key: `d8bk6v`
        }]
    ]),

    ke = [{
        id: 0,
        code: `CLIMA-35`,
        description: `Aire acondicionado Split Inverter 3.500 frigorías`,
        family: `Climatización`,
        active: !0,
        externalId: ``,
        version: 0,
        cost: 438.5,
        price: 689,
        igic: 7,
        stock: 8,
        warehouse: `01`,
        serial: !0,
        freq: 14,
        last: `28/08/2026`,
        discount: 5
    }, {
        id: 0,
        code: `BOMB-22`,
        description: `Bomba de calor mural 2.200 W`,
        family: `Climatización`,
        active: !0,
        externalId: ``,
        version: 0,
        cost: 296,
        price: 469,
        igic: 7,
        stock: 3,
        warehouse: `01`,
        serial: !0,
        freq: 11,
        last: `02/09/2026`,
        discount: 0
    }, {
        id: 0,
        code: `TERM-80`,
        description: `Termo eléctrico 80 L`,
        family: `ACS`,
        active: !0,
        externalId: ``,
        version: 0,
        cost: 142,
        price: 249,
        igic: 7,
        stock: 0,
        warehouse: `01`,
        serial: !1,
        freq: 8,
        last: `19/08/2026`,
        discount: 10
    }, {
        id: 0,
        code: `INST-01`,
        description: `Instalación estándar y puesta en marcha`,
        family: `Servicios`,
        active: !0,
        externalId: ``,
        version: 0,
        cost: 82,
        price: 185,
        igic: 7,
        stock: -1,
        warehouse: `01`,
        serial: !1,
        freq: 18,
        last: `05/09/2026`,
        discount: 0
    }, {
        id: 0,
        code: `ANT-009`,
        description: `Equipo descatalogado`,
        family: `Climatización`,
        active: !1,
        externalId: ``,
        version: 0,
        cost: 100,
        price: 190,
        igic: 7,
        stock: 2,
        warehouse: `01`,
        serial: !1,
        freq: 1,
        last: `12/02/2025`,
        discount: 0
    }],
    Ae = [{
        id: 1,
        kind: `Oferta`,
        number: `OF-2026-00418`,
        client: `Hotel Costa Azul`,
        date: `2026-09-08`,
        status: `Borrador`,
        series: `OF`,
        agent: `Iván García`,
        total: 2321.47
    }, {
        id: 2,
        kind: `Pedido`,
        number: `PD-2026-00192`,
        client: `Reformas Atlántico, S.L.`,
        date: `2026-09-08`,
        status: `Pendiente`,
        series: `PD`,
        agent: `Laura Pérez`,
        total: 1475.25
    }, {
        id: 3,
        kind: `Albarán`,
        number: `AL-2026-00876`,
        client: `Clínica Dental Mar`,
        date: `2026-09-07`,
        status: `Firmado`,
        series: `AL`,
        agent: `Iván García`,
        total: 0
    }, {
        id: 4,
        kind: `Oferta`,
        number: `OF-2026-00417`,
        client: `Restaurante El Puerto`,
        date: `2026-09-06`,
        status: `Enviada`,
        series: `OF`,
        agent: `Laura Pérez`,
        total: 884.19
    }],
    je = `microten-poc`,
    Me = `opa-documents`,
    Ne = () => new Promise((e, t) => {
        let n = indexedDB.open(je, 1);
        n.onupgradeneeded = () => {
            n.result.objectStoreNames.contains(Me) || n.result.createObjectStore(Me, {
                keyPath: `id`
            })
        }, n.onsuccess = () => e(n.result), n.onerror = () => t(n.error)
    }),
    Pe = async () => {
        let e = await Ne();
        return new Promise((t, n) => {
            let r = e.transaction(Me, `readonly`).objectStore(Me).getAll();
            r.onsuccess = () => t(r.result), r.onerror = () => n(r.error)
        })
    }, Fe = () => ({
        id: 0,
        code: ``,
        name: ``,
        nif: ``,
        address: ``,
        postalCode: ``,
        city: ``,
        province: ``,
        contact: ``,
        phone: ``,
        email: ``,
        notes: ``,
        origin: `LOCAL`,
        externalId: ``,
        lastSyncedAt: ``,
        linkStatus: `UNLINKED`,
        active: !0,
        version: 1,
        centers: [],
        assets: []
    }), Ie = (e = 0) => ({
        id: 0,
        customerId: e,
        code: ``,
        name: ``,
        address: ``,
        postalCode: ``,
        city: ``,
        province: ``,
        notes: ``,
        active: !0,
        version: 1
    }), Le = (e = 0, t = 0) => ({
        id: 0,
        customerId: e,
        centerId: t,
        code: ``,
        name: ``,
        commercialName: ``,
        serial: ``,
        type: ``,
        assetClass: ``,
        brand: ``,
        features: ``,
        location: ``,
        updatedOn: ``,
        supplier: ``,
        seller: `MICROTEN`,
        warrantyFrom: ``,
        warrantyTo: ``,
        domainGroup: ``,
        notes: ``,
        active: !0,
        externalId: ``,
        version: 1
    }), Re = `PC SEMITORRE.PC MINITORRE SLIM.PC SOBREMESA.NOTEBOOK.NETBOOK.FIREWALL.SERVIDOR CLÓNICO.SERVIDOR MARCA.GLOBAL.MÁQUINA VIRTUAL.TABLET.ITX.PC REACONDICIONADO.NOTEBOOK REACONDICIONADO.PERIFERICO REACONDICIONADO.AIO.MULTIFUNCIÓN TINTA.MULTIFUNCIÓN LÁSER.IMPRESORA LÁSER.IMPRESORA TINTA.IMPRESORA TICKET.MONITOR.PLOTTER.ESCÁNER.UNIDAD NAS.UPS.PUNTO DE ACCESO.ROUTER`.split(`.`), ze = `ZONE EVIL.ACER.GIGABYTE.MICROTEN.HP.DELL.ONEWAY.BOGO.SAMSUNG.EPSON.MICROSOFT.PANDA.MCAFEE.LOGITECH.CREATIVE.EWENT.SEAGATE.WESTERN DIGITAL.TOSHIBA.BQ.SAENTECH.SIN MARCA.PACKARD BELL.WOLDER.ENERGY.MEDIACOM.QI.LENOVO.OKI.LG.MSI.MR MICRO.ASUS.BROTHER.CANON.eMACHINE.SALICRU.APC.INTEGRA.ELBAT.TP-LINK.D-LINK.CAMVIEW.APPLE.VIEWSONIC.AOC.ENTERPRISE`.split(`.`), Be = (e, t, n) => Array.from(new Set([...e, ...t.map(e => e[n]).filter(Boolean)])), Ve = e => {
        if (!e) return `Pendiente de primer guardado`;
        let t = new Date(e.replace(` `, `T`));
        if (Number.isNaN(t.getTime())) return e;
        let n = e => String(e).padStart(2, `0`);
        return `${n(t.getDate())}/${n(t.getMonth()+1)}/${t.getFullYear()} ${n(t.getHours())}:${n(t.getMinutes())}`
    }, He = () => ({
        id: 0,
        code: ``,
        description: ``,
        family: ``,
        cost: 0,
        igic: 7,
        active: !0,
        serial: !1,
        externalId: ``,
        version: 1,
        price: 0,
        stock: 0,
        warehouse: `01`,
        freq: 0,
        last: ``,
        discount: 0
    }), Ue = () => ({
        urgency: `Normal`,
        schedule: `Adecuado`,
        treatment: `Correcto`,
        demand: `Normal`,
        scope: `Definido`,
        impact: `Bajo`,
        note: ``,
        light: `Verde`
    }), We = [{
        id: 301,
        number: `OT-2026-00301`,
        date: `2026-09-09`,
        startedAt: ``,
        finishedAt: ``,
        status: `En curso`,
        client: `Hotel Costa Azul`,
        center: `Hotel principal`,
        objectType: `Activo concreto`,
        asset: `CLIMA-HC-01 · Daikin VRV cubierta`,
        assets: [`CLIMA-HC-01 · Daikin VRV cubierta`],
        serial: `DRV-889214`,
        origin: `Solicitada`,
        assistance: [`Presencial`],
        mainTech: `Iván García`,
        extraTechs: [`Laura Pérez`],
        incident: `La unidad exterior se detiene de forma intermitente.`,
        action: `Comprobación de presiones y limpieza de filtros. Pendiente revisar placa de control.`,
        publicNotes: `Equipo operativo de forma provisional.`,
        internalNotes: `Priorizar repuesto antes del viernes.`,
        travel: !0,
        billable: !0,
        relatedDocs: [2],
        materials: [{
            id: 1,
            code: `CLIMA-35`,
            description: `Kit de filtros climatización`,
            qty: `2,00`,
            serialRequired: !0,
            serials: [`FLT-8821`, `FLT-8822`]
        }],
        quality: {
            ...Ue(),
            light: `Amarillo`,
            impact: `Medio`
        },
        signer: ``,
        signerId: ``,
        signedAt: ``,
        signatureData: ``,
        confirmed: !1
    }, {
        id: 300,
        number: `OT-2026-00300`,
        date: `2026-09-08`,
        status: `Borrador`,
        client: `Clínica Dental Mar`,
        center: `Clínica Las Canteras`,
        objectType: `Sistema informático`,
        asset: ``,
        assets: [],
        serial: ``,
        origin: `Mantenimiento preventivo`,
        assistance: [`Remota`, `Telefónica`],
        mainTech: `Iván García`,
        extraTechs: [],
        incident: `Revisión preventiva del servidor y copias.`,
        action: ``,
        publicNotes: ``,
        internalNotes: ``,
        travel: !1,
        billable: !1,
        relatedDocs: [3],
        materials: [],
        quality: Ue(),
        signer: ``,
        signerId: ``,
        signedAt: ``,
        signatureData: ``,
        confirmed: !1
    }, {
        id: 299,
        number: `OT-2026-00299`,
        date: `2026-09-07`,
        status: `Finalizada`,
        client: `Hotel Costa Azul`,
        center: `Apartamentos anexos`,
        objectType: `Red`,
        asset: ``,
        assets: [],
        serial: ``,
        origin: `Solicitada`,
        assistance: [`Presencial`, `SAT`],
        mainTech: `Laura Pérez`,
        extraTechs: [`Iván García`],
        incident: `Pérdida de conexión en planta 2.`,
        action: `Sustitución de switch y verificación de puntos de acceso.`,
        publicNotes: `Servicio restablecido.`,
        internalNotes: `No mostrar en parte.`,
        travel: !0,
        billable: !0,
        relatedDocs: [1],
        materials: [{
            id: 2,
            code: ``,
            description: `Latiguillo de red categoría 6`,
            qty: `3,00`,
            serialRequired: !1,
            serials: []
        }],
        quality: {
            ...Ue(),
            light: `Verde`
        },
        signer: `Marta Hernández`,
        signerId: `42888123A`,
        signedAt: `07/09/2026 18:42`,
        signatureData: ``,
        confirmed: !0
    }], Ge = e => ({
        id: Date.now(),
        number: e,
        date: `2026-09-09`,
        status: `Borrador`,
        client: ``,
        center: ``,
        objectType: `Activo concreto`,
        asset: ``,
        assets: [],
        serial: ``,
        origin: `Solicitada`,
        assistance: [],
        mainTech: ``,
        extraTechs: [],
        incident: ``,
        action: ``,
        publicNotes: ``,
        internalNotes: ``,
        travel: !1,
        billable: !1,
        relatedDocs: [],
        materials: [],
        quality: Ue(),
        signer: ``,
        signerId: ``,
        signedAt: ``,
        signatureData: ``,
        confirmed: !1
    }), Ke = () => [{
        id: Date.now(),
        code: ``,
        description: ``,
        qty: `1,00`,
        delivered: `0,00`,
        cost: `0,00`,
        price: `0,00`,
        discount: `0,00`,
        igic: `7`
    }], qe = () => [{
        id: 101,
        code: `CLIMA-35`,
        description: ke[0].description,
        qty: `2,00`,
        delivered: `0,00`,
        cost: `438,50`,
        price: `689,00`,
        discount: `5,00`,
        igic: `7`,
        serial: !0
    }, {
        id: 102,
        code: `INST-01`,
        description: ke[3].description,
        qty: `2,00`,
        delivered: `0,00`,
        cost: `82,00`,
        price: `185,00`,
        discount: `0,00`,
        igic: `7`
    }, {
        id: 103,
        code: ``,
        description: `ENTREGA E INSTALACIÓN`,
        qty: `0,00`,
        delivered: `0,00`,
        cost: `0,00`,
        price: `0,00`,
        discount: `0,00`,
        igic: `0`,
        note: !0,
        heading: !0
    }], A = e => {
        let t = (e || `0`).trim(),
            n = t.includes(`,`) ? t.replace(/\./g, ``).replace(`,`, `.`) : t;
        return Number(n) || 0
    }, Je = e => e.includes(`,`) ? e : e.replace(`.`, `,`), Ye = e => e.currentTarget.select(), Xe = (e, t) => e === `Albarán` ? t.map(e => e.serial ? {
        ...e,
        serials: Array.from({
            length: Math.max(0, Math.abs(Math.trunc(A(e.qty))))
        }, (t, n) => e.serials?.[n] || ``)
    } : e) : t, Ze = e => {
        let [t, n] = Math.abs(e).toFixed(2).split(`.`);
        return `${e<0?`-`:``}${t.replace(/\B(?=(\d{3})+(?!\d))/g,`.
        `)},${n}`
    }, j = e => `${Ze(e)} €`, Qe = e => new Intl.DateTimeFormat(`es-ES`, {
        day: `2-digit`,
        month: `short`
    }).format(new Date(`${e}T12:00:00`)), $e = () => ({
        id: 0,
        name: ``,
        email: ``,
        role: `Operador`,
        active: !0,
        twoFactorEnabled: !1,
        password: ``,
        version: 0
    });

export function RecoveredApplication({
    auth: e,
    onLogout: t
}) {
    let [n, r] = (0, h.useState)(`home`), [i, a] = (0, h.useState)(Ae), [o, s] = (0, h.useState)(`Todos`), [c, l] = (0, h.useState)(`Todos`), [u, d] = (0, h.useState)(Ae[0]), [f, p] = (0, h.useState)(null), [m, g] = (0, h.useState)({}), [_, v] = (0, h.useState)(qe()), [y, Te] = (0, h.useState)(Ae[0].client), [Ee, De] = (0, h.useState)(``), [je, Me] = (0, h.useState)(!1), [Ne, Ue] = (0, h.useState)(!1), [et, N] = (0, h.useState)(null), [tt, nt] = (0, h.useState)(``), [rt, it] = (0, h.useState)(`Resultados`), [at, ot] = (0, h.useState)(``), [st, ct] = (0, h.useState)(`Todas`), [lt, ut] = (0, h.useState)(ke), [P, dt] = (0, h.useState)(He()), [ft, pt] = (0, h.useState)(!1), [mt, ht] = (0, h.useState)(!0), [F, gt] = (0, h.useState)(e.roleCode === `ADMIN`), [_t, vt] = (0, h.useState)(``), [yt, bt] = (0, h.useState)(`Todos`), [xt, St] = (0, h.useState)(`Todos`), [Ct, wt] = (0, h.useState)(``), [Tt, Et] = (0, h.useState)(``), [Dt, Ot] = (0, h.useState)(`30`), [kt, At] = (0, h.useState)(`01`), [jt, Mt] = (0, h.useState)([]), [Nt, Pt] = (0, h.useState)([]), [Ft, It] = (0, h.useState)(null), [Lt, Rt] = (0, h.useState)({
        id: 0,
        title: ``,
        owner: `Iván García`,
        date: `2026-09-09`,
        link: ``,
        comment: ``,
        status: `Pendiente`,
        result: ``
    }), [zt, Bt] = (0, h.useState)(!1), [Vt, Ht] = (0, h.useState)(!1), [Ut, Wt] = (0, h.useState)(!1), [Gt, Kt] = (0, h.useState)(`Marta Hernández`), [qt, Jt] = (0, h.useState)(``), [Yt, Xt] = (0, h.useState)(`Corrección de unidades entregadas`), [Zt, Qt] = (0, h.useState)(!1), [$t, en] = (0, h.useState)(null), [tn, nn] = (0, h.useState)(We), [I, rn] = (0, h.useState)(We[0]), [an, on] = (0, h.useState)(``), [sn, cn] = (0, h.useState)(``), [ln, un] = (0, h.useState)(1), [dn, fn] = (0, h.useState)(``), [pn, mn] = (0, h.useState)(``), [hn, gn] = (0, h.useState)(``), [_n, vn] = (0, h.useState)(null), [yn, bn] = (0, h.useState)({
        qualityView: !0,
        qualityEdit: !1,
        billable: !1,
        otherTechs: !1,
        supervision: !1
    }), [xn, Sn] = (0, h.useState)([]), [Cn, wn] = (0, h.useState)(``), [L, Tn] = (0, h.useState)(null), [En, Dn] = (0, h.useState)(Fe()), [On, kn] = (0, h.useState)(!1), [An, jn] = (0, h.useState)(null), [Mn, Nn] = (0, h.useState)(``), [Pn, Fn] = (0, h.useState)([]), [In, Ln] = (0, h.useState)(0), [Rn, zn] = (0, h.useState)([]), [Bn, Vn] = (0, h.useState)([]), [Hn, Un] = (0, h.useState)(Ie()), [Wn, Gn] = (0, h.useState)(!1), [Kn, qn] = (0, h.useState)([]), [Jn, Yn] = (0, h.useState)([]), [R, z] = (0, h.useState)(Le()), [Xn, Zn] = (0, h.useState)(!1), [Qn, $n] = (0, h.useState)(0), [assetDeleteCandidate, setAssetDeleteCandidate] = (0, h.useState)(null), [assetCenterFilter, setAssetCenterFilter] = (0, h.useState)(0), [assetClassFilter, setAssetClassFilter] = (0, h.useState)(ASSET_CLASS.ALL), [er, tr] = (0, h.useState)(null), [nr, rr] = (0, h.useState)([]), [ir, ar] = (0, h.useState)($e()), [or, sr] = (0, h.useState)(!1), [cr, lr] = (0, h.useState)(!1), [ur, dr] = (0, h.useState)(``), [fr, pr] = (0, h.useState)(!1), [mr, hr] = (0, h.useState)(null), [ecoDraft, setEcoDraft] = (0, h.useState)(null), [printDocument, setPrintDocument] = (0, h.useState)(null), [workOrderMail, setWorkOrderMail] = (0, h.useState)({ recipient: ``, cc: ``, history: [], sending: !1 }), [workOrderMailCc, setWorkOrderMailCc] = (0, h.useState)(``), gr = (0, h.useRef)(null), _r = (0, h.useRef)(null), vr = (0, h.useRef)(null), assetWorkspaceRef = (0, h.useRef)(null), yr = (0, h.useRef)(!1), br = (0, h.useRef)(!1), xr = (0, h.useRef)(0), Sr = (0, h.useRef)(0), B = e => {
        nt(e), setTimeout(() => nt(``), 2200)
    };
    (0, h.useEffect)(() => {
        Pe().then(e => a(t => [...e.filter(e => ![`Oferta`, `Pedido`, `Albarán`].includes(e.kind)), ...t.filter(t => !e.some(e => e.id === t.id))])).catch(() => B(`No se pudo abrir la base local del POC`))
    }, []);
    (0, h.useEffect)(() => {
        setAssetCenterFilter(0), setAssetClassFilter(ASSET_CLASS.ALL)
    }, [L?.id]);
    let Cr = async (e = ``) => {
        let t = await M(`/api/offers.php?q=${encodeURIComponent(e)}`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!t.ok) throw Error(String(t.status));
        let n = await t.json();
        a(e => [...n.offers, ...e.filter(e => e.kind !== `Oferta`)])
    }, wr = async (e = ``) => {
        let t = await M(`/api/sales-orders.php?q=${encodeURIComponent(e)}`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!t.ok) throw Error(String(t.status));
        let n = await t.json();
        a(e => [...n.orders, ...e.filter(e => e.kind !== `Pedido`)])
    }, Tr = async (e = ``) => {
        let t = await M(`/api/delivery-notes.php?q=${encodeURIComponent(e)}`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!t.ok) throw Error(String(t.status));
        let n = await t.json();
        a(e => [...n.deliveryNotes, ...e.filter(e => e.kind !== `Albarán`)])
    }, Er = async (e = ``) => {
        let t = await M(`/api/tasks.php?q=${encodeURIComponent(e)}`, {
                headers: {
                    Accept: `application/json`
                }
            }),
            n = await t.json();
        if (!t.ok || !n.tasks) throw Error(String(t.status));
        Pt(n.tasks)
    }, Dr = async () => {
        let e = await M(`/api/users.php`, {
                headers: {
                    Accept: `application/json`
                }
            }),
            t = await e.json();
        if (!e.ok || !t.users) throw Error(String(e.status));
        rr(t.users)
    }, Or = async () => {
        let e = await M(`/api/users.php`, {
                method: ir.id ? `PUT` : `POST`,
                headers: {
                    Accept: `application/json`,
                    "Content-Type": `application/json`
                },
                body: JSON.stringify(ir)
            }),
            t = await e.json().catch(() => ({}));
        if (!e.ok) {
            B(t.error === `DUPLICATE_EMAIL` ? `Ese email ya está registrado` : t.error === `LAST_ADMIN` ? `Debe permanecer al menos un Administrador activo` : e.status === 409 ? `El usuario cambió en otra sesión; vuelve a abrirlo` : `No se pudo guardar el usuario`);
            return
        }
        sr(!1), ar($e()), await Dr(), B(`Guardado`)
    }, kr = async () => {
        let e = await M(`/api/users.php`, {
                method: `PATCH`,
                headers: {
                    Accept: `application/json`,
                    "Content-Type": `application/json`
                },
                body: JSON.stringify({
                    action: `password`,
                    id: ir.id,
                    version: ir.version,
                    password: ur
                })
            }),
            t = await e.json().catch(() => ({}));
        if (!e.ok) {
            B(e.status === 409 ? `El usuario cambió en otra sesión; vuelve a abrirlo` : t.error || `No se pudo cambiar la contraseña`);
            return
        }
        lr(!1), sr(!1), dr(``), ar($e()), await Dr(), B(`Guardado`)
    };
    (0, h.useEffect)(() => {
        if (n === `settings` && e.roleCode === `ADMIN`) {
            Dr().catch(() => B(`No se pudo cargar el maestro de usuarios`));
            M(`/api/work-order-email.php?settings=1`, { headers: { Accept: `application/json` } }).then(response => response.ok ? response.json() : Promise.reject()).then(data => setWorkOrderMailCc(data.cc || ``)).catch(() => B(`No se pudo cargar la configuración de correo`))
        }
    }, [n, e.roleCode]);
    let Ar = async e => {
        let t = await M(`/api/tasks.php`, {
                method: e.version ? `PUT` : `POST`,
                headers: {
                    Accept: `application/json`,
                    "Content-Type": `application/json`
                },
                body: JSON.stringify(e)
            }),
            n = await t.json().catch(() => ({}));
        if (!t.ok || !n.task) throw Error(n.error || String(t.status));
        return Pt(e => e.some(e => e.id === n.task.id) ? e.map(e => e.id === n.task.id ? n.task : e) : [n.task, ...e]), n.task
    }, jr = async (e, t) => {
        try {
            await Ar({
                ...e,
                status: t
            })
        } catch (e) {
            B(e instanceof Error && e.message === `VERSION_CONFLICT` ? `La tarea cambió en otra sesión; vuelve a abrirla` : `No se pudo actualizar la tarea`)
        }
    }, Mr = async (e, t) => {
        let n = e.kind === `Oferta` ? `/api/offers.php` : e.kind === `Pedido` ? `/api/sales-orders.php` : `/api/delivery-notes.php`,
            r = e.kind === `Oferta` ? `offer` : e.kind === `Pedido` ? `order` : `deliveryNote`,
            i = {
                ...e,
                valued: e.kind === `Albarán` ? e.valued ?? mt : void 0,
                client: e.customerId ? e.client : y,
                lines: t.map((e, t) => ({
                    ...e,
                    position: t,
                    articleId: e.articleId ?? lt.find(t => t.code === e.code)?.id ?? null
                }))
            },
            a = await M(n, {
                method: e.dbId ? `PUT` : `POST`,
                headers: {
                    Accept: `application/json`,
                    "Content-Type": `application/json`
                },
                body: JSON.stringify(i)
            }),
            o = await a.json().catch(() => ({})),
            s = o[r];
        if (!a.ok || !s) throw Error(String(o.error || a.status));
        return s
    }, Nr = async (e = ``) => {
        let t = await M(`/api/clients.php?q=${encodeURIComponent(e)}`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!t.ok) throw Error(String(t.status));
        Sn((await t.json()).clients)
    }, Pr = async e => {
        if (!e) {
            zn([]);
            return
        }
        let t = await M(`/api/centers.php?customerId=${e}`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!t.ok) throw Error(String(t.status));
        zn((await t.json()).centers)
    }, Fr = async e => {
        if (!e) {
            Vn([]);
            return
        }
        let t = await M(`/api/centers.php?customerId=${e}`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!t.ok) throw Error(String(t.status));
        Vn((await t.json()).centers)
    }, Ir = async (e, t = 0) => {
        if (!e) {
            qn([]);
            return
        }
        let n = await M(`/api/assets.php?customerId=${e}${t?`&centerId=${t}`:``}`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!n.ok) throw Error(String(n.status));
        qn((await n.json()).assets)
    }, Lr = async (e, t = 0) => {
        if (!e || !t) {
            Yn([]);
            return
        }
        let n = await M(`/api/assets.php?customerId=${e}&centerId=${t}`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!n.ok) throw Error(String(n.status));
        Yn((await n.json()).assets)
    }, Rr = async (e = ``) => {
        let t = await M(`/api/articles.php?q=${encodeURIComponent(e)}`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!t.ok) throw Error(String(t.status));
        ut((await t.json()).articles.map(e => {
            let t = ke.find(t => t.code === e.code);
            return {
                ...e,
                inactive: !e.active,
                price: t?.price || 0,
                stock: t?.stock || 0,
                warehouse: t?.warehouse || `01`,
                freq: t?.freq || 0,
                last: t?.last || ``,
                discount: t?.discount || 0
            }
        }))
    }, zr = async () => {
        let e = await M(`/api/orders.php`, {
            headers: {
                Accept: `application/json`
            }
        });
        if (!e.ok) throw Error(String(e.status));
        let t = await e.json();
        t.orders.length && nn(t.orders)
    }, Br = async (e, t) => {
        let n = xn.find(t => t.name === e.client),
            r = Bn.find(t => t.name === e.center),
            i = e.assets.map(e => Jn.find(t => `${t.code} · ${t.name}` === e)?.id).filter(e => !!e),
            a = {
                ...e,
                status: t,
                customerId: n?.id || 0,
                centerId: r?.id || 0,
                assetIds: i,
                materials: e.materials.map((e, t) => ({
                    ...e,
                    articleId: e.articleId ?? lt.find(t => t.code === e.code)?.id ?? null,
                    position: t
                }))
            },
            o = await M(`/api/orders.php`, {
                method: e.dbId ? `PUT` : `POST`,
                headers: {
                    Accept: `application/json`,
                    "Content-Type": `application/json`
                },
                body: JSON.stringify(a)
            }),
            s = await o.json().catch(() => ({}));
        if (!o.ok || !s.order) throw Error(s.error || String(o.status));
        return s.order
    }, loadWorkOrderMail = async (order = I, openDialog = !1) => {
        let response = await M(`/api/work-order-email.php?orderId=${order.dbId || order.id}`, { headers: { Accept: `application/json` } }), data = await response.json().catch(() => ({}));
        if (!response.ok) throw Error(data.error || String(response.status));
        setWorkOrderMail({ recipient: data.recipient || ``, cc: data.cc || ``, history: data.history || [], sending: !1 });
        if (openDialog) N(`work-order-email`)
    }, sendWorkOrderMail = async () => {
        setWorkOrderMail(value => ({ ...value, sending: !0 }));
        let response = await M(`/api/work-order-email.php`, { method: `POST`, headers: { Accept: `application/json`, "Content-Type": `application/json` }, body: JSON.stringify({ orderId: I.dbId || I.id, to: workOrderMail.recipient }) }), data = await response.json().catch(() => ({}));
        setWorkOrderMail(value => ({ ...value, history: data.history || value.history, sending: !1 }));
        if (!response.ok || data.result !== `SENT`) { B(`No se pudo enviar la Orden de Trabajo`); return }
        N(null), B(`Orden de Trabajo enviada`)
    }, saveWorkOrderMailCc = async () => {
        let response = await M(`/api/work-order-email.php`, { method: `PUT`, headers: { Accept: `application/json`, "Content-Type": `application/json` }, body: JSON.stringify({ cc: workOrderMailCc }) });
        if (!response.ok) { B(`No se pudo guardar la copia de Órdenes de Trabajo`); return }
        B(`Guardado`)
    };
    (0, h.useEffect)(() => {
        Nr().catch(() => B(`No se pudo cargar el maestro de clientes`)), Rr().catch(() => B(`No se pudo cargar el maestro de artículos`)), zr().catch(() => B(`No se pudieron cargar las órdenes`)), Cr().catch(() => B(`No se pudieron cargar las ofertas`)), wr().catch(() => B(`No se pudieron cargar los pedidos`)), Tr().catch(() => B(`No se pudieron cargar los albaranes`)), Er().catch(() => B(`No se pudieron cargar las tareas`))
    }, []), (0, h.useEffect)(() => {
        let e = setTimeout(() => Nr(Cn).catch(() => B(`No se pudo buscar clientes`)), 250);
        return () => clearTimeout(e)
    }, [Cn]), (0, h.useEffect)(() => {
        if (An !== `existing`) return;
        let e = setTimeout(async () => {
            try {
                let e = await M(`/api/clients.php?q=${encodeURIComponent(Mn)}`, {
                    headers: {
                        Accept: `application/json`
                    }
                });
                if (!e.ok) throw Error(String(e.status));
                let t = await e.json();
                Fn(t.clients), Ln(e => t.clients.some(t => t.id === e) ? e : 0)
            } catch {
                B(`No se pudieron buscar clientes existentes`)
            }
        }, 250);
        return () => clearTimeout(e)
    }, [An, Mn]), (0, h.useEffect)(() => {
        Fr(xn.find(e => e.name === I.client)?.id || 0).catch(() => B(`No se pudieron cargar los centros`))
    }, [I.client, xn]), (0, h.useEffect)(() => {
        let e = Bn.find(e => e.name === I.center);
        Lr(xn.find(e => e.name === I.client)?.id || 0, e?.id || 0).catch(() => B(`No se pudieron cargar los activos`))
    }, [I.client, I.center, Bn]), (0, h.useEffect)(() => {
        L && (Pr(L.id).catch(() => B(`No se pudieron cargar los centros`)), Ir(L.id).catch(() => B(`No se pudieron cargar los activos`)))
    }, [L?.id]), (0, h.useEffect)(() => {
        et === `task` && Rt(Ft || {
            id: Date.now(),
            title: ``,
            owner: `Iván García`,
            date: `2026-09-09`,
            link: u.number || ``,
            comment: ``,
            status: `Pendiente`,
            result: ``
        })
    }, [et, Ft, u.number]), (0, h.useEffect)(() => {
        if (ln !== 4) {
            yr.current = !1;
            return
        }
        if (yr.current || !vr.current) return;
        let e = vr.current.getContext(`2d`);
        if (e?.clearRect(0, 0, vr.current.width, vr.current.height), !I.signatureData) return;
        let t = new Image;
        t.onload = () => {
            e && vr.current && e.drawImage(t, 0, 0)
        }, t.src = I.signatureData
    }, [ln, I.id, I.signatureData]);
    (0, h.useEffect)(() => {
        if (n === `order-editor` && I.status === `Finalizada` && (I.dbId || I.id)) loadWorkOrderMail(I).catch(() => B(`No se pudo cargar el histórico de envíos`))
    }, [n, I.dbId, I.status]);
    let Vr = (0, h.useMemo)(() => calculateCommercialEconomics(_, {
            globalDiscountMode: u.globalDiscountMode || `PERCENT`,
            globalDiscountValue: u.globalDiscountValue || 0,
            expenseMode: u.expenseMode || `PERCENT`,
            expenseValue: u.expenseValue || 0
        }), [_, u.globalDiscountMode, u.globalDiscountValue, u.expenseMode, u.expenseValue]),
        Hr = e => {
            r(e), Ue(!1)
        },
        resetClientFile = () => {
            Tn(null), $n(0), Dn(Fe()), kn(!1), jn(null), wn(``)
        },
        openClientFiles = () => {
            resetClientFile(), Hr(`client`)
        },
        Ur = () => {
            let e = Math.max(0, ...tn.map(e => Number(e.number.split(`-`).at(-1))).filter(Number.isFinite));
            rn({
                ...Ge(`OT-2026-${String(e+1).padStart(5,`0`)}`),
                assets: [],
                asset: ``,
                serial: ``
            }), un(1), fn(``), mn(``), gn(``), r(`order-editor`)
        },
        Wr = e => e === `Oferta` ? [`Borrador`, `Enviada`, `Aceptada`, `Rechazada`] : e === `Pedido` ? [`Pendiente`, `Preparado`, `Entregado parcialmente`, `Entregado`, `Cerrado`] : [`Abierto`, `Firmado`],
        Gr = async () => {
            let e = {
                ...u,
                lines: JSON.parse(JSON.stringify(_)),
                total: Vr.total
            };
            try {
                if (e.kind === `Oferta` || e.kind === `Pedido` || e.kind === `Albarán`) {
                    let t = await Mr(e, _);
                    d(t), v(t.lines || []), a(e => e.some(e => e.kind === t.kind && e.dbId === t.dbId) ? e.map(e => e.kind === t.kind && e.dbId === t.dbId ? t : e) : [t, ...e]), B(`Guardado`)
                }
            } catch (e) {
                B(e instanceof Error && e.message === `VERSION_CONFLICT` ? `El ${u.kind.toLowerCase()} cambió en otra sesión; vuelve a abrirlo` : `No se pudo guardar el documento`)
            }
        }, Kr = async () => {
            if (!u.dbId || !Yt.trim()) {
                B(`Indica el motivo de rectificación`);
                return
            }
            let e = {
                    ...u,
                    id: Date.now(),
                    dbId: void 0,
                    version: void 0,
                    number: ``,
                    series: `ALR`,
                    status: `Abierto`,
                    closedAt: void 0,
                    rectifiesId: u.dbId,
                    rectifiesNumber: u.number,
                    correctionReason: Yt.trim(),
                    globalDiscountMode: `PERCENT`,
                    globalDiscountValue: 0,
                    globalDiscountAmount: 0,
                    expenseMode: `PERCENT`,
                    expenseValue: 0,
                    expenseAmount: 0,
                    signatureUrl: void 0,
                    signerName: void 0,
                    signerTaxId: void 0,
                    signedAt: void 0,
                    sourceRefs: [{
                        type: `Albarán`,
                        number: u.number
                    }],
                    generatedRefs: []
                },
                t = _.map(e => ({
                    ...e,
                    id: Date.now() + e.id,
                    qty: e.note ? `0,00` : Ze(-A(e.qty)),
                    serials: e.serial ? Array.from({
                        length: Math.max(0, Math.abs(Math.trunc(A(e.qty))))
                    }, () => ``) : []
                }));
            try {
                let n = await Mr(e, t);
                a(e => [n, ...e]), d(n), v(n.lines || []), Bt(!1), ht(n.valued ?? !0), N(null), B(`Rectificativo ${n.number} creado`)
            } catch {
                B(`No se pudo crear el rectificativo`)
            }
        }, qr = async () => {
            if (!u.dbId || !Vt) {
                B(`Añada una firma válida antes de cerrar.`);
                return
            }
            if (!Ut) {
                B(`Debe marcar la conformidad antes de firmar.`);
                return
            }
            if (!u.client.trim() || !Gt.trim() || _.some(e => !e.description.trim())) {
                B(`Completa los datos obligatorios`);
                return
            }
            if (_.some(e => {
                    if (e.note || !e.serial) return !1;
                    let t = Math.abs(A(e.qty));
                    return !Number.isInteger(t) || (e.serials || []).length !== t || (e.serials || []).some(e => !e.trim())
                })) {
                B(`Falta introducir el número de serie de una o más unidades.`);
                return
            }
            let e = _r.current?.toDataURL(`image/png`) || ``,
                t;
            try {
                let n = await Mr({
                        ...u,
                        status: `Abierto`,
                        valued: mt
                    }, _),
                    r = await M(`/api/delivery-note-signature.php`, {
                        method: `POST`,
                        headers: {
                            Accept: `application/json`,
                            "Content-Type": `application/json`
                        },
                        body: JSON.stringify({
                            documentId: n.dbId,
                            version: n.version,
                            signerName: Gt,
                            signerTaxId: qt,
                            conformity: !0,
                            signatureData: e
                        })
                    }),
                    i = await r.json().catch(() => ({}));
                if (!r.ok || !i.deliveryNote || i.deliveryNote.status !== `Firmado`) throw Error(i.error || `TECHNICAL_ERROR`);
                t = i.deliveryNote, d(t), v(t.lines || _), a(e => e.map(e => e.kind === `Albarán` && e.dbId === t.dbId ? t : e)), Bt(!0), N(null), B(`Albarán firmado y cerrado`)
            } catch (e) {
                let t = e instanceof Error ? e.message : ``;
                B(t === `SERIAL_VALIDATION` ? `Falta introducir el número de serie de una o más unidades.` : t === `VERSION_CONFLICT` ? `El albarán fue modificado en otra sesión. Vuelva a abrirlo.` : t === `STORAGE_ERROR` ? `La firma no pudo guardarse. Inténtelo de nuevo.` : `No se pudo completar la firma. Inténtelo de nuevo o contacte con soporte.`);
                return
            }
            try {
                let e = await M(`/api/delivery-notes.php?id=${t.dbId}`, {
                        headers: {
                            Accept: `application/json`
                        }
                    }),
                    n = await e.json().catch(() => ({}));
                if (!e.ok || !n.deliveryNote) throw Error(`REFRESH_FAILED`);
                let r = n.deliveryNote;
                d(r), v(r.lines || []), a(e => e.map(e => e.kind === `Albarán` && e.dbId === r.dbId ? r : e))
            } catch {
                B(`El albarán se firmó correctamente, pero no se pudo actualizar la pantalla. Vuelva a abrirlo.`)
            }
        }, Jr = async e => {
            let t = await M(`/api/conversions.php?sourceId=${e}`, {
                    headers: {
                        Accept: `application/json`
                    }
                }),
                n = await t.json();
            if (!t.ok) throw Error(String(t.status));
            return n
        }, Yr = async () => {
            if (u.dbId) try {
                let e = await Jr(u.dbId),
                    t = _.map(t => ({
                        ...t,
                        converted: e.quantities?.[String(t.id)]?.converted || `0,00`,
                        conversionPending: e.quantities?.[String(t.id)]?.pending || t.qty
                    }));
                v(t), g(Object.fromEntries(t.filter(e => !e.note).map(e => [e.id, e.conversionPending || e.qty]))), N(`convert`)
            } catch {
                B(`No se pudo preparar la conversión`)
            }
        }, Xr = async (e, t) => {
            let n = e === `Oferta` ? `/api/offers.php` : e === `Pedido` ? `/api/sales-orders.php` : `/api/delivery-notes.php`,
                r = e === `Oferta` ? `offer` : e === `Pedido` ? `order` : `deliveryNote`,
                i = await M(`${n}?id=${t}`, {
                    headers: {
                        Accept: `application/json`
                    }
                }),
                a = await i.json();
            if (!i.ok || !a[r]) throw Error(String(i.status));
            let o = a[r],
                s = await Jr(t);
            return {
                ...o,
                sourceRefs: [...o.sourceRefs || [], ...s.sourceRefs || []],
                generatedRefs: [...o.generatedRefs || [], ...s.generatedRefs || []],
                lines: (o.lines || []).map(e => ({
                    ...e,
                    converted: s.quantities?.[String(e.id)]?.converted || `0,00`,
                    conversionPending: s.quantities?.[String(e.id)]?.pending || e.qty
                }))
            }
        }, Zr = async e => {
            try {
                let t = await M(`/api/conversions.php`, {
                        method: `POST`,
                        headers: {
                            Accept: `application/json`,
                            "Content-Type": `application/json`
                        },
                        body: JSON.stringify({
                            sourceId: u.dbId,
                            sourceVersion: u.version,
                            targetKind: e,
                            lines: _.filter(e => !e.note).map(e => ({
                                lineId: e.id,
                                quantity: m[e.id] ?? `0,00`
                            }))
                        })
                    }),
                    n = await t.json().catch(() => ({}));
                if (!t.ok || !n.sourceId || !n.targetId) throw Error(n.error || String(t.status));
                let [r, i] = await Promise.all([Xr(u.kind, n.sourceId), Xr(e, n.targetId)]);
                d(r), v(r.lines || []), a(e => [i, ...e.filter(e => !(e.kind === r.kind && e.dbId === r.dbId) && !(e.kind === i.kind && e.dbId === i.dbId)), r]), p({
                    source: r,
                    target: i
                }), N(`conversion-complete`)
            } catch (e) {
                B(e instanceof Error && e.message === `VERSION_CONFLICT` ? `El documento cambió en otra sesión; vuelve a abrirlo` : `No se pudo completar la conversión`)
            }
        }, Qr = async e => {
            let t = e === `Oferta` ? `OF` : e === `Pedido` ? `PD` : `AL`,
                n = Math.max(0, ...i.filter(t => t.kind === e).map(e => Number(e.number.split(`-`).at(-1)))),
                a = `${t}-2026-${String(n+1).padStart(5,`0`)}`,
                o = {
                    id: Date.now(),
                    kind: e,
                    number: a,
                    client: ``,
                    date: `2026-09-08`,
                    status: e === `Oferta` ? `Borrador` : e === `Pedido` ? `Pendiente` : `Abierto`,
                    series: t,
                    agent: `Iván García`,
                    total: 0,
                    globalDiscountMode: `PERCENT`,
                    globalDiscountValue: 0,
                    globalDiscountAmount: 0,
                    expenseMode: `PERCENT`,
                    expenseValue: 0,
                    expenseAmount: 0
                },
                s = o;
            if (e === `Oferta` || e === `Pedido` || e === `Albarán`) try {
                s = await Mr(o, [])
            } catch {
                B(`No se pudo crear el ${e}`);
                return
            }
            d(s), Te(``), v([]), Bt(!1), ht(s.valued ?? !0), Ht(!1), Wt(!1), r(`editor`), B(`${e} ${s.number} creada`)
        }, $r = e => {
            let t = ++xr.current;
            d(e), Te(e.client);
            let n = e.lines ? JSON.parse(JSON.stringify(e.lines)) : e.id < 10 ? qe() : [];
            v(Xe(e.kind, n)), Bt(e.status === `Firmado`), ht(e.valued ?? !0), Ht(!1), Wt(!1), Kt(e.signerName || `Marta Hernández`), Jt(e.signerTaxId || ``), r(`editor`), e.dbId && Xr(e.kind, e.dbId).then(e => {
                xr.current === t && (d(e), v(Xe(e.kind, e.lines || [])), ht(e.valued ?? !0))
            }).catch(() => {
                xr.current === t && B(`No se pudo actualizar la trazabilidad`)
            })
        }, ei = async e => {
            if (fr) return;
            let t = ++Sr.current;
            pr(!0);
            try {
                if (e.type === `Orden`) {
                    let t = tn.find(t => t.number === e.number);
                    if (!t) return;
                    rn(JSON.parse(JSON.stringify(t))), un(1), r(`order-editor`);
                    return
                }
                if (e.id && (e.type === `Albarán` || e.type === `Rectificativo`)) try {
                    let n = await Xr(`Albarán`, e.id);
                    if (Sr.current !== t) return;
                    $r(n);
                    return
                } catch {
                    B(`No se pudo abrir el documento relacionado`)
                }
                let n = i.find(t => t.number === e.number);
                n && Sr.current === t && $r(n)
            } finally {
                Sr.current === t && pr(!1)
            }
        }, ti = async e => {
            if (fr) return;
            let t = ++Sr.current;
            pr(!0);
            try {
                let n = e.id;
                if (!n && e.number) {
                    let t = await M(`/api/delivery-notes.php?q=${encodeURIComponent(e.number)}`, {
                            headers: {
                                Accept: `application/json`
                            }
                        }),
                        r = await t.json();
                    if (!t.ok || !r.deliveryNotes) throw Error(String(t.status));
                    let i = r.deliveryNotes.filter(t => t.kind === `Albarán` && t.series === `ALR` && t.number === e.number && !!t.dbId);
                    if (i.length !== 1) throw Error(`RECTIFICATIVE_NOT_UNIQUE`);
                    n = i[0].dbId
                }
                if (!n) throw Error(`RECTIFICATIVE_NOT_FOUND`);
                let r = await Xr(`Albarán`, n);
                if (Sr.current !== t) return;
                hr(r), N(`rectificative-preview`)
            } catch {
                Sr.current === t && B(`No se pudo consultar el rectificativo`)
            } finally {
                Sr.current === t && pr(!1)
            }
        }, ni = (e, t, n) => v(r => r.map(r => r.id === e ? {
            ...r,
            [t]: n
        } : r)), ri = (e, t) => v(n => {
            let r = n.findIndex(t => t.id === e),
                i = r + t;
            if (r < 0 || i < 0 || i >= n.length) return n;
            let a = [...n];
            return [a[r], a[i]] = [a[i], a[r]], a
        }), ii = e => {
            v(t => [...t, {
                id: Date.now(),
                articleId: e.id || null,
                code: e.code,
                description: e.description,
                qty: `1,00`,
                delivered: `0,00`,
                cost: Ze(e.cost),
                price: Ze(e.price),
                discount: Ze(rt === `Últimas ventas` ? e.discount : 0),
                igic: String(e.igic),
                serial: e.serial,
                serials: e.serial && u.kind === `Albarán` ? [``] : []
            }]), N(null), B(`${e.code} añadido`)
        }, ai = e => {
            e && (Mt(t => [...t, ...Array.from(e).map((e, t) => ({
                id: Date.now() + t,
                name: e.name,
                type: e.type || `Archivo`,
                size: e.size < 1024 ? `${e.size} B` : e.size < 1048576 ? `${(e.size/1024).toFixed(1)} KB` : `${(e.size/1048576).toFixed(1)} MB`,
                include: !1,
                url: URL.createObjectURL(e)
            }))]), B(`${e.length} adjunto(s) añadido(s)`))
        }, oi = lt.filter(e => e.active && (e.code + e.description).toLowerCase().includes(at.toLowerCase()) && (st === `Todas` || e.family === st)).sort((e, t) => rt === `Habituales` ? t.freq - e.freq : 0), si = Ee.length > 1 ? {
            Clientes: xn.filter(e => (e.code + e.name + e.nif).toLowerCase().includes(Ee.toLowerCase())).map(e => e.name),
            Documentos: i.filter(e => (e.number + e.client + e.date).toLowerCase().includes(Ee.toLowerCase())).slice(0, 5),
            Artículos: lt.filter(e => (e.code + e.description).toLowerCase().includes(Ee.toLowerCase())).slice(0, 5)
        } : null;
    return (0, k.jsxs)(`div`, {
        className: `shell poc2`,
        children: [(0, k.jsxs)(`aside`, {
            className: Ne ? `side open` : `side`,
            children: [(0, k.jsxs)(`div`, {
                className: `brand`,
                children: [(0, k.jsx)(`b`, {
                    children: `m`
                }), (0, k.jsxs)(`span`, {
                    children: [`Microten`, (0, k.jsx)(`small`, {
                        children: `Operaciones`
                    })]
                }), (0, k.jsx)(`button`, {
                    onClick: () => Ue(!1),
                    children: (0, k.jsx)(we, {})
                })]
            }), (0, k.jsxs)(`nav`, {
                children: [(0, k.jsxs)(`button`, {
                    className: n === `home` ? `on` : ``,
                    onClick: () => Hr(`home`),
                    children: [(0, k.jsx)(b, {}), `Panel`]
                }), (0, k.jsxs)(`button`, {
                    className: n === `docs` ? `on` : ``,
                    onClick: () => Hr(`docs`),
                    children: [(0, k.jsx)(se, {}), `Documentos`]
                }), (0, k.jsxs)(`div`, {
                    className: `subnav`,
                    children: [(0, k.jsx)(`button`, {
                        onClick: () => {
                            s(`Oferta`), Hr(`docs`)
                        },
                        children: `Ofertas`
                    }), (0, k.jsx)(`button`, {
                        onClick: () => {
                            s(`Pedido`), Hr(`docs`)
                        },
                        children: `Pedidos`
                    }), (0, k.jsx)(`button`, {
                        onClick: () => {
                            s(`Albarán`), Hr(`docs`)
                        },
                        children: `Albaranes`
                    })]
                }), (0, k.jsxs)(`button`, {
                    className: n === `orders` || n === `order-editor` || n === `client` || n === `backup-monitor` ? `on` : ``,
                    onClick: () => Hr(`orders`),
                    children: [(0, k.jsx)(T, {}), `SAT`]
                }), (0, k.jsxs)(`div`, {
                    className: `subnav`,
                    children: [(0, k.jsxs)(`button`, {
                        className: n === `orders` || n === `order-editor` ? `on` : ``,
                        onClick: () => Hr(`orders`),
                        children: [(0, k.jsx)(Ce, {}), `Órdenes`]
                    }), (0, k.jsxs)(`button`, {
                        className: n === `client` ? `on` : ``,
                        onClick: openClientFiles,
                        children: [(0, k.jsx)(Se, {}), `Expedientes`]
                    }), e.roleCode === `ADMIN` && (0, k.jsxs)(`button`, {
                        className: n === `backup-monitor` ? `on` : ``,
                        onClick: () => Hr(`backup-monitor`),
                        children: [(0, k.jsx)(b, {}), `Backup Monitor`]
                    })]
                }), (0, k.jsxs)(`button`, {
                    className: n === `tasks` ? `on` : ``,
                    onClick: () => Hr(`tasks`),
                    children: [(0, k.jsx)(re, {}), `Tareas `, (0, k.jsx)(`em`, {
                        children: Nt.filter(e => e.status !== `Completada` && e.status !== `Cancelada`).length
                    })]
                }), (0, k.jsxs)(`button`, {
                    onClick: () => Hr(`articles`),
                    className: n === `articles` ? `on` : ``,
                    children: [(0, k.jsx)(E, {}), `Maestros`]
                }), (0, k.jsx)(`div`, {
                    className: `subnav`,
                    children: (0, k.jsxs)(`button`, {
                        className: n === `articles` ? `on` : ``,
                        onClick: () => Hr(`articles`),
                        children: [(0, k.jsx)(w, {}), `Artículos`]
                    })
                })]
            }), (0, k.jsxs)(`div`, {
                className: `sidefoot`,
                children: [(0, k.jsxs)(`div`, {
                    className: `sync`,
                    children: [(0, k.jsx)(`i`, {}), (0, k.jsxs)(`span`, {
                        children: [(0, k.jsx)(`b`, {
                            children: `Modo simulación`
                        }), (0, k.jsx)(`small`, {
                            children: `Sin conexión al sistema central`
                        })]
                    })]
                }), F && (0, k.jsxs)(`button`, {
                    className: n === `settings` ? `on` : ``,
                    onClick: () => Hr(`settings`),
                    children: [(0, k.jsx)(ge, {}), `Configuración`]
                })]
            })]
        }), (0, k.jsxs)(`main`, {
            children: [(0, k.jsxs)(`header`, {
                className: `top`,
                children: [(0, k.jsx)(`button`, {
                    className: `hamb`,
                    onClick: () => Ue(!0),
                    children: (0, k.jsx)(ue, {})
                }), (0, k.jsxs)(`div`, {
                    className: `globalbox`,
                    children: [(0, k.jsxs)(`label`, {
                        children: [(0, k.jsx)(he, {}), (0, k.jsx)(`input`, {
                            value: Ee,
                            onFocus: () => Me(!0),
                            onChange: e => {
                                De(e.target.value), Me(!0)
                            },
                            placeholder: `Buscar cliente, documento, artículo o fecha…`
                        })]
                    }), je && si && (0, k.jsxs)(`div`, {
                        className: `globalresults`,
                        children: [(0, k.jsx)(`button`, {
                            className: `closemini`,
                            onClick: () => Me(!1),
                            children: (0, k.jsx)(we, {})
                        }), Object.entries(si).map(([e, t]) => (0, k.jsxs)(`section`, {
                            children: [(0, k.jsx)(`b`, {
                                children: e
                            }), t.length ? t.map((t, n) => (0, k.jsx)(`button`, {
                                onClick: () => {
                                    e === `Documentos` ? $r(t) : Hr(e === `Artículos` ? `articles` : `client`), Me(!1)
                                },
                                children: typeof t == `string` ? t : t.number + ` · ` + t.client
                            }, n)) : (0, k.jsx)(`small`, {
                                children: `Sin resultados`
                            })]
                        }, e))]
                    })]
                }), (0, k.jsxs)(`div`, {
                    className: `usermenu`,
                    children: [(0, k.jsxs)(`button`, {
                        onClick: () => Qt(!Zt),
                        children: [(0, k.jsx)(`span`, {
                            className: `avatar`,
                            children: e.name.split(` `).map(e => e[0]).join(``).slice(0, 2).toUpperCase()
                        }), (0, k.jsx)(`b`, {
                            children: e.name
                        }), (0, k.jsx)(ne, {})]
                    }), Zt && (0, k.jsxs)(`div`, {
                        children: [(0, k.jsxs)(`button`, {
                            onClick: () => Hr(`settings`),
                            children: [(0, k.jsx)(ge, {}), `Preferencias`]
                        }), (0, k.jsxs)(`button`, {
                            onClick: () => B(`Perfil de ${e.name}`),
                            children: [(0, k.jsx)(Se, {}), `Mi perfil`]
                        }), (0, k.jsxs)(`button`, {
                            onClick: () => {
                                Qt(!1), N(`logout`)
                            },
                            children: [(0, k.jsx)(le, {}), `Cerrar sesión`]
                        })]
                    })]
                })]
            }), (0, k.jsx)(FeatureRouter, {
                route: n,
                user: e,
                renderers: {
                    dashboard: ci,
                    documents: li,
                    documentEditor: ui,
                    customerRecords: hi,
                    tasks: mi,
                    articles: pi,
                    workOrders: di,
                    workOrderEditor: fi,
                    settings: gi
                }
            })]
        }), et && _i(), tt && (0, k.jsxs)(`div`, {
            className: `toast`,
            children: [(0, k.jsx)(te, {}), tt]
        })]
    });

    function ci() {
        let e = i.filter(e => F || e.agent === `Iván García`),
            t = tn.filter(e => F || e.mainTech === `Iván García`),
            n = Nt.filter(e => F || e.owner === `Iván García`),
            a = [...e].sort((e, t) => t.date.localeCompare(e.date)).filter(e => c === `Todos` || e.kind === c);
        return (0, k.jsxs)(`div`, {
            className: `page`,
            children: [(0, k.jsx)(PageHeader, {
                eyebrow: new Intl.DateTimeFormat(`es-ES`, {
                    weekday: `long`,
                    day: `numeric`,
                    month: `long`
                }).format(new Date).toUpperCase(),
                title: F ? `Panel de empresa` : `Mi panel`,
                sub: F ? `Actividad global de documentos, órdenes y tareas.` : `Tu actividad, órdenes, tareas y documentos autorizados.`,
                actions: (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsxs)(`button`, {
                        className: `primary`,
                        onClick: () => Qr(`Oferta`),
                        children: [(0, k.jsx)(D, {}), `Nueva oferta`]
                    }), (0, k.jsxs)(`button`, {
                        onClick: () => Qr(`Pedido`),
                        children: [(0, k.jsx)(D, {}), `Nuevo pedido`]
                    }), (0, k.jsxs)(`button`, {
                        onClick: () => Qr(`Albarán`),
                        children: [(0, k.jsx)(D, {}), `Nuevo albarán`]
                    }), (0, k.jsxs)(`button`, {
                        onClick: () => {
                            It(null), N(`task`)
                        },
                        children: [(0, k.jsx)(D, {}), `Nueva tarea`]
                    }), (0, k.jsxs)(`button`, {
                        onClick: Ur,
                        children: [(0, k.jsx)(D, {}), `Nueva orden`]
                    })]
                })
            }), (0, k.jsx)(`section`, {
                className: `stats`,
                children: [
                    [`Ofertas abiertas`, i.filter(e => e.kind === `Oferta`).length, `offer`],
                    [`Pedidos pendientes`, i.filter(e => e.kind === `Pedido`).length, `order`],
                    [`Albaranes de hoy`, i.filter(e => e.kind === `Albarán`).length, `delivery`],
                    [`Tareas pendientes`, n.filter(e => e.status === `Pendiente`).length, `alert`],
                    [`Órdenes de trabajo`, t.length, `order`]
                ].map((e, t) => (0, k.jsxs)(`article`, {
                    children: [(0, k.jsx)(`span`, {
                        className: e[2],
                        children: t === 0 ? (0, k.jsx)(se, {}) : t === 1 ? (0, k.jsx)(E, {}) : t === 2 ? (0, k.jsx)(be, {}) : (0, k.jsx)(re, {})
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`small`, {
                            children: e[0]
                        }), (0, k.jsx)(`strong`, {
                            children: e[1]
                        }), (0, k.jsx)(`em`, {
                            children: `Datos de esta sesión`
                        })]
                    })]
                }, e[0]))
            }), (0, k.jsxs)(`div`, {
                className: `dashgrid`,
                children: [(0, k.jsx)(`div`, {
                    className: `dash-left`,
                    children: (0, k.jsx)(TodayPanel, {
                        Title: V,
                        tasks: n,
                        onOpenTask: e => {
                            It(e), N(`task`)
                        },
                        onNewTask: () => {
                            It(null), N(`task`)
                        },
                        NextIcon: S,
                        AddIcon: D
                    })
                }), (0, k.jsx)(RecentActivity, {
                    Title: V,
                    filter: c,
                    setFilter: l,
                    documents: a,
                    DocumentRow: xi,
                    orders: t,
                    tasks: n,
                    onOpenOrder: e => {
                        rn(JSON.parse(JSON.stringify(e))), un(1), r(`order-editor`)
                    },
                    onOpenTask: e => {
                        It(e), N(`task`)
                    },
                    NextIcon: S
                })]
            })]
        })
    }

    function li() {
        let e = _t,
            t = vt,
            n = yt,
            r = bt,
            a = xt,
            s = St,
            c = Ct,
            l = wt,
            u = Tt,
            d = Et,
            f = i.filter(t => (o === `Todos` || t.kind === o) && (t.client + t.number + t.series).toLowerCase().includes(e.toLowerCase()) && (n === `Todos` || t.status === n) && (a === `Todos` || t.agent === a) && (!c || t.date >= c) && (!u || t.date <= u));
        return (0, k.jsxs)(`div`, {
            className: `page`,
            children: [(0, k.jsx)(PageHeader, {
                eyebrow: `Acceso general`,
                title: o === `Todos` ? `Documentos` : o === `Oferta` ? `Ofertas` : o === `Pedido` ? `Pedidos` : `Albaranes`,
                sub: `${f.length} documentos encontrados`,
                actions: (0, k.jsxs)(`button`, {
                    className: `primary`,
                    onClick: () => Qr(o === `Todos` ? `Oferta` : o),
                    children: [(0, k.jsx)(D, {}), `Nuevo documento`]
                })
            }), (0, k.jsxs)(`section`, {
                className: `card filters2`,
                children: [(0, k.jsxs)(`label`, {
                    children: [`Cliente, serie o número`, (0, k.jsx)(`input`, {
                        value: e,
                        onChange: e => t(e.target.value),
                        placeholder: `Contiene…`
                    })]
                }), (0, k.jsxs)(`label`, {
                    children: [`Estado`, (0, k.jsxs)(`select`, {
                        value: n,
                        onChange: e => r(e.target.value),
                        children: [(0, k.jsx)(`option`, {
                            children: `Todos`
                        }), [`Borrador`, `Enviada`, `Aceptada`, `Pendiente`, `Preparado`, `Abierto`, `Firmado`].map(e => (0, k.jsx)(`option`, {
                            children: e
                        }, e))]
                    })]
                }), (0, k.jsxs)(`label`, {
                    children: [`Agente`, (0, k.jsxs)(`select`, {
                        value: a,
                        onChange: e => s(e.target.value),
                        children: [(0, k.jsx)(`option`, {
                            children: `Todos`
                        }), (0, k.jsx)(`option`, {
                            children: `Iván García`
                        }), (0, k.jsx)(`option`, {
                            children: `Laura Pérez`
                        })]
                    })]
                }), (0, k.jsxs)(`label`, {
                    children: [`Desde`, (0, k.jsx)(`input`, {
                        type: `date`,
                        value: c,
                        onChange: e => l(e.target.value)
                    })]
                }), (0, k.jsxs)(`label`, {
                    children: [`Hasta`, (0, k.jsx)(`input`, {
                        type: `date`,
                        value: u,
                        onChange: e => d(e.target.value)
                    })]
                })]
            }), (0, k.jsxs)(`section`, {
                className: `card doclist`,
                children: [(0, k.jsx)(V, {
                    title: `Resultados`
                }), f.map(e => (0, k.jsx)(xi, {
                    d: e
                }, e.id))]
            })]
        })
    }

    function ui() {
        let e = u.originOrder || tn.find(e => e.relatedDocs.includes(u.id))?.number,
            t = [...u.sourceRefs || []],
            n = u.generatedRefs || [],
            r = u.kind === `Albarán` && zt;
        return e && !t.some(t => t.number === e) && t.push({
            type: `Orden`,
            number: e
        }), (0, k.jsxs)(`div`, {
            className: `editor ${zt?`signed-document`:``}`,
            children: [(0, k.jsxs)(`div`, {
                className: `edithead compact`,
                children: [(0, k.jsx)(`button`, {
                    className: `back`,
                    onClick: () => Hr(`docs`),
                    children: (0, k.jsx)(ee, {})
                }), (0, k.jsxs)(`div`, {
                    children: [(0, k.jsxs)(`span`, {
                        children: [(0, k.jsx)(`b`, {
                            children: u.kind
                        }), (0, k.jsx)(`strong`, {
                            children: u.number
                        }), (0, k.jsx)(`i`, {
                            children: u.status
                        })]
                    }), (0, k.jsx)(`small`, {
                        children: `Pendiente de integrar en el sistema central`
                    })]
                }), (0, k.jsxs)(`div`, {
                    className: `actions`,
                    children: [(0, k.jsxs)(`button`, {
                        type: `button`,
                        onClick: () => u.kind === `Albarán` ? (setPrintDocument({
                            ...u,
                            sourceRefs: t
                        }), N(`print-delivery`)) : openCommercialPrintPreview({
                            ...u,
                            sourceRefs: t
                        }),
                        children: [(0, k.jsx)(pe, {}), `Imprimir / PDF`]
                    }), !zt && (0, k.jsx)(`button`, {
                        onClick: () => void Gr(),
                        children: `Guardar`
                    }), !zt && (0, k.jsx)(`button`, {
                        className: `primary`,
                        onClick: () => u.kind === `Albarán` ? N(`sign`) : void Yr(),
                        children: u.kind === `Albarán` ? (0, k.jsxs)(k.Fragment, {
                            children: [(0, k.jsx)(ve, {}), `Firmar y cerrar`]
                        }) : (0, k.jsxs)(k.Fragment, {
                            children: [`Convertir`, (0, k.jsx)(ne, {})]
                        })
                    })]
                })]
            }), (0, k.jsxs)(`section`, {
                className: `card docheader`,
                children: [(0, k.jsxs)(`div`, {
                    className: `identity`,
                    children: [(0, k.jsx)(`span`, {
                        className: `initials`,
                        children: u.client ? `HC` : `NC`
                    }), (0, k.jsxs)(`label`, {
                        className: `lookup`,
                        children: [`Cliente / Razón social`, (0, k.jsx)(`input`, {
                            disabled: r,
                            value: y,
                            onChange: e => {
                                let t = e.target.value;
                                Te(t), t !== u.client && u.customerId && d({
                                    ...u,
                                    customerId: null,
                                    client: ``,
                                    clientCode: ``,
                                    nif: ``,
                                    contact: ``,
                                    phone: ``,
                                    address: ``,
                                    postalCode: ``,
                                    city: ``,
                                    province: ``,
                                    email: ``
                                })
                            },
                            placeholder: `Buscar cliente por contiene…`
                        }), !r && y && y !== u.client && (0, k.jsx)(`div`, {
                            children: xn.filter(e => (e.code + e.name).toLowerCase().includes(y.toLowerCase())).map(e => (0, k.jsxs)(`button`, {
                                type: `button`,
                                onClick: () => {
                                    Te(e.name), d({
                                        ...u,
                                        customerId: e.id,
                                        clientCode: e.code,
                                        client: e.name,
                                        nif: e.nif,
                                        contact: e.contact,
                                        phone: e.phone,
                                        address: e.address,
                                        postalCode: e.postalCode,
                                        city: e.city,
                                        province: e.province,
                                        email: e.email
                                    })
                                },
                                children: [e.code, ` · `, e.name]
                            }, e.code))
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`NIF/CIF`, (0, k.jsx)(`input`, {
                            disabled: r,
                            value: u.nif || ``,
                            onChange: e => d({
                                ...u,
                                nif: e.target.value
                            })
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Contacto`, (0, k.jsx)(`input`, {
                            disabled: r,
                            value: u.contact || ``,
                            onChange: e => d({
                                ...u,
                                contact: e.target.value
                            })
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Teléfono`, (0, k.jsx)(`input`, {
                            disabled: r,
                            value: u.phone || ``,
                            onChange: e => d({
                                ...u,
                                phone: e.target.value
                            })
                        })]
                    }), (0, k.jsxs)(`label`, {
                        className: `address`,
                        children: [`Dirección`, (0, k.jsx)(`input`, {
                            disabled: r,
                            value: u.address || ``,
                            onChange: e => d({
                                ...u,
                                address: e.target.value
                            })
                        })]
                    })]
                }), (0, k.jsxs)(`div`, {
                    className: `documentdata`,
                    children: [(0, k.jsxs)(`label`, {
                        children: [`Fecha`, (0, k.jsx)(`input`, {
                            disabled: r,
                            type: `date`,
                            value: u.date,
                            onChange: e => d({
                                ...u,
                                date: e.target.value
                            })
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Almacén`, (0, k.jsxs)(`select`, {
                            disabled: r,
                            value: u.warehouse || `01`,
                            onChange: e => d({
                                ...u,
                                warehouse: e.target.value
                            }),
                            children: [(0, k.jsx)(`option`, {
                                value: `01`,
                                children: `01 · Principal`
                            }), (0, k.jsx)(`option`, {
                                value: `02`,
                                children: `02 · Sur`
                            })]
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Serie`, (0, k.jsxs)(`span`, {
                            className: `fixedvalue`,
                            children: [u.series, ` · General`]
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Número`, (0, k.jsx)(`span`, {
                            className: `fixedvalue`,
                            children: u.number
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Estado`, (0, k.jsx)(`select`, {
                            disabled: u.kind === `Albarán`,
                            value: u.status,
                            onChange: e => d({
                                ...u,
                                status: e.target.value
                            }),
                            children: Wr(u.kind).map(e => (0, k.jsx)(`option`, {
                                children: e
                            }, e))
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Agente / Vendedor`, (0, k.jsxs)(`select`, {
                            disabled: r,
                            value: u.agent,
                            onChange: e => d({
                                ...u,
                                agent: e.target.value
                            }),
                            children: [(0, k.jsx)(`option`, {
                                children: `Iván García`
                            }), (0, k.jsx)(`option`, {
                                children: `Laura Pérez`
                            })]
                        })]
                    }), u.kind === `Albarán` && (0, k.jsxs)(`label`, {
                        children: [`Visualización`, (0, k.jsxs)(`select`, {
                            value: mt ? `Valorado` : `No valorado`,
                            disabled: zt,
                            onChange: e => {
                                let t = e.target.value === `Valorado`;
                                ht(t), d({
                                    ...u,
                                    valued: t
                                })
                            },
                            children: [(0, k.jsx)(`option`, {
                                children: `Valorado`
                            }), (0, k.jsx)(`option`, {
                                children: `No valorado`
                            })]
                        })]
                    })]
                }), (t.length > 0 || n.length > 0) && (0, k.jsxs)(`div`, {
                    className: `document-trace`,
                    children: [t.length > 0 && (0, k.jsxs)(`span`, {
                        children: [(0, k.jsx)(`b`, {
                            children: u.kind === `Albarán` && u.rectifiesId ? `Rectifica a:` : `Procede de:`
                        }), t.map(e => (0, k.jsxs)(`button`, {
                            disabled: fr,
                            onClick: () => ei(e),
                            children: [e.type, ` `, e.number]
                        }, `${e.type}-${e.number}`))]
                    }), n.length > 0 && (0, k.jsxs)(`span`, {
                        children: [(0, k.jsx)(`b`, {
                            children: u.kind === `Albarán` && n.some(e => e.type === `Rectificativo`) ? `Rectificado por:` : `Generó:`
                        }), n.map(e => (0, k.jsxs)(`button`, {
                            disabled: fr,
                            onClick: () => e.type === `Rectificativo` ? ti(e) : ei(e),
                            children: [e.type, ` `, e.number]
                        }, `${e.type}-${e.number}`))]
                    }), fr && (0, k.jsx)(`small`, {
                        children: `Cargando…`
                    })]
                })]
            }), (0, k.jsxs)(`section`, {
                className: `card lines`,
                children: [(0, k.jsxs)(`div`, {
                    className: `lineshead`,
                    children: [(0, k.jsx)(V, {
                        title: `Líneas del documento`,
                        sub: `Edición directa y cálculos automáticos.`
                    }), !r && (0, k.jsxs)(`div`, {
                        children: [(0, k.jsxs)(`button`, {
                            onClick: () => {
                                it(`Resultados`), N(`article`)
                            },
                            children: [(0, k.jsx)(he, {}), `Buscar artículo`]
                        }), (0, k.jsxs)(`button`, {
                            onClick: () => v(e => [...e, ...Ke()]),
                            children: [(0, k.jsx)(D, {}), `Línea libre`]
                        })]
                    })]
                }), (0, k.jsxs)(`div`, {
                    className: `table ${F?``:`nocost`} ${mt?``:`unvalued`}`,
                    children: [(0, k.jsxs)(`div`, {
                        className: `th`,
                        children: [(0, k.jsx)(`span`, {}), (0, k.jsx)(`span`, {
                            children: `Artículo / descripción`
                        }), (0, k.jsx)(`span`, {
                            children: `Cantidad`
                        }), (0, k.jsx)(`span`, {
                            className: `cost`,
                            children: `Coste`
                        }), (0, k.jsx)(`span`, {
                            children: `Precio`
                        }), (0, k.jsx)(`span`, {
                            children: `Dto.`
                        }), (0, k.jsx)(`span`, {
                            children: `Neto`
                        }), (0, k.jsx)(`span`, {
                            className: `cost`,
                            children: `Margen`
                        }), (0, k.jsx)(`span`, {
                            children: `IGIC`
                        }), (0, k.jsx)(`span`, {
                            children: `Total`
                        }), (0, k.jsx)(`span`, {})]
                    }), _.map((e, t) => (0, k.jsxs)(`div`, {
                        className: e.note ? `tr note` : `tr`,
                        draggable: !r,
                        onDragStart: () => en(e.id),
                        onDragOver: e => e.preventDefault(),
                        onDrop: () => {
                            if ($t === null || $t === e.id) return;
                            let t = _.findIndex(e => e.id === $t),
                                n = _.findIndex(t => t.id === e.id),
                                r = [..._],
                                [i] = r.splice(t, 1);
                            r.splice(n, 0, i), v(r), en(null)
                        },
                        children: [(0, k.jsx)(ce, {}), (0, k.jsxs)(`div`, {
                            className: `desc`,
                            children: [(0, k.jsx)(`b`, {
                                children: e.note ? e.heading ? `CABECERA DE GRUPO` : `TEXTO` : e.code || `LÍNEA LIBRE`
                            }), (0, k.jsx)(`input`, {
                                disabled: r,
                                value: e.description,
                                onChange: t => ni(e.id, `description`, t.target.value),
                                placeholder: `Descripción obligatoria…`
                            }), e.serial && u.kind === `Albarán` && (0, k.jsx)(`div`, {
                                className: `line-serials`,
                                children: (e.serials || []).map((t, n) => (0, k.jsx)(`input`, {
                                    disabled: r,
                                    value: t,
                                    placeholder: `Serie ${n+1}`,
                                    onChange: t => {
                                        let r = [...e.serials || []];
                                        r[n] = t.target.value, ni(e.id, `serials`, r)
                                    }
                                }, n))
                            })]
                        }), !e.note && (0, k.jsxs)(`div`, {
                            className: `line-economics`,
                            children: [(0, k.jsxs)(`label`, {
                                className: `quantity-cell line-field`,
                                children: [(0, k.jsx)(`span`, {
                                    children: `Cantidad`
                                }), (0, k.jsx)(`input`, {
                                    disabled: r,
                                    "aria-label": `Cantidad pedida`,
                                    inputMode: `decimal`,
                                    onFocus: Ye,
                                    value: e.qty,
                                    onChange: t => {
                                        let n = Je(t.target.value);
                                        if (ni(e.id, `qty`, n), u.kind === `Albarán` && e.serial) {
                                            let t = Math.max(0, Math.floor(A(n)));
                                            v(r => r.map(r => r.id === e.id ? {
                                                ...r,
                                                qty: n,
                                                serials: Array.from({
                                                    length: t
                                                }, (e, t) => r.serials?.[t] || ``)
                                            } : r))
                                        }
                                    }
                                }), u.kind === `Pedido` && !e.note && (0, k.jsxs)(k.Fragment, {
                                    children: [(0, k.jsx)(`small`, {
                                        children: `Entregada`
                                    }), (0, k.jsx)(`input`, {
                                        "aria-label": `Cantidad entregada`,
                                        inputMode: `decimal`,
                                        onFocus: Ye,
                                        value: e.delivered,
                                        onChange: t => ni(e.id, `delivered`, Je(t.target.value))
                                    }), (0, k.jsxs)(`small`, {
                                        children: [`Pendiente `, Ze(A(e.qty) - A(e.delivered))]
                                    })]
                                })]
                            }), (0, k.jsxs)(`label`, {
                                className: `line-field cost`,
                                children: [(0, k.jsx)(`span`, {
                                    children: `Coste`
                                }), (0, k.jsx)(`input`, {
                                    disabled: r,
                                    inputMode: `decimal`,
                                    onFocus: Ye,
                                    value: e.cost,
                                    onChange: t => ni(e.id, `cost`, Je(t.target.value))
                                })]
                            }), (0, k.jsxs)(`label`, {
                                className: `line-field`,
                                children: [(0, k.jsx)(`span`, {
                                    children: `Precio`
                                }), (0, k.jsx)(`input`, {
                                    disabled: r,
                                    inputMode: `decimal`,
                                    onFocus: Ye,
                                    value: e.price,
                                    onChange: t => ni(e.id, `price`, Je(t.target.value))
                                })]
                            }), (0, k.jsxs)(`label`, {
                                className: `line-field`,
                                children: [(0, k.jsx)(`span`, {
                                    children: `Descuento`
                                }), (0, k.jsx)(`input`, {
                                    disabled: r,
                                    inputMode: `decimal`,
                                    onFocus: Ye,
                                    value: e.discount,
                                    onChange: t => ni(e.id, `discount`, Je(t.target.value))
                                })]
                            }), (0, k.jsxs)(`div`, {
                                className: `line-value net`,
                                children: [(0, k.jsx)(`span`, {
                                    children: `Neto`
                                }), (0, k.jsx)(`strong`, {
                                    children: j(A(e.price) * (1 - A(e.discount) / 100))
                                })]
                            }), (0, k.jsxs)(`div`, {
                                className: `line-value cost margin-value`,
                                children: [(0, k.jsx)(`span`, {
                                    children: `Margen`
                                }), (0, k.jsxs)(`i`, {
                                    className: `margin`,
                                    children: [Ze(A(e.price) ? (A(e.price) * (1 - A(e.discount) / 100) - A(e.cost)) / (A(e.price) * (1 - A(e.discount) / 100)) * 100 : 0), ` `, `%`]
                                })]
                            }), (0, k.jsxs)(`label`, {
                                className: `line-field igic-field`,
                                children: [(0, k.jsx)(`span`, {
                                    children: `IGIC`
                                }), (0, k.jsxs)(`select`, {
                                    disabled: r,
                                    value: e.igic,
                                    onChange: t => ni(e.id, `igic`, t.target.value),
                                    children: [(0, k.jsx)(`option`, {
                                        value: `0`,
                                        children: `Exento`
                                    }), (0, k.jsx)(`option`, {
                                        value: `3`,
                                        children: `3 %`
                                    }), (0, k.jsx)(`option`, {
                                        value: `7`,
                                        children: `7 %`
                                    })]
                                })]
                            }), (0, k.jsxs)(`div`, {
                                className: `line-value total-value`,
                                children: [(0, k.jsx)(`span`, {
                                    children: `Total`
                                }), (0, k.jsx)(`strong`, {
                                    children: j(A(e.qty) * A(e.price) * (1 - A(e.discount) / 100) * (1 + A(e.igic) / 100))
                                })]
                            })]
                        }), !r && (0, k.jsxs)(`div`, {
                            className: `rowactions`,
                            children: [(0, k.jsx)(`button`, {
                                title: `Mover arriba`,
                                onClick: () => ri(e.id, -1),
                                disabled: !t,
                                children: (0, k.jsx)(C, {})
                            }), (0, k.jsx)(`button`, {
                                title: `Mover abajo`,
                                onClick: () => ri(e.id, 1),
                                disabled: t === _.length - 1,
                                children: (0, k.jsx)(x, {})
                            }), (0, k.jsx)(`button`, {
                                title: `Duplicar`,
                                onClick: () => v([..._, {
                                    ...e,
                                    id: Date.now()
                                }]),
                                children: (0, k.jsx)(ie, {})
                            }), (0, k.jsx)(`button`, {
                                title: `Eliminar`,
                                onClick: () => v(_.filter(t => t.id !== e.id)),
                                children: (0, k.jsx)(ye, {})
                            })]
                        })]
                    }, e.id))]
                }), !r && (0, k.jsxs)(`div`, {
                    className: `textactions`,
                    children: [(0, k.jsxs)(`button`, {
                        onClick: () => v(e => [...e, {
                            ...Ke()[0],
                            qty: `0,00`,
                            note: !0
                        }]),
                        children: [(0, k.jsx)(D, {}), `Texto normal`]
                    }), (0, k.jsxs)(`button`, {
                        onClick: () => v(e => [...e, {
                            ...Ke()[0],
                            qty: `0,00`,
                            note: !0,
                            heading: !0
                        }]),
                        children: [(0, k.jsx)(D, {}), `Cabecera de grupo`]
                    })]
                })]
            }), (0, k.jsxs)(`div`, {
                className: `bottom`,
                children: [(0, k.jsxs)(`section`, {
                    className: `card notes`,
                    children: [(0, k.jsxs)(`label`, {
                        children: [`Observaciones visibles para el cliente`, (0, k.jsx)(`textarea`, {
                            disabled: r,
                            value: u.notes || ``,
                            onChange: e => d({
                                ...u,
                                notes: e.target.value
                            }),
                            placeholder: `Se mostrarán en el documento…`
                        })]
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsxs)(`b`, {
                            children: [(0, k.jsx)(_e, {}), `Seguimiento interno`]
                        }), Nt.filter(e => e.link === u.number || e.link === u.client).map(e => (0, k.jsxs)(`p`, {
                            children: [(0, k.jsxs)(`strong`, {
                                children: [e.owner, ` · `, e.date, ` · `, e.status]
                            }), e.comment || e.title]
                        }, e.id)), !r && (0, k.jsx)(`button`, {
                            onClick: () => {
                                It(null), N(`task`)
                            },
                            children: `+ Añadir seguimiento`
                        })]
                    }), (0, k.jsxs)(`div`, {
                        className: `attachments`,
                        children: [(0, k.jsx)(`input`, {
                            disabled: r,
                            ref: gr,
                            type: `file`,
                            multiple: !0,
                            onChange: e => ai(e.target.files)
                        }), !r && (0, k.jsxs)(`button`, {
                            onClick: () => gr.current?.click(),
                            children: [(0, k.jsx)(xe, {}), `Seleccionar archivos`]
                        }), jt.map(e => (0, k.jsxs)(`div`, {
                            children: [(0, k.jsx)(de, {}), (0, k.jsxs)(`a`, {
                                href: e.url,
                                download: e.name,
                                children: [e.name, (0, k.jsxs)(`small`, {
                                    children: [e.type, ` · `, e.size]
                                })]
                            }), (0, k.jsxs)(`label`, {
                                children: [(0, k.jsx)(`input`, {
                                    disabled: r,
                                    type: `checkbox`,
                                    checked: e.include,
                                    onChange: t => Mt(n => n.map(n => n.id === e.id ? {
                                        ...n,
                                        include: t.target.checked
                                    } : n))
                                }), e.include ? `Incluir con documento` : `Interno`]
                            }), (0, k.jsx)(`a`, {
                                href: e.url,
                                download: e.name,
                                children: (0, k.jsx)(ae, {})
                            }), !r && (0, k.jsx)(`button`, {
                                onClick: () => {
                                    URL.revokeObjectURL(e.url), Mt(t => t.filter(t => t.id !== e.id))
                                },
                                children: (0, k.jsx)(ye, {})
                            })]
                        }, e.id))]
                    })]
                }), (u.kind !== `Albarán` || mt) && (0, k.jsxs)(`section`, {
                    className: `card totals`,
                    children: [(0, k.jsxs)(`p`, {
                        children: [(0, k.jsx)(`span`, {
                            children: `Subtotal`
                        }), (0, k.jsx)(`b`, {
                            children: j(Vr.subtotal - Vr.lineDiscount)
                        })]
                    }), !u.rectifiesId && (0, k.jsx)(`button`, {
                        type: `button`,
                        className: `economic-adjustment`,
                        onClick: () => {
                            setEcoDraft({
                                globalDiscountMode: u.globalDiscountMode || `PERCENT`,
                                globalDiscountValue: String(u.globalDiscountValue || 0),
                                expenseMode: u.expenseMode || `PERCENT`,
                                expenseValue: String(u.expenseValue || 0)
                            }), N(`economics`)
                        },
                        children: [(0, k.jsx)(`span`, {
                            children: `Descuento`
                        }), (0, k.jsx)(`b`, {
                            children: j(Vr.globalDiscount)
                        })]
                    }), !u.rectifiesId && (0, k.jsx)(`button`, {
                        type: `button`,
                        className: `economic-adjustment`,
                        onClick: () => {
                            setEcoDraft({
                                globalDiscountMode: u.globalDiscountMode || `PERCENT`,
                                globalDiscountValue: String(u.globalDiscountValue || 0),
                                expenseMode: u.expenseMode || `PERCENT`,
                                expenseValue: String(u.expenseValue || 0)
                            }), N(`economics`)
                        },
                        children: [(0, k.jsx)(`span`, {
                            children: `Gastos`
                        }), (0, k.jsx)(`b`, {
                            children: j(Vr.expenses)
                        })]
                    }), (0, k.jsxs)(`p`, {
                        children: [(0, k.jsx)(`span`, {
                            children: `Base imponible`
                        }), (0, k.jsx)(`b`, {
                            children: j(Vr.base)
                        })]
                    }), (0, k.jsxs)(`p`, {
                        children: [(0, k.jsx)(`span`, {
                            children: `IGIC`
                        }), (0, k.jsx)(`b`, {
                            children: j(Vr.tax)
                        })]
                    }), F && (0, k.jsxs)(k.Fragment, {
                        children: [(0, k.jsxs)(`p`, {
                            className: `costline`,
                            children: [(0, k.jsx)(`span`, {
                                children: `Coste total estimado`
                            }), (0, k.jsx)(`b`, {
                                children: j(Vr.cost)
                            })]
                        }), (0, k.jsxs)(`p`, {
                            className: `profit`,
                            children: [(0, k.jsx)(`span`, {
                                children: `Beneficio estimado`
                            }), (0, k.jsx)(`b`, {
                                children: j(Vr.profit)
                            })]
                        }), (0, k.jsxs)(`p`, {
                            className: `profit`,
                            children: [(0, k.jsx)(`span`, {
                                children: `Margen estimado`
                            }), (0, k.jsxs)(`b`, {
                                children: [Ze(Vr.margin), ` %`]
                            })]
                        })]
                    }), (0, k.jsxs)(`p`, {
                        className: `grand`,
                        children: [(0, k.jsx)(`span`, {
                            children: `Total documento`
                        }), (0, k.jsx)(`strong`, {
                            children: j(Vr.total)
                        })]
                    })]
                })]
            }), zt && (0, k.jsxs)(`div`, {
                className: `locked`,
                children: [(0, k.jsx)(te, {}), (0, k.jsxs)(`span`, {
                    children: [(0, k.jsx)(`b`, {
                        children: `Albarán firmado y cerrado`
                    }), (0, k.jsx)(`small`, {
                        children: `Documento cerrado: contenido operativo en sólo lectura`
                    })]
                }), (0, k.jsxs)(`button`, {
                    onClick: () => N(`rectify`),
                    children: [(0, k.jsx)(O, {}), `Crear rectificativo`]
                })]
            })]
        })
    }

    function di() {
        let e = tn.filter(e => (F || yn.otherTechs || e.mainTech === `Iván García`) && (e.number + e.client + e.mainTech + e.status + e.incident).toLowerCase().includes(an.toLowerCase())),
            t = e => {
                rn(JSON.parse(JSON.stringify(e))), un(1), fn(e.client), mn(e.center), gn(e.asset), r(`order-editor`)
            };
        return (0, k.jsxs)(`div`, {
            className: `page order-page`,
            children: [(0, k.jsx)(PageHeader, {
                eyebrow: `Servicio técnico`,
                title: `Órdenes de trabajo`,
                sub: `Intervenciones, materiales, firma y seguimiento.`,
                actions: (0, k.jsxs)(`button`, {
                    className: `primary`,
                    onClick: Ur,
                    children: [(0, k.jsx)(D, {}), `Nueva orden`]
                })
            }), (0, k.jsxs)(`section`, {
                className: `stats order-stats`,
                children: [(0, k.jsxs)(`article`, {
                    children: [(0, k.jsx)(`span`, {
                        className: `offer`,
                        children: (0, k.jsx)(me, {})
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`small`, {
                            children: `Pendientes`
                        }), (0, k.jsx)(`strong`, {
                            children: tn.filter(e => e.status === `Borrador`).length
                        }), (0, k.jsx)(`em`, {
                            children: `Para continuar`
                        })]
                    })]
                }), (0, k.jsxs)(`article`, {
                    children: [(0, k.jsx)(`span`, {
                        className: `order`,
                        children: (0, k.jsx)(Ce, {})
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`small`, {
                            children: `En curso`
                        }), (0, k.jsx)(`strong`, {
                            children: tn.filter(e => e.status === `En curso`).length
                        }), (0, k.jsx)(`em`, {
                            children: `Intervenciones activas`
                        })]
                    })]
                }), (0, k.jsxs)(`article`, {
                    children: [(0, k.jsx)(`span`, {
                        className: `delivery`,
                        children: (0, k.jsx)(te, {})
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`small`, {
                            children: `Finalizadas`
                        }), (0, k.jsx)(`strong`, {
                            children: tn.filter(e => e.status === `Finalizada`).length
                        }), (0, k.jsx)(`em`, {
                            children: `Sólo lectura`
                        })]
                    })]
                })]
            }), (0, k.jsxs)(`section`, {
                className: `card order-list`,
                children: [(0, k.jsxs)(`div`, {
                    className: `order-toolbar`,
                    children: [(0, k.jsxs)(`label`, {
                        children: [(0, k.jsx)(he, {}), (0, k.jsx)(`input`, {
                            value: an,
                            onChange: e => on(e.target.value),
                            placeholder: `Buscar orden, cliente, técnico o incidencia…`
                        })]
                    }), (0, k.jsxs)(`select`, {
                        defaultValue: `date`,
                        children: [(0, k.jsx)(`option`, {
                            value: `date`,
                            children: `Fecha`
                        }), (0, k.jsx)(`option`, {
                            value: `number`,
                            children: `Número`
                        }), (0, k.jsx)(`option`, {
                            value: `client`,
                            children: `Cliente`
                        }), (0, k.jsx)(`option`, {
                            value: `status`,
                            children: `Estado`
                        })]
                    })]
                }), e.map(e => (0, k.jsxs)(`button`, {
                    className: `order-row`,
                    onClick: () => t(e),
                    children: [(0, k.jsxs)(`span`, {
                        children: [(0, k.jsx)(`b`, {
                            children: e.number
                        }), (0, k.jsxs)(`small`, {
                            children: [e.date, ` · `, e.origin]
                        })]
                    }), (0, k.jsxs)(`span`, {
                        children: [(0, k.jsx)(`b`, {
                            children: e.client || `Sin cliente`
                        }), (0, k.jsxs)(`small`, {
                            children: [e.objectType, e.asset ? ` · ${e.asset}` : ``]
                        })]
                    }), (0, k.jsxs)(`span`, {
                        children: [(0, k.jsx)(`b`, {
                            children: e.mainTech || `Sin asignar`
                        }), (0, k.jsx)(`small`, {
                            children: e.assistance.join(`, `) || `Sin asistencia`
                        })]
                    }), (0, k.jsx)(`em`, {
                        className: `order-status ${e.status===`Finalizada`?`done`:e.status===`En curso`?`doing`:``}`,
                        children: e.status
                    }), (0, k.jsx)(S, {})]
                }, e.id))]
            })]
        })
    }

    function fi() {
        let e = I.status === `Finalizada`,
            t = (e, t) => rn(n => ({
                ...n,
                [e]: t
            })),
            n = xn.find(e => e.name === I.client),
            i = er ? Jn.find(e => e.id === er.assetId) : void 0,
            a = i ? `${i.code} · ${i.name}` : ``,
            o = i ? tn.filter(e => e.assets.includes(a)) : [],
            s = (e, n) => t(`materials`, I.materials.map(t => t.id === e ? {
                ...t,
                ...n
            } : t)),
            c = async e => {
                if (!validWorkOrderTiming(I.startedAt, I.finishedAt)) {
                    B(`La hora de fin no puede ser anterior a la hora de inicio.`);
                    return
                }
                try {
                    let t = await Br(I, e);
                    rn(t), nn(e => e.some(e => e.dbId === t.dbId || e.id === I.id) ? e.map(e => e.dbId === t.dbId || e.id === I.id ? t : e) : [t, ...e]), B(e === `Finalizada` ? `Orden finalizada y bloqueada` : `Guardado`)
                } catch (e) {
                    B(e instanceof Error && e.message === `VERSION_CONFLICT` ? `La orden cambió en otra sesión; vuelve a abrirla` : `No se pudo guardar la orden`)
                }
            }, l = n => {
                if (e) return;
                n.preventDefault();
                let r = vr.current;
                if (!r) return;
                let i = r.getBoundingClientRect(),
                    a = r.getContext(`2d`);
                if (!a) return;
                let o = (n.clientX - i.left) * r.width / i.width,
                    s = (n.clientY - i.top) * r.height / i.height;
                n.type === `pointerdown` ? (r.setPointerCapture(n.pointerId), yr.current = !0, a.beginPath(), a.moveTo(o, s)) : n.type === `pointermove` && yr.current ? (a.lineTo(o, s), a.strokeStyle = `#10384f`, a.lineWidth = 3, a.lineCap = `round`, a.stroke(), t(`signatureData`, r.toDataURL())) : yr.current && (yr.current = !1, r.hasPointerCapture(n.pointerId) && r.releasePointerCapture(n.pointerId), t(`signatureData`, r.toDataURL()))
            }, u = e => {
                fn(e), mn(``), gn(``), rn(t => ({
                    ...t,
                    client: e,
                    center: ``,
                    asset: ``,
                    assets: [],
                    serial: ``,
                    relatedDocs: []
                }))
            }, d = e => t(`materials`, [...I.materials, {
                id: Date.now(),
                articleId: e?.id || null,
                code: e?.code || ``,
                description: e?.description || ``,
                qty: `1,00`,
                serialRequired: !!e?.serial,
                serials: e?.serial ? [``] : []
            }]), f = (e, t) => {
                z({
                    ...e
                }), tr({
                    assetId: e.id,
                    view: t,
                    editing: !1
                })
            };
        return (0, k.jsxs)(`div`, {
            className: `editor guided-order`,
            children: [(0, k.jsxs)(`header`, {
                className: `edithead`,
                children: [(0, k.jsxs)(`div`, {
                    children: [(0, k.jsx)(`button`, {
                        onClick: () => r(`orders`),
                        children: (0, k.jsx)(ee, {})
                    }), (0, k.jsxs)(`span`, {
                        children: [(0, k.jsx)(`small`, {
                            children: e ? `ORDEN FINALIZADA · SÓLO LECTURA` : `ORDEN DE TRABAJO`
                        }), (0, k.jsx)(`strong`, {
                            children: I.number
                        })]
                    })]
                }), (0, k.jsxs)(`div`, {
                    className: `actions`,
                    children: [(0, k.jsxs)(`button`, {
                        onClick: () => openWorkOrderPrintPreview({
                            ...I,
                            clientNif: n?.nif,
                            clientAddress: n?.address,
                            clientPostalCode: n?.postalCode,
                            clientCity: n?.city,
                            clientProvince: n?.province
                        }, Jn.find(e => I.assets?.includes(`${e.code} · ${e.name}`) || `${e.code} · ${e.name}` === I.asset)),
                        children: [(0, k.jsx)(pe, {}), `Imprimir / PDF`]
                    }), e && (0, k.jsx)(`button`, {
                        className: `primary`,
                        onClick: () => void loadWorkOrderMail(I, !0).catch(() => B(`No se pudo preparar el envío`)),
                        children: `Enviar al cliente`
                    }), e && (0, k.jsx)(`button`, {
                        onClick: () => void loadWorkOrderMail(I).then(() => N(`work-order-mail-history`)).catch(() => B(`No se pudo cargar el histórico de envíos`)),
                        children: `Histórico de envíos (${workOrderMail.history.length})`
                    }), !e && (0, k.jsx)(`button`, {
                        "data-session-save": `work-order`,
                        onClick: () => c(`Borrador`),
                        children: `Guardar`
                    })]
                })]
            }), e && (0, k.jsxs)(`div`, {
                className: `locked-order`,
                children: [(0, k.jsx)(_e, {}), (0, k.jsx)(`b`, {
                    children: `Orden cerrada`
                }), (0, k.jsx)(`span`, {
                    children: `Consulta e impresión disponibles; datos operativos bloqueados.`
                })]
            }), (0, k.jsx)(`nav`, {
                className: `order-stepper`,
                "aria-label": `Pasos de la orden`,
                children: [`Datos básicos`, `Intervención`, `Materiales`, `Cierre`].map((e, t) => (0, k.jsxs)(`button`, {
                    className: ln === t + 1 ? `on` : ``,
                    onClick: () => {
                        yr.current = !1, un(t + 1)
                    },
                    children: [(0, k.jsx)(`b`, {
                        children: t + 1
                    }), (0, k.jsx)(`span`, {
                        children: e
                    })]
                }, e))
            }), (0, k.jsxs)(`fieldset`, {
                disabled: e,
                className: `order-fieldset`,
                children: [ln === 1 && (0, k.jsxs)(`section`, {
                    className: `card guided-step`,
                    children: [(0, k.jsx)(V, {
                        title: `Cliente y asignación`,
                        sub: `Búsqueda por contiene; al cambiar cliente se limpian centro, activo y documentos`
                    }), (0, k.jsxs)(`div`, {
                        className: `order-grid`,
                        children: [(0, k.jsxs)(`label`, {
                            className: `wide lookup`,
                            children: [`Cliente`, (0, k.jsx)(`input`, {
                                value: dn,
                                onChange: e => fn(e.target.value),
                                placeholder: `Buscar cliente por nombre…`
                            }), dn && dn !== I.client && (0, k.jsx)(`div`, {
                                children: xn.filter(e => e.name.toLowerCase().includes(dn.toLowerCase())).map(e => (0, k.jsx)(`button`, {
                                    type: `button`,
                                    onClick: () => u(e.name),
                                    children: e.name
                                }, e.name))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Centro de trabajo`, (0, k.jsxs)(`select`, {
                                value: I.center,
                                disabled: !I.client,
                                onChange: e => {
                                    mn(e.target.value), gn(``), rn(t => ({
                                        ...t,
                                        center: e.target.value,
                                        asset: ``,
                                        assets: [],
                                        serial: ``
                                    }))
                                },
                                children: [(0, k.jsx)(`option`, {
                                    value: ``,
                                    children: `Seleccionar centro…`
                                }), Bn.filter(e => e.active).map(e => (0, k.jsx)(`option`, {
                                    children: e.name
                                }, e.id))]
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Origen`, (0, k.jsxs)(`select`, {
                                value: I.origin,
                                onChange: e => t(`origin`, e.target.value),
                                children: [(0, k.jsx)(`option`, {
                                    children: `Solicitada`
                                }), (0, k.jsx)(`option`, {
                                    children: `Mantenimiento preventivo`
                                })]
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Técnico principal`, (0, k.jsxs)(`select`, {
                                value: I.mainTech,
                                onChange: e => t(`mainTech`, e.target.value),
                                children: [(0, k.jsx)(`option`, {
                                    value: ``,
                                    children: `Seleccionar técnico…`
                                }), (0, k.jsx)(`option`, {
                                    children: `Iván García`
                                }), (0, k.jsx)(`option`, {
                                    children: `Laura Pérez`
                                }), (0, k.jsx)(`option`, {
                                    children: `Marta Suárez`
                                })]
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Técnicos adicionales`, (0, k.jsxs)(`select`, {
                                multiple: !0,
                                value: I.extraTechs,
                                onChange: e => t(`extraTechs`, Array.from(e.target.selectedOptions).map(e => e.value)),
                                children: [(0, k.jsx)(`option`, {
                                    children: `Iván García`
                                }), (0, k.jsx)(`option`, {
                                    children: `Laura Pérez`
                                }), (0, k.jsx)(`option`, {
                                    children: `Marta Suárez`
                                })]
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Tipo de asistencia`, (0, k.jsx)(`div`, {
                                className: `order-chips`,
                                children: [`Presencial`, `Remota`, `Telefónica`, `WhatsApp`, `SAT`, `Administrativa`, `Operador`].map(e => (0, k.jsx)(`button`, {
                                    type: `button`,
                                    className: I.assistance.includes(e) ? `on` : ``,
                                    onClick: () => t(`assistance`, I.assistance.includes(e) ? I.assistance.filter(t => t !== e) : [...I.assistance, e]),
                                    children: e
                                }, e))
                            })]
                        })]
                    })]
                }), ln === 2 && (0, k.jsxs)(`section`, {
                    className: `card guided-step`,
                    children: [(0, k.jsx)(V, {
                        title: `Objeto e intervención`,
                        sub: `Activo del cliente o intervención genérica`
                    }), (0, k.jsx)(`div`, {
                        className: `object-buttons`,
                        children: [`Activo concreto`, `Sistema informático`, `Red`, `Aplicación`, `Servicio`, `Otro`].map(e => (0, k.jsx)(`button`, {
                            type: `button`,
                            className: I.objectType === e ? `on` : ``,
                            onClick: () => t(`objectType`, e),
                            children: e
                        }, e))
                    }), (0, k.jsxs)(`div`, {
                        className: `order-grid`,
                        children: [(0, k.jsxs)(`div`, {
                            className: `intervention-timing wide`,
                            children: [(0, k.jsxs)(`label`, {
                                children: [`Inicio`, (0, k.jsx)(`input`, { type: `datetime-local`, value: I.startedAt || ``, onChange: e => t(`startedAt`, e.target.value) })]
                            }), (0, k.jsxs)(`label`, {
                                children: [`Fin`, (0, k.jsx)(`input`, { type: `datetime-local`, value: I.finishedAt || ``, min: I.startedAt || void 0, onChange: e => t(`finishedAt`, e.target.value) })]
                            }), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`small`, { children: `Duración` }), (0, k.jsx)(`b`, { children: workOrderDuration(I.startedAt, I.finishedAt) || `Sin iniciar` })]
                            }), (0, k.jsxs)(`div`, {
                                className: `intervention-timing-actions`,
                                children: [(0, k.jsx)(`button`, { type: `button`, disabled: !!I.startedAt, onClick: () => t(`startedAt`, localDateTimeValue()), children: `Iniciar intervención` }), (0, k.jsx)(`button`, { type: `button`, disabled: !I.startedAt || !!I.finishedAt, onClick: () => t(`finishedAt`, localDateTimeValue()), children: `Finalizar intervención` })]
                            })]
                        }), I.objectType === `Activo concreto` && (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Activos del cliente y centro`, (0, k.jsx)(`select`, {
                                multiple: !0,
                                value: I.assets,
                                disabled: !I.center,
                                onChange: e => {
                                    let t = Array.from(e.target.selectedOptions).map(e => e.value),
                                        n = Jn.find(e => `${e.code} · ${e.name}` === t[0]);
                                    rn(e => ({
                                        ...e,
                                        assets: t,
                                        asset: t[0] || ``,
                                        serial: n?.serial || ``
                                    }))
                                },
                                children: Jn.filter(e => e.active).map(e => (0, k.jsxs)(`option`, {
                                    value: `${e.code} · ${e.name}`,
                                    children: [e.code, ` · `, e.name]
                                }, e.id))
                            }), (0, k.jsx)(`small`, {
                                children: `Ctrl/Cmd o selección táctil para elegir varios equipos.`
                            })]
                        }), I.assets.map(e => {
                            let t = Jn.find(t => `${t.code} · ${t.name}` === e);
                            if (!t) return null;
                            let n = new Date().toISOString().slice(0, 10),
                                r = !t.warrantyFrom || !t.warrantyTo ? `Sin datos` : t.warrantyFrom <= n && t.warrantyTo >= n ? `En garantía` : `Fuera de garantía`;
                            return (0, k.jsxs)(`div`, {
                                className: `asset-summary asset-detail wide`,
                                children: [(0, k.jsx)(T, {}), (0, k.jsxs)(`span`, {
                                    children: [(0, k.jsx)(`b`, {
                                        children: t.name
                                    }), (0, k.jsxs)(`small`, {
                                        children: [t.code, ` · Serie: `, t.serial || `Sin datos`]
                                    }), (0, k.jsx)(`small`, {
                                        children: t.features || `Sin características`
                                    }), (0, k.jsxs)(`small`, {
                                        children: [`Garantía desde: `, t.warrantyFrom || `Sin datos`, ` · Garantía hasta: `, t.warrantyTo || `Sin datos`]
                                    }), (0, k.jsx)(`em`, {
                                        className: r === `En garantía` ? `warranty-ok` : r === `Fuera de garantía` ? `warranty-out` : ``,
                                        children: r
                                    })]
                                }), (0, k.jsxs)(`div`, {
                                    className: `asset-actions`,
                                    children: [(0, k.jsx)(`button`, {
                                        type: `button`,
                                        onClick: () => f(t, `details`),
                                        children: `Ver activo`
                                    }), (0, k.jsx)(`button`, {
                                        type: `button`,
                                        onClick: () => f(t, `history`),
                                        children: `Ver historial ampliado`
                                    }), (0, k.jsx)(`button`, {
                                        type: `button`,
                                        onClick: () => {
                                            let t = I.assets.filter(t => t !== e),
                                                n = Jn.find(e => `${e.code} · ${e.name}` === t[0]);
                                            rn(e => ({
                                                ...e,
                                                assets: t,
                                                asset: t[0] || ``,
                                                serial: n?.serial || ``
                                            }))
                                        },
                                        children: `Quitar`
                                    })]
                                })]
                            }, t.id)
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Incidencia / Servicio solicitado`, (0, k.jsx)(`textarea`, {
                                value: I.incident,
                                onChange: e => t(`incident`, e.target.value)
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Acción técnica realizada`, (0, k.jsx)(`textarea`, {
                                value: I.action,
                                onChange: e => t(`action`, e.target.value)
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Observaciones internas`, (0, k.jsx)(`textarea`, {
                                value: I.internalNotes,
                                onChange: e => t(`internalNotes`, e.target.value)
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Desplazamiento`, (0, k.jsxs)(`select`, {
                                value: I.travel ? `Sí` : `No`,
                                onChange: e => t(`travel`, e.target.value === `Sí`),
                                children: [(0, k.jsx)(`option`, {
                                    children: `Sí`
                                }), (0, k.jsx)(`option`, {
                                    children: `No`
                                })]
                            })]
                        }), (F || yn.billable) && (0, k.jsxs)(`label`, {
                            children: [`Facturable`, (0, k.jsxs)(`select`, {
                                value: I.billable ? `Sí` : `No`,
                                onChange: e => t(`billable`, e.target.value === `Sí`),
                                children: [(0, k.jsx)(`option`, {
                                    children: `Sí`
                                }), (0, k.jsx)(`option`, {
                                    children: `No`
                                })]
                            })]
                        })]
                    })]
                }), ln === 3 && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsxs)(`section`, {
                        className: `card guided-step`,
                        children: [(0, k.jsxs)(`div`, {
                            className: `lineshead`,
                            children: [(0, k.jsx)(V, {
                                title: `Materiales / componentes`,
                                sub: `Arrastra desde los seis puntos; artículo real o línea libre`
                            }), (0, k.jsxs)(`div`, {
                                children: [(0, k.jsxs)(`button`, {
                                    type: `button`,
                                    onClick: () => d(),
                                    children: [(0, k.jsx)(D, {}), `Línea libre`]
                                }), (0, k.jsxs)(`button`, {
                                    type: `button`,
                                    onClick: () => cn(` `),
                                    children: [(0, k.jsx)(he, {}), `Buscar artículo`]
                                })]
                            })]
                        }), sn && (0, k.jsxs)(`div`, {
                            className: `order-article-search`,
                            children: [(0, k.jsx)(`input`, {
                                autoFocus: !0,
                                value: sn.trimStart(),
                                onChange: e => cn(e.target.value || ` `),
                                placeholder: `Buscar por código o descripción…`
                            }), lt.filter(e => !e.inactive && (e.code + e.description).toLowerCase().includes(sn.trim().toLowerCase())).map(e => (0, k.jsxs)(`button`, {
                                type: `button`,
                                onClick: () => {
                                    d(e), cn(``)
                                },
                                children: [(0, k.jsx)(`b`, {
                                    children: e.code
                                }), (0, k.jsx)(`span`, {
                                    children: e.description
                                })]
                            }, e.code))]
                        }), (0, k.jsx)(`div`, {
                            className: `order-materials`,
                            children: I.materials.map((e, n) => (0, k.jsxs)(`article`, {
                                draggable: !0,
                                onDragStart: () => en(e.id),
                                onDragOver: e => e.preventDefault(),
                                onDrop: () => {
                                    if ($t === null || $t === e.id) return;
                                    let r = [...I.materials],
                                        i = r.findIndex(e => e.id === $t),
                                        [a] = r.splice(i, 1);
                                    r.splice(n, 0, a), t(`materials`, r), en(null)
                                },
                                children: [(0, k.jsx)(ce, {}), (0, k.jsxs)(`label`, {
                                    children: [`Código`, (0, k.jsx)(`input`, {
                                        value: e.code,
                                        onChange: t => s(e.id, {
                                            code: t.target.value
                                        })
                                    })]
                                }), (0, k.jsxs)(`label`, {
                                    children: [`Descripción`, (0, k.jsx)(`input`, {
                                        value: e.description,
                                        onChange: t => s(e.id, {
                                            description: t.target.value
                                        })
                                    })]
                                }), (0, k.jsxs)(`label`, {
                                    children: [`Cantidad`, (0, k.jsx)(`input`, {
                                        className: `manual-quantity`,
                                        inputMode: `decimal`,
                                        onFocus: Ye,
                                        value: e.qty,
                                        onChange: t => {
                                            let n = Je(t.target.value),
                                                r = Math.max(0, Math.floor(A(n)));
                                            s(e.id, {
                                                qty: n,
                                                serials: e.serialRequired ? Array.from({
                                                    length: r
                                                }, (t, n) => e.serials[n] || ``) : []
                                            })
                                        }
                                    })]
                                }), e.serialRequired && (0, k.jsxs)(`label`, {
                                    children: [`Series`, e.serials.map((t, n) => (0, k.jsx)(`input`, {
                                        value: t,
                                        onChange: t => {
                                            let r = [...e.serials];
                                            r[n] = t.target.value, s(e.id, {
                                                serials: r
                                            })
                                        }
                                    }, n))]
                                }), (0, k.jsx)(`button`, {
                                    type: `button`,
                                    title: `Eliminar`,
                                    onClick: () => t(`materials`, I.materials.filter(t => t.id !== e.id)),
                                    children: (0, k.jsx)(ye, {})
                                })]
                            }, e.id))
                        })]
                    }), (0, k.jsxs)(`section`, {
                        className: `card guided-step`,
                        children: [(0, k.jsx)(V, {
                            title: `Tareas y adjuntos`,
                            sub: `Seguimiento recuperable desde la orden y el módulo Tareas`
                        }), (0, k.jsxs)(`button`, {
                            type: `button`,
                            className: `primary`,
                            onClick: () => {
                                It({
                                    id: Date.now(),
                                    title: `Revisar estado`,
                                    owner: `Iván García`,
                                    date: `2026-09-10`,
                                    link: I.number,
                                    comment: ``,
                                    status: `Pendiente`,
                                    result: ``
                                }), N(`task`)
                            },
                            children: [(0, k.jsx)(D, {}), `Nueva tarea`]
                        }), Nt.filter(e => e.link === I.number).map(e => (0, k.jsxs)(`button`, {
                            type: `button`,
                            className: `taskquick`,
                            onClick: () => {
                                It(e), N(`task`)
                            },
                            children: [(0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: e.title
                                }), (0, k.jsxs)(`small`, {
                                    children: [e.date, ` · `, e.status]
                                })]
                            }), (0, k.jsx)(fe, {})]
                        }, e.id)), (0, k.jsxs)(`label`, {
                            className: `order-upload`,
                            children: [(0, k.jsx)(de, {}), `Adjuntar archivos`, (0, k.jsx)(`input`, {
                                type: `file`,
                                multiple: !0,
                                onChange: e => ai(e.target.files)
                            })]
                        })]
                    })]
                }), ln === 4 && (0, k.jsxs)(`section`, {
                    className: `card guided-step`,
                    children: [(0, k.jsx)(V, {
                        title: `Cierre de la orden`,
                        sub: `Evaluación interna, firma y acciones de cierre`
                    }), (F || yn.qualityView) && (0, k.jsxs)(`div`, {
                        className: `quality-form`,
                        children: [
                            [
                                [`urgency`, `Urgencia`, [`Normal`, `Urgente justificada`, `Urgente no justificada`]],
                                [`schedule`, `Horario`, [`Adecuado`, `Fuera de horario acordado`, `Fuera de horario no previsto`]],
                                [`treatment`, `Trato / respeto`, [`Correcto`, `Tenso`, `Inadecuado`]],
                                [`demand`, `Exigencia`, [`Normal`, `Alta`, `Desproporcionada`]],
                                [`scope`, `Alcance`, [`Definido`, `Fuera de alcance`, `Dudoso`]],
                                [`impact`, `Impacto operativo`, [`Bajo`, `Medio`, `Alto`]]
                            ].map(([e, n, r]) => (0, k.jsxs)(`label`, {
                                children: [n, (0, k.jsx)(`select`, {
                                    disabled: !F && !yn.qualityEdit,
                                    value: I.quality[e],
                                    onChange: n => t(`quality`, {
                                        ...I.quality,
                                        [e]: n.target.value
                                    }),
                                    children: r.map(e => (0, k.jsx)(`option`, {
                                        children: e
                                    }, e))
                                })]
                            }, e)), (0, k.jsxs)(`label`, {
                                className: `wide`,
                                children: [`Observación interna de calidad`, (0, k.jsx)(`textarea`, {
                                    value: I.quality.note,
                                    onChange: e => t(`quality`, {
                                        ...I.quality,
                                        note: e.target.value
                                    })
                                })]
                            }), (0, k.jsxs)(`span`, {
                                className: `quality-light ${I.quality.light.toLowerCase()}`,
                                children: [`● `, I.quality.light]
                            })
                        ]
                    }), (0, k.jsxs)(`div`, {
                        className: `signature-order`,
                        children: [(0, k.jsx)(`canvas`, {
                            ref: vr,
                            width: `800`,
                            height: `170`,
                            onPointerDown: l,
                            onPointerMove: l,
                            onPointerUp: l,
                            onPointerCancel: l
                        }), I.signatureData && (0, k.jsx)(`img`, {
                            className: `signature-preview`,
                            src: I.signatureData,
                            alt: `Firma guardada`
                        }), (0, k.jsx)(`span`, {
                            children: `Firma del cliente`
                        }), !e && (0, k.jsxs)(`button`, {
                            type: `button`,
                            onClick: () => {
                                yr.current = !1;
                                let e = vr.current;
                                e?.getContext(`2d`)?.clearRect(0, 0, e.width, e.height), t(`signatureData`, ``)
                            },
                            children: [(0, k.jsx)(O, {}), `Borrar firma`]
                        })]
                    }), (0, k.jsxs)(`div`, {
                        className: `order-grid`,
                        children: [(0, k.jsxs)(`label`, {
                            children: [`Nombre y apellidos`, (0, k.jsx)(`input`, {
                                value: I.signer,
                                onChange: e => t(`signer`, e.target.value)
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`NIF/CIF`, (0, k.jsx)(`input`, {
                                value: I.signerId,
                                onChange: e => t(`signerId`, e.target.value)
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide conformity`,
                            children: [(0, k.jsx)(`input`, {
                                type: `checkbox`,
                                checked: I.confirmed,
                                onChange: e => t(`confirmed`, e.target.checked)
                            }), `He revisado y estoy conforme con los datos de la orden.`]
                        })]
                    }), (0, k.jsxs)(`div`, {
                        className: `close-actions`,
                        children: [I.billable && (0, k.jsxs)(`button`, {
                            type: `button`,
                            onClick: () => B(`Albarán simulado generado y vinculado`),
                            children: [(0, k.jsx)(be, {}), `Generar albarán`]
                        }), !e && (0, k.jsxs)(`button`, {
                            type: `button`,
                            className: `primary`,
                            onClick: () => I.confirmed ? c(`Finalizada`) : B(`Marca la conformidad antes de cerrar`),
                            children: [(0, k.jsx)(te, {}), `Finalizar y bloquear`]
                        })]
                    })]
                })]
            }), !e && (0, k.jsxs)(`footer`, {
                className: `guided-footer`,
                children: [(0, k.jsxs)(`button`, {
                    disabled: ln === 1,
                    onClick: () => {
                        yr.current = !1, un(e => Math.max(1, e - 1))
                    },
                    children: [(0, k.jsx)(ee, {}), `Anterior`]
                }), (0, k.jsxs)(`span`, {
                    children: [`Paso `, ln, ` de 4`]
                }), (0, k.jsxs)(`button`, {
                    className: `primary`,
                    disabled: ln === 4,
                    onClick: () => {
                        yr.current = !1, un(e => Math.min(4, e + 1))
                    },
                    children: [`Continuar`, (0, k.jsx)(S, {})]
                })]
            }), er && i && (0, k.jsx)(`div`, {
                className: `order-overlay`,
                children: (0, k.jsxs)(`section`, {
                    className: `asset-panel`,
                    children: [(0, k.jsx)(`button`, {
                        className: `closemini`,
                        onClick: () => tr(null),
                        children: (0, k.jsx)(we, {})
                    }), (0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: er.view === `history` ? `Historial ampliado` : `Activo de la Orden`
                    }), (0, k.jsxs)(`h2`, {
                        children: [i.code, ` · `, i.name]
                    }), (0, k.jsxs)(`div`, {
                        className: `asset-panel-tabs`,
                        children: [(0, k.jsx)(`button`, {
                            className: er.view === `details` ? `on` : ``,
                            onClick: () => tr({
                                ...er,
                                view: `details`,
                                editing: !1
                            }),
                            children: `Datos del activo`
                        }), (0, k.jsx)(`button`, {
                            className: er.view === `history` ? `on` : ``,
                            onClick: () => tr({
                                ...er,
                                view: `history`,
                                editing: !1
                            }),
                            children: `Historial ampliado`
                        })]
                    }), er.view === `details` && !er.editing && (0, k.jsxs)(k.Fragment, {
                        children: [(0, k.jsxs)(`div`, {
                            className: `asset-panel-data`,
                            children: [(0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`small`, {
                                    children: `Centro`
                                }), (0, k.jsx)(`b`, {
                                    children: Bn.find(e => e.id === i.centerId)?.name || `Sin centro`
                                })]
                            }), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`small`, {
                                    children: `Serie`
                                }), (0, k.jsx)(`b`, {
                                    children: i.serial || `Sin datos`
                                })]
                            }), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`small`, {
                                    children: `Tipo`
                                }), (0, k.jsx)(`b`, {
                                    children: i.type || `Sin datos`
                                })]
                            }), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`small`, {
                                    children: `Marca`
                                }), (0, k.jsx)(`b`, {
                                    children: i.brand || `Sin datos`
                                })]
                            }), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`small`, {
                                    children: `Ubicación`
                                }), (0, k.jsx)(`b`, {
                                    children: i.location || `Sin datos`
                                })]
                            }), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`small`, {
                                    children: `Última actualización`
                                }), (0, k.jsx)(`b`, {
                                    children: Ve(i.updatedOn)
                                })]
                            }), (0, k.jsxs)(`span`, {
                                className: `wide`,
                                children: [(0, k.jsx)(`small`, {
                                    children: `Características`
                                }), (0, k.jsx)(`b`, {
                                    children: i.features || `Sin datos`
                                })]
                            }), (0, k.jsxs)(`span`, {
                                className: `wide`,
                                children: [(0, k.jsx)(`small`, {
                                    children: `ID externo futuro`
                                }), (0, k.jsx)(`b`, {
                                    children: i.externalId || `Sin asignar`
                                })]
                            })]
                        }), F && !e && (0, k.jsx)(`div`, {
                            className: `close-actions`,
                            children: (0, k.jsx)(`button`, {
                                className: `primary`,
                                onClick: () => {
                                    z({
                                        ...i
                                    }), tr({
                                        ...er,
                                        editing: !0
                                    })
                                },
                                children: `Editar activo`
                            })
                        })]
                    }), er.view === `details` && er.editing && (0, k.jsxs)(`div`, {
                        className: `order-grid`,
                        children: [(0, k.jsxs)(`label`, {
                            children: [`Centro`, (0, k.jsx)(`select`, {
                                value: R.centerId,
                                onChange: e => z(t => ({
                                    ...t,
                                    centerId: Number(e.target.value)
                                })),
                                children: Bn.filter(e => e.active || e.id === R.centerId).map(e => (0, k.jsx)(`option`, {
                                    value: e.id,
                                    children: e.name
                                }, e.id))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Referencia`, (0, k.jsx)(`input`, {
                                value: R.code,
                                onChange: e => z(t => ({
                                    ...t,
                                    code: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Nombre`, (0, k.jsx)(`input`, {
                                value: R.name,
                                onChange: e => z(t => ({
                                    ...t,
                                    name: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Serie`, (0, k.jsx)(`input`, {
                                value: R.serial,
                                onChange: e => z(t => ({
                                    ...t,
                                    serial: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Tipo`, (0, k.jsx)(`input`, {
                                list: `order-asset-types`,
                                value: R.type,
                                onChange: e => z(t => ({
                                    ...t,
                                    type: e.target.value
                                }))
                            }), (0, k.jsx)(`datalist`, {
                                id: `order-asset-types`,
                                children: Be(Re, Jn, `type`).map(e => (0, k.jsx)(`option`, {
                                    value: e
                                }, e))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Marca`, (0, k.jsx)(`input`, {
                                list: `order-asset-brands`,
                                value: R.brand,
                                onChange: e => z(t => ({
                                    ...t,
                                    brand: e.target.value
                                }))
                            }), (0, k.jsx)(`datalist`, {
                                id: `order-asset-brands`,
                                children: Be(ze, Jn, `brand`).map(e => (0, k.jsx)(`option`, {
                                    value: e
                                }, e))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Ubicación`, (0, k.jsx)(`input`, {
                                value: R.location,
                                onChange: e => z(t => ({
                                    ...t,
                                    location: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Características`, (0, k.jsx)(`textarea`, {
                                value: R.features,
                                onChange: e => z(t => ({
                                    ...t,
                                    features: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`div`, {
                            className: `asset-updated wide`,
                            children: [(0, k.jsx)(`small`, {
                                children: `Última actualización`
                            }), (0, k.jsx)(`b`, {
                                children: Ve(R.updatedOn)
                            }), (0, k.jsx)(`span`, {
                                children: `Se actualizará automáticamente al guardar.`
                            })]
                        }), (0, k.jsxs)(`div`, {
                            className: `close-actions wide`,
                            children: [(0, k.jsx)(`button`, {
                                onClick: () => tr({
                                    ...er,
                                    editing: !1
                                }),
                                children: `Cancelar`
                            }), (0, k.jsx)(`button`, {
                                "data-session-save": `asset-details`,
                                className: `primary`,
                                onClick: async () => {
                                    if (Jn.some(e => e.id !== R.id && e.centerId === R.centerId && e.code.trim().toLocaleLowerCase() === R.code.trim().toLocaleLowerCase())) {
                                        B(`La referencia ya existe en este cliente y centro`);
                                        return
                                    }
                                    let e = Jn.find(e => e.id === R.id);
                                    if (!e) return;
                                    let t = await M(`/api/assets.php`, {
                                            method: `PUT`,
                                            headers: {
                                                "Content-Type": `application/json`,
                                                Accept: `application/json`
                                            },
                                            body: JSON.stringify(R)
                                        }),
                                        n = await t.json();
                                    if (!t.ok) {
                                        B(n.error || `No se pudo guardar el activo`);
                                        return
                                    }
                                    let r = n.asset,
                                        i = `${e.code} · ${e.name}`,
                                        a = `${r.code} · ${r.name}`;
                                    Yn(e => e.map(e => e.id === r.id ? r : e)), rn(e => ({
                                        ...e,
                                        assets: e.assets.map(e => e === i ? a : e),
                                        asset: e.asset === i ? a : e.asset,
                                        serial: e.asset === i ? r.serial : e.serial
                                    })), z(r), tr({
                                        assetId: r.id,
                                        view: `details`,
                                        editing: !1
                                    }), B(`Guardado`)
                                },
                                children: `Guardar`
                            })]
                        })]
                    }), er.view === `history` && (0, k.jsxs)(`div`, {
                        className: `asset-history`,
                        children: [o.map(e => (0, k.jsxs)(`article`, {
                            children: [(0, k.jsxs)(`b`, {
                                children: [e.number, ` · `, e.date]
                            }), (0, k.jsxs)(`span`, {
                                children: [e.status, ` · `, [e.mainTech, ...e.extraTechs].filter(Boolean).join(`, `) || `Sin técnico`]
                            }), (0, k.jsxs)(`p`, {
                                children: [(0, k.jsx)(`strong`, {
                                    children: `Incidencia:`
                                }), ` `, e.incident || `Sin datos`]
                            }), (0, k.jsxs)(`p`, {
                                children: [(0, k.jsx)(`strong`, {
                                    children: `Actuación:`
                                }), ` `, e.action || `Sin datos`]
                            }), (0, k.jsxs)(`p`, {
                                children: [(0, k.jsx)(`strong`, {
                                    children: `Materiales:`
                                }), ` `, e.materials.map(e => `${e.description} (${e.qty})`).join(`, `) || `Sin materiales`]
                            })]
                        }, e.dbId || e.id)), !o.length && (0, k.jsx)(`p`, {
                            children: `Sin órdenes relacionadas con este activo.`
                        })]
                    })]
                })
            }), _n === `part` && (0, k.jsx)(`div`, {
                className: `order-overlay`,
                children: (0, k.jsxs)(`section`, {
                    className: `full-report`,
                    children: [(0, k.jsx)(`button`, {
                        className: `closemini`,
                        onClick: () => vn(null),
                        children: (0, k.jsx)(we, {})
                    }), (0, k.jsxs)(`header`, {
                        children: [(0, k.jsx)(`b`, {
                            children: `Microten`
                        }), (0, k.jsxs)(`span`, {
                            children: [`Parte de asistencia técnica · `, I.number]
                        })]
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`strong`, {
                            children: `Fecha/hora:`
                        }), ` `, I.date, ` · 10:30`]
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`strong`, {
                            children: `Cliente:`
                        }), ` `, I.client || `Sin indicar`, ` · `, I.center || `Sin centro`]
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`strong`, {
                            children: `Técnicos:`
                        }), ` `, [I.mainTech, ...I.extraTechs].filter(Boolean).join(`, `)]
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`strong`, {
                            children: `Asistencia:`
                        }), ` `, I.assistance.join(`, `), ` · `, I.origin]
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`strong`, {
                            children: `Objeto:`
                        }), ` `, I.objectType, ` `, I.asset && `· ${I.asset} · Serie ${I.serial}`]
                    }), (0, k.jsx)(`h3`, {
                        children: `Incidencia / Servicio solicitado`
                    }), (0, k.jsx)(`p`, {
                        children: I.incident || `Sin contenido`
                    }), (0, k.jsx)(`h3`, {
                        children: `Acción técnica realizada`
                    }), (0, k.jsx)(`p`, {
                        children: I.action || `Sin contenido`
                    }), (0, k.jsx)(`h3`, {
                        children: `Materiales`
                    }), I.materials.map(e => (0, k.jsxs)(`p`, {
                        children: [e.code, ` · `, e.description, ` · `, e.qty, ` uds.`]
                    }, e.id)), (0, k.jsxs)(`div`, {
                        className: `report-signature`,
                        children: [`Firma del cliente · `, I.signer || `Pendiente`]
                    }), (0, k.jsxs)(`button`, {
                        onClick: () => window.print(),
                        children: [(0, k.jsx)(pe, {}), `Imprimir / guardar PDF`]
                    })]
                })
            })]
        })
    }

    function pi() {
        return (0, k.jsxs)(`div`, {
            className: `page`,
            children: [(0, k.jsx)(PageHeader, {
                eyebrow: `Catálogo ficticio`,
                title: `Artículos`,
                sub: null,
                actions: (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsxs)(`button`, {
                        className: `primary`,
                        onClick: () => {
                            dt(He()), pt(!0), N(`article-master`)
                        },
                        children: [(0, k.jsx)(D, {}), `Nuevo artículo`]
                    })]
                })
            }), (0, k.jsxs)(`section`, {
                className: `card filters2`,
                children: [(0, k.jsxs)(`label`, {
                    children: [`Buscar`, (0, k.jsx)(`input`, {
                        value: at,
                        onChange: e => ot(e.target.value),
                        placeholder: `Código o descripción…`
                    })]
                }), (0, k.jsxs)(`label`, {
                    children: [`Familia`, (0, k.jsxs)(`select`, {
                        value: st,
                        onChange: e => ct(e.target.value),
                        children: [(0, k.jsx)(`option`, {
                            children: `Todas`
                        }), (0, k.jsx)(`option`, {
                            children: `Climatización`
                        }), (0, k.jsx)(`option`, {
                            children: `ACS`
                        }), (0, k.jsx)(`option`, {
                            children: `Servicios`
                        })]
                    })]
                })]
            }), (0, k.jsxs)(`section`, {
                className: `card articletable`,
                children: [(0, k.jsxs)(`div`, {
                    className: `articlehead ${F?`with-cost`:``}`,
                    children: [(0, k.jsx)(`span`, {
                        children: `Código`
                    }), (0, k.jsx)(`span`, {
                        children: `Descripción`
                    }), (0, k.jsx)(`span`, {
                        children: `Familia`
                    }), (0, k.jsx)(`span`, {
                        children: `Estado`
                    }), F && (0, k.jsx)(`span`, {
                        children: `Coste`
                    }), (0, k.jsx)(`span`, {
                        children: `IGIC`
                    }), (0, k.jsx)(`span`, {
                        children: `Serie`
                    })]
                }), lt.filter(e => (e.code + e.description).toLowerCase().includes(at.toLowerCase()) && (st === `Todas` || e.family === st)).map(e => (0, k.jsxs)(`button`, {
                    className: F ? `with-cost` : ``,
                    onClick: () => {
                        dt(e), pt(!0), N(`article-master`)
                    },
                    children: [(0, k.jsx)(`b`, {
                        children: e.code
                    }), (0, k.jsx)(`span`, {
                        children: e.description
                    }), (0, k.jsx)(`span`, {
                        children: e.family
                    }), (0, k.jsx)(`i`, {
                        children: e.active ? `Activo` : `Inactivo`
                    }), F && (0, k.jsx)(`strong`, {
                        children: j(e.cost)
                    }), (0, k.jsxs)(`span`, {
                        children: [e.igic, ` %`]
                    }), (0, k.jsx)(`span`, {
                        children: e.serial ? `Sí` : `No`
                    })]
                }, e.code))]
            })]
        })
    }

    function mi() {
        return (0, k.jsxs)(`div`, {
            className: `page`,
            children: [(0, k.jsx)(PageHeader, {
                eyebrow: `Organización`,
                title: `Tareas`,
                sub: `Seguimiento vinculado a clientes y documentos.`,
                actions: (0, k.jsxs)(`button`, {
                    className: `primary`,
                    onClick: () => {
                        It(null), N(`task`)
                    },
                    children: [(0, k.jsx)(D, {}), `Nueva tarea`]
                })
            }), (0, k.jsx)(`div`, {
                className: `board four`,
                children: [`Pendiente`, `En curso`, `Completada`, `Cancelada`].map(e => (0, k.jsxs)(`section`, {
                    onDragOver: e => e.preventDefault(),
                    onDrop: t => {
                        let n = Number(t.dataTransfer.getData(`task`)),
                            r = Nt.find(e => e.id === n);
                        r && jr(r, e)
                    },
                    children: [(0, k.jsxs)(`h2`, {
                        children: [e, (0, k.jsx)(`span`, {
                            children: Nt.filter(t => t.status === e).length
                        })]
                    }), Nt.filter(t => t.status === e).map(e => (0, k.jsxs)(`article`, {
                        draggable: !0,
                        onDragStart: t => t.dataTransfer.setData(`task`, String(e.id)),
                        onClick: () => {
                            It(e), N(`task`)
                        },
                        children: [(0, k.jsx)(`i`, {}), (0, k.jsx)(`b`, {
                            children: e.title
                        }), (0, k.jsxs)(`p`, {
                            children: [e.link, (0, k.jsx)(`br`, {}), e.date, ` · `, e.owner]
                        }), (0, k.jsxs)(`div`, {
                            children: [(0, k.jsx)(`span`, {
                                className: `avatar`,
                                children: e.owner.split(` `).map(e => e[0]).slice(0, 2)
                            }), (0, k.jsx)(fe, {})]
                        })]
                    }, e.id))]
                }, e))
            })]
        })
    }

    async function deleteAssetCandidate() {
        let e = assetDeleteCandidate;
        if (!e) return;
        let t = await M(`/api/assets.php`, {
                method: `DELETE`,
                headers: {
                    "Content-Type": `application/json`,
                    Accept: `application/json`
                },
                body: JSON.stringify({
                    id: e.id,
                    version: e.version
                })
            }), n = await t.json();
        N(null), setAssetDeleteCandidate(null);
        if (!t.ok) {
            await Ir(e.customerId), B(n.error || `No se pudo eliminar el activo`);
            return
        }
        Zn(!1), $n(0), await Ir(e.customerId), B(`Activo eliminado`)
    }

    function hi() {
        let e = e => {
                rn(JSON.parse(JSON.stringify(e))), un(1), fn(e.client), mn(e.center), gn(e.asset), r(`order-editor`)
            },
            t = L ? tn.filter(e => e.client === L.name) : [],
            n = Kn.find(e => e.id === Qn),
            i = n ? `${n.code} · ${n.name}` : ``,
            a = n ? t.filter(e => e.assets.includes(i)) : t,
            assetHasHistory = e => {
                let n = `${e.code} · ${e.name}`;
                return t.some(e => Array.isArray(e.assets) && e.assets.includes(n))
            },
            filteredClientAssets = filterAssets(Kn, {
                centerId: assetCenterFilter,
                assetClass: assetClassFilter
            }),
            focusAssetWorkspace = () => requestAnimationFrame(() => assetWorkspaceRef.current?.scrollIntoView({
                block: `start`
            })),
            o = async () => {
                let e = !En.id,
                    t = await M(`/api/clients.php`, {
                        method: e ? `POST` : `PUT`,
                        headers: {
                            "Content-Type": `application/json`,
                            Accept: `application/json`
                        },
                        body: JSON.stringify(En)
                    }),
                    n = await t.json();
                if (!t.ok) {
                    B(n.error || `No se pudo guardar el cliente`);
                    return
                }
                Tn(n.client), Dn(n.client), kn(!1), jn(null), await Nr(Cn), B(`Guardado`)
            }, s = async e => {
                let t = await M(`/api/clients.php`, {
                        method: `PATCH`,
                        headers: {
                            "Content-Type": `application/json`,
                            Accept: `application/json`
                        },
                        body: JSON.stringify({
                            id: e.id,
                            active: !e.active,
                            version: e.version
                        })
                    }),
                    n = await t.json();
                if (!t.ok) {
                    B(n.error || `No se pudo cambiar el estado`);
                    return
                }
                Tn(n.client), Dn(n.client), await Nr(Cn), B(n.client.active ? `Cliente activado` : `Cliente desactivado`)
            }, c = (e, t) => Dn(n => ({
                ...n,
                [e]: t
            })), l = () => {
                kn(!1), jn(`choose`), Nn(``), Fn([]), Ln(0)
            }, u = () => {
                jn(null), Ln(0)
            }, d = () => {
                let e = Pn.find(e => e.id === In);
                e && (Tn(e), $n(0), Dn(e), kn(!1), jn(null), B(`Expediente existente abierto; no se ha duplicado el cliente`))
            }, f = async () => {
                let e = await M(`/api/centers.php`, {
                        method: Hn.id ? `PUT` : `POST`,
                        headers: {
                            "Content-Type": `application/json`,
                            Accept: `application/json`
                        },
                        body: JSON.stringify(Hn)
                    }),
                    t = await e.json();
                if (!e.ok) {
                    B(t.error || `No se pudo guardar el centro`);
                    return
                }
                Gn(!1), await Pr(Hn.customerId), B(`Guardado`)
            }, p = async e => {
                let t = await M(`/api/centers.php`, {
                        method: `PATCH`,
                        headers: {
                            "Content-Type": `application/json`,
                            Accept: `application/json`
                        },
                        body: JSON.stringify({
                            id: e.id,
                            version: e.version,
                            active: !e.active
                        })
                    }),
                    n = await t.json();
                if (!t.ok) {
                    B(n.error || `No se pudo cambiar el centro`);
                    return
                }
                await Pr(e.customerId), B(n.center.active ? `Centro activado` : `Centro desactivado`)
            }, m = async () => {
                if (!R.id && !R.assetClass) {
                    B(`La clase del activo es obligatoria.`);
                    return
                }
                if (Kn.some(e => e.id !== R.id && e.centerId === R.centerId && e.code.trim().toLocaleLowerCase() === R.code.trim().toLocaleLowerCase())) {
                    B(`La referencia ya existe en este cliente y centro`);
                    return
                }
                let e = await M(`/api/assets.php`, {
                        method: R.id ? `PUT` : `POST`,
                        headers: {
                            "Content-Type": `application/json`,
                            Accept: `application/json`
                        },
                        body: JSON.stringify(R)
                    }),
                    t = await e.json();
                if (!e.ok) {
                    B(t.error || `No se pudo guardar el activo`);
                    return
                }
                Zn(!1), $n(0), await Ir(R.customerId), B(`Guardado`)
            }, h = async e => {
                let t = await M(`/api/assets.php`, {
                        method: `PATCH`,
                        headers: {
                            "Content-Type": `application/json`,
                            Accept: `application/json`
                        },
                        body: JSON.stringify({
                            id: e.id,
                            version: e.version,
                            active: !e.active
                        })
                    }),
                    n = await t.json();
                if (!t.ok) {
                    B(n.error || `No se pudo cambiar el activo`);
                    return
                }
                await Ir(e.customerId), B(n.asset.active ? `Activo activado` : `Activo desactivado`)
            };
        return (0, k.jsxs)(`div`, {
            className: `page`,
            children: [(0, k.jsx)(PageHeader, {
                eyebrow: `Expediente técnico`,
                title: An ? `Nuevo expediente` : L?.name || `Expedientes`,
                sub: An ? `¿Cómo quieres crear el expediente?` : L ? `${L.nif||`Sin NIF/CIF`} · ${L.address||`Sin dirección`}` : `Clientes y contactos con su estructura técnica, activos e histórico real.`,
                actions: (0, k.jsxs)(k.Fragment, {
                    children: [!An && F && (0, k.jsx)(`button`, {
                        className: `primary`,
                        onClick: l,
                        children: `Nuevo expediente`
                    }), An && (0, k.jsxs)(`button`, {
                        onClick: u,
                        children: [(0, k.jsx)(ee, {}), `Volver a Expedientes`]
                    })]
                })
            }), !An && !L && (0, k.jsxs)(`section`, {
                className: `card compact order-section`,
                children: [(0, k.jsx)(V, {
                    title: `Buscar expediente`,
                    sub: `Búsqueda por contiene; la selección nunca es automática.`
                }), (0, k.jsx)(`div`, {
                    className: `order-toolbar`,
                    children: (0, k.jsxs)(`label`, {
                        children: [(0, k.jsx)(he, {}), (0, k.jsx)(`input`, {
                            value: Cn,
                            onChange: e => wn(e.target.value),
                            placeholder: `Código, nombre, NIF/CIF, teléfono o email…`
                        })]
                    })
                }), (0, k.jsxs)(`div`, {
                    className: `doclist`,
                    children: [xn.map(e => (0, k.jsxs)(`button`, {
                        className: `order-row`,
                        onClick: () => {
                            Tn(e), $n(0), Dn(e), kn(!1), wn(``)
                        },
                        children: [(0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: e.code || `EXP-${String(e.id).padStart(5,`0`)}`
                            }), (0, k.jsx)(`small`, {
                                children: e.nif || `Sin NIF/CIF`
                            })]
                        }), (0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: e.name
                            }), (0, k.jsxs)(`small`, {
                                children: [e.origin === `GOLDEN` ? `Vinculado a Golden` : `Local / no vinculado`, ` · `, e.phone || e.email || e.city || `Sin contacto`]
                            })]
                        }), (0, k.jsx)(`em`, {
                            className: `order-status ${e.active?`doing`:`done`}`,
                            children: e.active ? `Activo` : `Inactivo`
                        }), (0, k.jsx)(S, {})]
                    }, e.id)), !xn.length && (0, k.jsx)(`small`, {
                        children: `Sin resultados`
                    })]
                })]
            }), An && (0, k.jsxs)(`section`, {
                className: `card compact order-section`,
                children: [(0, k.jsx)(V, {
                    title: `Nuevo expediente`,
                    sub: `Elige primero si el cliente ya existe en OPAT o si debe darse de alta como contacto local.`
                }), An === `choose` && (0, k.jsxs)(`div`, {
                    className: `doclist`,
                    children: [(0, k.jsxs)(`button`, {
                        className: `order-row`,
                        onClick: () => jn(`existing`),
                        children: [(0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: `Cliente existente en OPAT`
                            }), (0, k.jsx)(`small`, {
                                children: `Buscar y abrir su expediente técnico sin crear ni duplicar el cliente.`
                            })]
                        }), (0, k.jsx)(S, {})]
                    }), (0, k.jsxs)(`button`, {
                        className: `order-row`,
                        onClick: () => {
                            Tn(null), Dn(Fe()), kn(!0), jn(`local`)
                        },
                        children: [(0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: `Nuevo cliente/contacto local`
                            }), (0, k.jsx)(`small`, {
                                children: `Crear un cliente local nuevo, sin exigir código Golden.`
                            })]
                        }), (0, k.jsx)(S, {})]
                    })]
                }), An === `existing` && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(V, {
                        title: `Seleccionar cliente existente`,
                        sub: `Búsqueda por contiene en código, nombre/razón social o NIF/CIF. Debes seleccionar un resultado expresamente.`
                    }), (0, k.jsx)(`div`, {
                        className: `order-toolbar`,
                        children: (0, k.jsxs)(`label`, {
                            children: [(0, k.jsx)(he, {}), (0, k.jsx)(`input`, {
                                value: Mn,
                                onChange: e => Nn(e.target.value),
                                placeholder: `Código, nombre o NIF/CIF…`,
                                autoFocus: !0
                            })]
                        })
                    }), (0, k.jsxs)(`div`, {
                        className: `doclist`,
                        children: [Pn.map(e => (0, k.jsxs)(`button`, {
                            className: `order-row`,
                            onClick: () => Ln(e.id),
                            children: [(0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: e.code || `EXP-${String(e.id).padStart(5,`0`)}`
                                }), (0, k.jsx)(`small`, {
                                    children: e.nif || `Sin NIF/CIF`
                                })]
                            }), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: e.name
                                }), (0, k.jsx)(`small`, {
                                    children: e.id === In ? `Seleccionado explícitamente` : `Seleccionar cliente`
                                })]
                            }), (0, k.jsx)(`em`, {
                                className: `order-status ${e.id===In?`doing`:`done`}`,
                                children: e.id === In ? `Seleccionado` : `Elegir`
                            })]
                        }, e.id)), !Pn.length && (0, k.jsx)(`small`, {
                            children: `Sin resultados`
                        })]
                    }), In > 0 && (0, k.jsxs)(`div`, {
                        className: `notice`,
                        children: [(0, k.jsx)(`b`, {
                            children: `Este cliente ya tiene expediente técnico en OPAT.`
                        }), (0, k.jsx)(`small`, {
                            children: `Se abrirá la ficha asociada al mismo customer_id. No se creará ningún registro nuevo.`
                        })]
                    }), (0, k.jsxs)(`div`, {
                        className: `close-actions`,
                        children: [(0, k.jsx)(`button`, {
                            onClick: () => jn(`choose`),
                            children: `Atrás`
                        }), (0, k.jsx)(`button`, {
                            className: `primary`,
                            disabled: !In,
                            onClick: d,
                            children: `Abrir expediente existente`
                        })]
                    })]
                }), An === `choose` && (0, k.jsx)(`div`, {
                    className: `close-actions`,
                    children: (0, k.jsx)(`button`, {
                        onClick: u,
                        children: `Cancelar`
                    })
                })]
            }), On && (0, k.jsxs)(`section`, {
                className: `card compact order-section`,
                children: [(0, k.jsx)(V, {
                    title: En.id ? `Datos generales` : `Alta de expediente local`,
                    sub: `Sólo el nombre es obligatorio; Golden no se consulta en esta fase.`
                }), (0, k.jsxs)(`div`, {
                    className: `order-grid`,
                    children: [(0, k.jsxs)(`label`, {
                        children: [`Código interno (opcional)`, (0, k.jsx)(`input`, {
                            value: En.code,
                            onChange: e => c(`code`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Razón social / nombre`, (0, k.jsx)(`input`, {
                            value: En.name,
                            onChange: e => c(`name`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`NIF/CIF`, (0, k.jsx)(`input`, {
                            value: En.nif,
                            onChange: e => c(`nif`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Contacto`, (0, k.jsx)(`input`, {
                            value: En.contact,
                            onChange: e => c(`contact`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        className: `wide`,
                        children: [`Dirección`, (0, k.jsx)(`input`, {
                            value: En.address,
                            onChange: e => c(`address`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Código postal`, (0, k.jsx)(`input`, {
                            value: En.postalCode,
                            onChange: e => c(`postalCode`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Población`, (0, k.jsx)(`input`, {
                            value: En.city,
                            onChange: e => c(`city`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Provincia`, (0, k.jsx)(`input`, {
                            value: En.province,
                            onChange: e => c(`province`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        children: [`Móvil`, (0, k.jsx)(`input`, {
                            value: En.phone,
                            onChange: e => c(`phone`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        className: `wide`,
                        children: [`Email`, (0, k.jsx)(`input`, {
                            type: `email`,
                            value: En.email,
                            onChange: e => c(`email`, e.target.value)
                        })]
                    }), (0, k.jsxs)(`label`, {
                        className: `wide`,
                        children: [`Observaciones`, (0, k.jsx)(`textarea`, {
                            value: En.notes,
                            onChange: e => c(`notes`, e.target.value)
                        })]
                    })]
                }), (0, k.jsxs)(`div`, {
                    className: `close-actions`,
                    children: [(0, k.jsx)(`button`, {
                        onClick: () => {
                            kn(!1), An === `local` && jn(`choose`)
                        },
                        children: `Cancelar`
                    }), (0, k.jsx)(`button`, {
                        "data-session-save": `customer-file`,
                        className: `primary`,
                        onClick: o,
                        children: `Guardar`
                    })]
                })]
            }), L && !On && !An && (0, k.jsxs)(k.Fragment, {
                children: [(0, k.jsxs)(`section`, {
                    className: `clienthero`,
                    children: [(0, k.jsx)(`span`, {
                        className: `initials`,
                        children: L.name.split(` `).map(e => e[0]).slice(0, 2).join(``).toUpperCase()
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsx)(`b`, {
                            children: L.contact || `Sin contacto`
                        }), (0, k.jsxs)(`small`, {
                            children: [L.code, ` · `, L.city]
                        }), (0, k.jsxs)(`a`, {
                            children: [L.email || `Sin email`, ` · `, L.phone || `Sin móvil`]
                        })]
                    }), (0, k.jsxs)(`div`, {
                        children: [(0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`small`, {
                                children: `Origen`
                            }), (0, k.jsx)(`b`, {
                                children: L.origin === `GOLDEN` ? `Vinculado a Golden` : `Local / no vinculado`
                            })]
                        }), (0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`small`, {
                                children: `Estado`
                            }), (0, k.jsx)(`b`, {
                                children: L.active ? `Activo` : `Inactivo`
                            })]
                        }), (0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`small`, {
                                children: `Centros`
                            }), (0, k.jsx)(`b`, {
                                children: Rn.length
                            })]
                        }), (0, k.jsxs)(`div`, {
                            className: `clienthero-actions`,
                            children: [(0, k.jsx)(`button`, {
                                disabled: !0,
                                title: `Disponible cuando exista el conector oficial con Golden`,
                                children: `Vincular con cliente de Golden`
                            }), F && (0, k.jsx)(`button`, {
                                onClick: () => {
                                    Dn(L), kn(!0)
                                },
                                children: `Editar`
                            }), F && (0, k.jsx)(`button`, {
                                className: L.active ? `danger` : void 0,
                                onClick: () => s(L),
                                children: L.active ? `Desactivar` : `Activar`
                            }), (0, k.jsx)(`button`, {
                                onClick: () => {
                                    Tn(null), $n(0), Dn(Fe()), kn(!1), wn(``)
                                },
                                children: `Cambiar expediente`
                            })]
                        })]
                    })]
                }), (0, k.jsxs)(`section`, {
                    ref: assetWorkspaceRef,
                    className: `card compact order-section`,
                    children: [!Xn && !n && (0, k.jsxs)(`div`, {
                        className: `lineshead`,
                        children: [(0, k.jsx)(V, {
                            title: `Centros / Sedes`,
                            sub: `Vinculados exclusivamente a este expediente`
                        }), F && (0, k.jsxs)(`button`, {
                            className: `primary`,
                            onClick: () => {
                                Un(Ie(L.id)), Gn(!0)
                            },
                            children: [(0, k.jsx)(D, {}), `Nuevo centro`]
                        })]
                    }), Rn.map(e => (0, k.jsxs)(`div`, {
                        className: `settingrow`,
                        children: [(0, k.jsxs)(`span`, {
                            children: [(0, k.jsxs)(`b`, {
                                children: [e.code ? `${e.code} · ` : ``, e.name]
                            }), (0, k.jsxs)(`small`, {
                                children: [e.address, ` · `, e.city, ` · `, e.active ? `Activo` : `Inactivo`]
                            })]
                        }), F && (0, k.jsxs)(`div`, {
                            className: `entity-actions`,
                            children: [(0, k.jsx)(`button`, {
                                onClick: () => {
                                    Un(e), Gn(!0)
                                },
                                children: `Editar`
                            }), (0, k.jsx)(`button`, {
                                className: e.active ? `danger` : void 0,
                                onClick: () => p(e),
                                children: e.active ? `Desactivar` : `Activar`
                            })]
                        })]
                    }, e.id)), Wn && (0, k.jsxs)(`div`, {
                        className: `order-grid`,
                        children: [(0, k.jsxs)(`label`, {
                            children: [`Referencia`, (0, k.jsx)(`input`, {
                                value: Hn.code,
                                onChange: e => Un(t => ({
                                    ...t,
                                    code: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Nombre`, (0, k.jsx)(`input`, {
                                value: Hn.name,
                                onChange: e => Un(t => ({
                                    ...t,
                                    name: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Dirección`, (0, k.jsx)(`input`, {
                                value: Hn.address,
                                onChange: e => Un(t => ({
                                    ...t,
                                    address: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Código postal`, (0, k.jsx)(`input`, {
                                value: Hn.postalCode,
                                onChange: e => Un(t => ({
                                    ...t,
                                    postalCode: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Población`, (0, k.jsx)(`input`, {
                                value: Hn.city,
                                onChange: e => Un(t => ({
                                    ...t,
                                    city: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Provincia`, (0, k.jsx)(`input`, {
                                value: Hn.province,
                                onChange: e => Un(t => ({
                                    ...t,
                                    province: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Observaciones`, (0, k.jsx)(`textarea`, {
                                value: Hn.notes,
                                onChange: e => Un(t => ({
                                    ...t,
                                    notes: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`div`, {
                            className: `close-actions wide`,
                            children: [(0, k.jsx)(`button`, {
                                onClick: () => Gn(!1),
                                children: `Cancelar`
                            }), (0, k.jsx)(`button`, {
                                "data-session-save": `center`,
                                className: `primary`,
                                onClick: f,
                                children: `Guardar`
                            })]
                        })]
                    })]
                }), (0, k.jsxs)(`section`, {
                    className: `card compact order-section`,
                    children: [(0, k.jsxs)(`div`, {
                        className: `lineshead`,
                        children: [(0, k.jsx)(V, {
                            title: `Activos / equipos`,
                            sub: `Inventario del cliente y sus centros`
                        }), F && (0, k.jsxs)(`button`, {
                            className: `primary`,
                            disabled: !Rn.some(e => e.active),
                            onClick: () => {
                                let e = Rn.find(e => e.active);
                                $n(0), z(Le(L.id, e?.id || 0)), Zn(!0), focusAssetWorkspace()
                            },
                            children: [(0, k.jsx)(D, {}), `Nuevo activo`]
                        })]
                    }), !Xn && !n && (0, k.jsxs)(`div`, {
                        className: `asset-filters`,
                        children: [(0, k.jsxs)(`label`, {
                            children: [`Centro`, (0, k.jsxs)(`select`, {
                                value: assetCenterFilter,
                                onChange: e => setAssetCenterFilter(Number(e.target.value)),
                                children: [(0, k.jsxs)(`option`, {
                                    value: 0,
                                    children: [`Todos (`, countAssetsByCenter(Kn), `)`]
                                }), Rn.map(e => (0, k.jsxs)(`option`, {
                                    value: e.id,
                                    children: [e.name, ` (`, countAssetsByCenter(Kn, e.id), `)`]
                                }, e.id))]
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Clase`, (0, k.jsxs)(`select`, {
                                value: assetClassFilter,
                                onChange: e => setAssetClassFilter(e.target.value),
                                children: [(0, k.jsxs)(`option`, {
                                    value: ASSET_CLASS.ALL,
                                    children: [`Todos (`, countAssetsByClass(Kn), `)`]
                                }), (0, k.jsxs)(`option`, {
                                    value: ASSET_CLASS.EQUIPMENT,
                                    children: [`Equipos (`, countAssetsByClass(Kn, ASSET_CLASS.EQUIPMENT), `)`]
                                }), (0, k.jsxs)(`option`, {
                                    value: ASSET_CLASS.PERIPHERAL,
                                    children: [`Periféricos (`, countAssetsByClass(Kn, ASSET_CLASS.PERIPHERAL), `)`]
                                }), (0, k.jsxs)(`option`, {
                                    value: ASSET_CLASS.UNCLASSIFIED,
                                    children: [`Sin clasificar (`, countAssetsByClass(Kn, ASSET_CLASS.UNCLASSIFIED), `)`]
                                })]
                            })]
                        })]
                    }), !Xn && !n && filteredClientAssets.map(e => (0, k.jsxs)(`div`, {
                        className: `settingrow`,
                        children: [(0, k.jsxs)(`span`, {
                            children: [(0, k.jsxs)(`b`, {
                                children: [e.code, ` · `, e.name]
                            }), (0, k.jsxs)(`small`, {
                                children: [Rn.find(t => t.id === e.centerId)?.name || `Sin centro`, ` · `, e.assetClass === ASSET_CLASS.EQUIPMENT ? `Equipo` : e.assetClass === ASSET_CLASS.PERIPHERAL ? `Periférico` : `Sin clasificar`, ` · Serie `, e.serial || `Sin datos`, ` · `, e.active ? `Activo` : `Inactivo`]
                            })]
                        }), (0, k.jsxs)(`div`, {
                            className: `entity-actions`,
                            children: [(0, k.jsx)(`button`, {
                                onClick: () => {
                                    Zn(!1), $n(e.id), focusAssetWorkspace()
                                },
                                children: `Ver activo`
                            }), F && (0, k.jsxs)(k.Fragment, {
                                children: [(0, k.jsx)(`button`, {
                                    onClick: () => {
                                        $n(e.id), z(e), Zn(!0), focusAssetWorkspace()
                                    },
                                    children: `Editar`
                                }), (0, k.jsx)(`button`, {
                                    onClick: () => {
                                        $n(0), z(duplicateAssetDraft(e)), Zn(!0), focusAssetWorkspace()
                                    },
                                    children: `Duplicar activo`
                                }), (0, k.jsx)(`button`, {
                                    className: e.active ? `danger` : void 0,
                                    onClick: () => h(e),
                                    children: e.active ? `Desactivar` : `Activar`
                                }), !assetHasHistory(e) && (0, k.jsx)(`button`, {
                                    className: `danger`,
                                    onClick: () => {
                                        setAssetDeleteCandidate(e), N(`delete-asset`)
                                    },
                                    children: `Eliminar activo`
                                })]
                            })]
                        })]
                    }, e.id)), Xn && (0, k.jsxs)(k.Fragment, {
                        children: [(0, k.jsxs)(`div`, {
                            className: `lineshead`,
                            children: [(0, k.jsx)(V, {
                                title: R.id ? `Editar activo · ${R.name}` : R.duplicatedFrom ? `Nuevo activo · copia de ${R.duplicatedFrom}` : `Nuevo activo`,
                                sub: R.id ? `Modifica los datos del activo seleccionado.` : R.duplicatedFrom ? `Revisa los datos copiados y completa la nueva referencia y el número de serie.` : `Completa la ficha del nuevo activo.`
                            }), (0, k.jsx)(`button`, {
                                onClick: () => {
                                    Zn(!1), $n(0)
                                },
                                children: `Volver a Activos`
                            })]
                        }), (0, k.jsxs)(`div`, {
                        className: `order-grid`,
                        children: [(0, k.jsxs)(`label`, {
                            children: [`Centro`, (0, k.jsx)(`select`, {
                                value: R.centerId,
                                onChange: e => z(t => ({
                                    ...t,
                                    centerId: Number(e.target.value)
                                })),
                                children: Rn.filter(e => e.active || e.id === R.centerId).map(e => (0, k.jsx)(`option`, {
                                    value: e.id,
                                    children: e.name
                                }, e.id))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [R.id ? `Clase` : `Clase *`, (0, k.jsxs)(`select`, {
                                value: R.assetClass || ``,
                                onChange: e => z(t => ({
                                    ...t,
                                    assetClass: e.target.value
                                })),
                                children: [(0, k.jsx)(`option`, {
                                    value: ``,
                                    children: R.id ? `Sin clasificar` : `Seleccionar clase…`
                                }), (0, k.jsx)(`option`, {
                                    value: ASSET_CLASS.EQUIPMENT,
                                    children: `Equipo`
                                }), (0, k.jsx)(`option`, {
                                    value: ASSET_CLASS.PERIPHERAL,
                                    children: `Periférico`
                                })]
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Referencia`, (0, k.jsx)(`input`, {
                                value: R.code,
                                onChange: e => z(t => ({
                                    ...t,
                                    code: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Nombre del activo`, (0, k.jsx)(`input`, {
                                value: R.name,
                                onChange: e => z(t => ({
                                    ...t,
                                    name: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Nombre comercial`, (0, k.jsx)(`input`, {
                                value: R.commercialName,
                                onChange: e => z(t => ({
                                    ...t,
                                    commercialName: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Número de serie`, (0, k.jsx)(`input`, {
                                value: R.serial,
                                onChange: e => z(t => ({
                                    ...t,
                                    serial: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Tipo`, (0, k.jsx)(EditableCombobox, {
                                ariaLabel: `Tipo`,
                                value: R.type,
                                options: Be(Re, Kn, `type`),
                                onChange: e => z(t => ({
                                    ...t,
                                    type: e
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Marca`, (0, k.jsx)(EditableCombobox, {
                                ariaLabel: `Marca`,
                                value: R.brand,
                                options: Be(ze, Kn, `brand`),
                                onChange: e => z(t => ({
                                    ...t,
                                    brand: e
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Ubicación / oficina`, (0, k.jsx)(`input`, {
                                value: R.location,
                                onChange: e => z(t => ({
                                    ...t,
                                    location: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Características`, (0, k.jsx)(`textarea`, {
                                value: R.features,
                                onChange: e => z(t => ({
                                    ...t,
                                    features: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`div`, {
                            className: `asset-updated wide`,
                            children: [(0, k.jsx)(`small`, {
                                children: `Última actualización`
                            }), (0, k.jsx)(`b`, {
                                children: Ve(R.updatedOn)
                            }), (0, k.jsx)(`span`, {
                                children: `Se asigna automáticamente al guardar.`
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Proveedor`, (0, k.jsx)(`input`, {
                                value: R.supplier,
                                onChange: e => z(t => ({
                                    ...t,
                                    supplier: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Vendedor`, (0, k.jsx)(`input`, {
                                value: R.seller,
                                onChange: e => z(t => ({
                                    ...t,
                                    seller: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Garantía desde`, (0, k.jsx)(`input`, {
                                type: `date`,
                                value: R.warrantyFrom,
                                onChange: e => z(t => ({
                                    ...t,
                                    warrantyFrom: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Garantía hasta`, (0, k.jsx)(`input`, {
                                type: `date`,
                                value: R.warrantyTo,
                                onChange: e => z(t => ({
                                    ...t,
                                    warrantyTo: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Dominio / grupo`, (0, k.jsx)(`input`, {
                                value: R.domainGroup,
                                onChange: e => z(t => ({
                                    ...t,
                                    domainGroup: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`div`, {
                            children: [(0, k.jsx)(`small`, {
                                children: `ID externo futuro`
                            }), (0, k.jsx)(`b`, {
                                children: R.externalId || `Sin asignar`
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Observaciones`, (0, k.jsx)(`textarea`, {
                                value: R.notes,
                                onChange: e => z(t => ({
                                    ...t,
                                    notes: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`div`, {
                            className: `close-actions wide`,
                            children: [(0, k.jsx)(`button`, {
                                onClick: () => {
                                    Zn(!1), $n(0)
                                },
                                children: `Cancelar`
                            }), (0, k.jsx)(`button`, {
                                "data-session-save": `asset`,
                                className: `primary`,
                                onClick: m,
                                children: `Guardar`
                            })]
                        })]
                    })]
                    }), !Xn && n && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsxs)(`div`, {
                        className: `lineshead`,
                        children: [(0, k.jsx)(V, {
                            title: `Activo · ${n.name}`,
                            sub: `${n.brand||`Sin marca`} · ${n.type||`Sin tipo`} · Serie ${n.serial||`Sin datos`}`
                        }), (0, k.jsxs)(`div`, {
                            className: `asset-actions`,
                            children: [F && (0, k.jsx)(`button`, {
                                onClick: () => {
                                    $n(0), z(duplicateAssetDraft(n)), Zn(!0), focusAssetWorkspace()
                                },
                                children: `Duplicar activo`
                            }), F && !assetHasHistory(n) && (0, k.jsx)(`button`, {
                                className: `danger`,
                                onClick: () => {
                                    setAssetDeleteCandidate(n), N(`delete-asset`)
                                },
                                children: `Eliminar activo`
                            }), (0, k.jsx)(`button`, {
                                onClick: () => $n(0),
                                children: `Volver a Activos`
                            })]
                        })]
                    }), (0, k.jsxs)(`div`, {
                        className: `order-grid asset-readonly`,
                        children: [(0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Centro` }), (0, k.jsx)(`b`, { children: Rn.find(e => e.id === n.centerId)?.name || `Sin centro` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Clase` }), (0, k.jsx)(`b`, { children: n.assetClass === ASSET_CLASS.EQUIPMENT ? `Equipo` : n.assetClass === ASSET_CLASS.PERIPHERAL ? `Periférico` : `Sin clasificar` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Referencia` }), (0, k.jsx)(`b`, { children: n.code || `Sin referencia` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Nombre del activo` }), (0, k.jsx)(`b`, { children: n.name || `Sin nombre` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Nombre comercial` }), (0, k.jsx)(`b`, { children: n.commercialName || `Sin datos` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Número de serie` }), (0, k.jsx)(`b`, { children: n.serial || `Sin datos` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Tipo` }), (0, k.jsx)(`b`, { children: n.type || `Sin tipo` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Marca` }), (0, k.jsx)(`b`, { children: n.brand || `Sin marca` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Ubicación / oficina` }), (0, k.jsx)(`b`, { children: n.location || `Sin ubicación` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Proveedor / vendedor` }), (0, k.jsx)(`b`, { children: [n.supplier, n.seller].filter(Boolean).join(` · `) || `Sin datos` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Dominio / grupo` }), (0, k.jsx)(`b`, { children: n.domainGroup || `Sin datos` })] }), (0, k.jsxs)(`div`, { children: [(0, k.jsx)(`small`, { children: `Garantía` }), (0, k.jsxs)(`b`, { children: [n.warrantyFrom || `sin fecha`, ` → `, n.warrantyTo || `sin fecha`] })] }), (0, k.jsxs)(`div`, { className: `wide`, children: [(0, k.jsx)(`small`, { children: `Características` }), (0, k.jsx)(`p`, { children: n.features || `Sin características registradas.` })] }), (0, k.jsxs)(`div`, { className: `wide`, children: [(0, k.jsx)(`small`, { children: `Observaciones` }), (0, k.jsx)(`p`, { children: n.notes || `Sin observaciones.` })] })]
                    })]
                    })]
                }), (0, k.jsxs)(`section`, {
                    className: `card compact order-section`,
                    children: [(0, k.jsx)(V, {
                        title: `Histórico técnico / Órdenes`,
                        sub: n ? `Sólo órdenes relacionadas con el activo seleccionado.` : `Histórico global real del expediente.`
                    }), (0, k.jsxs)(`div`, {
                        className: `doclist`,
                        children: [a.map(t => (0, k.jsxs)(`button`, {
                            className: `order-row`,
                            onClick: () => e(t),
                            children: [(0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: t.number
                                }), (0, k.jsxs)(`small`, {
                                    children: [t.date, ` · `, t.status]
                                })]
                            }), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: t.incident || `Sin incidencia`
                                }), (0, k.jsxs)(`small`, {
                                    children: [t.action || `Sin actuación`, ` · `, [t.mainTech, ...t.extraTechs].filter(Boolean).join(`, `) || `Sin técnico`]
                                })]
                            }), (0, k.jsx)(`span`, {
                                children: (0, k.jsx)(`small`, {
                                    children: t.materials.map(e => `${e.description} (${e.qty})`).join(`, `) || `Sin materiales`
                                })
                            }), (0, k.jsx)(S, {})]
                        }, t.dbId || t.id)), !a.length && (0, k.jsx)(`small`, {
                            children: `Sin órdenes relacionadas.`
                        })]
                    })]
                })]
            })]
        })
    }

    function gi() {
        let e = Dt,
            t = Ot;
        return (0, k.jsxs)(`div`, {
            className: `page`,
            children: [(0, k.jsx)(PageHeader, {
                eyebrow: `Sólo Administrador`,
                title: `Configuración`,
                sub: `Parámetros de validación del POC.`
            }), (0, k.jsxs)(`div`, {
                className: `settingsgrid`,
                children: [(0, k.jsxs)(`section`, {
                    className: `card`,
                    children: [(0, k.jsxs)(`div`, {
                        className: `lineshead`,
                        children: [(0, k.jsx)(V, {
                            title: `Usuarios y roles`
                        }), (0, k.jsxs)(`button`, {
                            className: `primary`,
                            onClick: () => {
                                ar($e()), lr(!1), sr(!0)
                            },
                            children: [(0, k.jsx)(D, {}), `Nuevo usuario`]
                        })]
                    }), nr.map(e => (0, k.jsxs)(`div`, {
                        className: `settingrow`,
                        children: [(0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: e.name
                            }), (0, k.jsxs)(`small`, {
                                children: [e.email, ` · `, e.role, ` · `, e.active ? `Activo` : `Inactivo`, ` · 2FA email `, e.twoFactorEnabled ? `activado` : `desactivado`, e.lastLoginAt ? ` · Última entrada ${new Date(e.lastLoginAt).toLocaleString(`es-ES`)}` : ``]
                            })]
                        }), (0, k.jsx)(`button`, {
                            onClick: () => {
                                ar({
                                    ...e,
                                    password: ``
                                }), lr(!1), dr(``), sr(!0)
                            },
                            children: `Editar`
                        })]
                    }, e.id)), or && (0, k.jsxs)(`div`, {
                        className: `order-grid`,
                        children: [(0, k.jsxs)(`label`, {
                            children: [`Nombre`, (0, k.jsx)(`input`, {
                                value: ir.name,
                                onChange: e => ar(t => ({
                                    ...t,
                                    name: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Email / login`, (0, k.jsx)(`input`, {
                                type: `email`,
                                value: ir.email,
                                onChange: e => ar(t => ({
                                    ...t,
                                    email: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Rol`, (0, k.jsxs)(`select`, {
                                value: ir.role,
                                onChange: e => ar(t => ({
                                    ...t,
                                    role: e.target.value
                                })),
                                children: [(0, k.jsx)(`option`, {
                                    children: `Administrador`
                                }), (0, k.jsx)(`option`, {
                                    children: `Operador`
                                })]
                            })]
                        }), !ir.id && (0, k.jsxs)(`label`, {
                            children: [`Contraseña inicial`, (0, k.jsx)(`input`, {
                                type: `password`,
                                autoComplete: `new-password`,
                                value: ir.password,
                                onChange: e => ar(t => ({
                                    ...t,
                                    password: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `switch`,
                            children: [(0, k.jsx)(`input`, {
                                type: `checkbox`,
                                checked: ir.active,
                                onChange: e => ar(t => ({
                                    ...t,
                                    active: e.target.checked
                                }))
                            }), (0, k.jsx)(`span`, {
                                children: `Usuario activo`
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `switch`,
                            children: [(0, k.jsx)(`input`, {
                                type: `checkbox`,
                                checked: ir.twoFactorEnabled,
                                onChange: e => ar(t => ({
                                    ...t,
                                    twoFactorEnabled: e.target.checked
                                }))
                            }), (0, k.jsx)(`span`, {
                                children: `2FA mediante código por email`
                            })]
                        }), (0, k.jsxs)(`div`, {
                            className: `close-actions wide`,
                            children: [(0, k.jsx)(`button`, {
                                onClick: () => {
                                    sr(!1), lr(!1)
                                },
                                children: `Cancelar`
                            }), ir.id > 0 && (0, k.jsx)(`button`, {
                                onClick: () => lr(e => !e),
                                children: `Cambiar contraseña`
                            }), (0, k.jsx)(`button`, {
                                className: `primary`,
                                disabled: !ir.name.trim() || !ir.email.trim() || !ir.id && ir.password.length < 12,
                                onClick: () => void Or(),
                                children: `Guardar`
                            })]
                        }), cr && (0, k.jsxs)(k.Fragment, {
                            children: [(0, k.jsxs)(`label`, {
                                className: `wide`,
                                children: [`Nueva contraseña`, (0, k.jsx)(`input`, {
                                    type: `password`,
                                    autoComplete: `new-password`,
                                    value: ur,
                                    onChange: e => dr(e.target.value)
                                })]
                            }), (0, k.jsxs)(`div`, {
                                className: `close-actions wide`,
                                children: [(0, k.jsx)(`button`, {
                                    onClick: () => {
                                        lr(!1), dr(``)
                                    },
                                    children: `Cancelar`
                                }), (0, k.jsx)(`button`, {
                                    className: `primary`,
                                    disabled: ur.length < 12,
                                    onClick: () => void kr(),
                                    children: `Actualizar contraseña`
                                })]
                            })]
                        })]
                    }), (0, k.jsxs)(`label`, {
                        className: `switch`,
                        children: [(0, k.jsx)(`input`, {
                            type: `checkbox`,
                            checked: F,
                            onChange: e => gt(e.target.checked)
                        }), (0, k.jsx)(`span`, {
                            children: `Probar vista con permiso para costes y márgenes`
                        })]
                    })]
                }), (0, k.jsxs)(`section`, {
                    className: `card`,
                    children: [(0, k.jsx)(V, {
                        title: `Almacén`
                    }), (0, k.jsxs)(`label`, {
                        className: `field`,
                        children: [`Almacén predeterminado`, (0, k.jsxs)(`select`, {
                            value: kt,
                            onChange: e => At(e.target.value),
                            children: [(0, k.jsx)(`option`, {
                                children: `01`
                            }), (0, k.jsx)(`option`, {
                                children: `02`
                            })]
                        })]
                    })]
                }), (0, k.jsxs)(`section`, {
                    className: `card`,
                    children: [(0, k.jsx)(V, {
                        title: `Seguridad y sesión`
                    }), (0, k.jsx)(`div`, {
                        className: `settingrow`,
                        children: (0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: `2FA por email`
                            }), (0, k.jsx)(`small`, {
                                children: `Configurable individualmente en Usuarios y roles`
                            })]
                        })
                    }), (0, k.jsxs)(`label`, {
                        className: `field`,
                        children: [`Inactividad antes de cerrar sesión`, (0, k.jsxs)(`select`, {
                            value: e,
                            onChange: e => t(e.target.value),
                            children: [(0, k.jsx)(`option`, {
                                value: `15`,
                                children: `15 minutos`
                            }), (0, k.jsx)(`option`, {
                                value: `30`,
                                children: `30 minutos`
                            }), (0, k.jsx)(`option`, {
                                value: `60`,
                                children: `60 minutos`
                            })]
                        })]
                    })]
                }), (0, k.jsxs)(`section`, {
                    className: `card`,
                    children: [(0, k.jsx)(V, {
                        title: `Notificaciones y sincronización`
                    }), (0, k.jsxs)(`label`, {
                        className: `field`,
                        children: [`Copia oculta (CCO) de Órdenes de Trabajo`, (0, k.jsx)(`input`, { type: `email`, value: workOrderMailCc, onChange: e => setWorkOrderMailCc(e.target.value) })]
                    }), (0, k.jsx)(`button`, { className: `primary work-order-cc-save`, onClick: () => void saveWorkOrderMailCc(), children: `Guardar CCO de Órdenes de Trabajo` }), (0, k.jsxs)(`label`, {
                        className: `switch`,
                        children: [(0, k.jsx)(`input`, {
                            type: `checkbox`,
                            defaultChecked: !0
                        }), (0, k.jsx)(`span`, {
                            children: `Avisos internos del portal`
                        })]
                    }), (0, k.jsxs)(`label`, {
                        className: `switch`,
                        children: [(0, k.jsx)(`input`, {
                            type: `checkbox`
                        }), (0, k.jsx)(`span`, {
                            children: `Email (sólo concepto visual)`
                        })]
                    }), (0, k.jsx)(`div`, {
                        className: `settingrow`,
                        children: (0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: `Sistema central → Web`
                            }), (0, k.jsx)(`small`, {
                                children: `Desactivado · simulación`
                            })]
                        })
                    }), (0, k.jsx)(`div`, {
                        className: `settingrow`,
                        children: (0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: `Web → Sistema central`
                            }), (0, k.jsx)(`small`, {
                                children: `Desactivado · simulación`
                            })]
                        })
                    })]
                }), (0, k.jsxs)(`section`, {
                    className: `card`,
                    children: [(0, k.jsx)(V, {
                        title: `Permisos de Órdenes`
                    }), [
                        [`qualityView`, `Ver Calidad`],
                        [`qualityEdit`, `Editar Calidad`],
                        [`billable`, `Ver / modificar Facturable`],
                        [`otherTechs`, `Ver órdenes de otros técnicos`],
                        [`supervision`, `Ver Resumen / Supervisión`]
                    ].map(([e, t]) => (0, k.jsxs)(`label`, {
                        className: `switch`,
                        children: [(0, k.jsx)(`input`, {
                            type: `checkbox`,
                            checked: yn[e],
                            onChange: t => bn(n => ({
                                ...n,
                                [e]: t.target.checked
                            }))
                        }), (0, k.jsx)(`span`, {
                            children: t
                        })]
                    }, e))]
                })]
            })]
        })
    }

    function _i() {
        let e = mr?.lines || [],
            n = e.filter(e => !e.note).reduce((e, t) => e + A(t.qty) * A(t.price) * (1 - A(t.discount) / 100), 0),
            r = e.filter(e => !e.note).reduce((e, t) => e + A(t.qty) * A(t.price) * (1 - A(t.discount) / 100) * A(t.igic) / 100, 0);
        return (0, k.jsx)(`div`, {
            className: `overlay`,
            onMouseDown: e => e.target === e.currentTarget && N(null),
            children: (0, k.jsxs)(`section`, {
                className: `dialog ${et===`article`||et===`rectificative-preview`?`wide`:``}`,
                children: [(0, k.jsx)(`button`, {
                    className: `close`,
                    onClick: () => N(null),
                    children: (0, k.jsx)(we, {})
                }), et === `delete-asset` && assetDeleteCandidate && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Activos`
                    }), (0, k.jsx)(`h2`, {
                        children: `Eliminar activo`
                    }), (0, k.jsxs)(`p`, {
                        children: [`Se eliminará definitivamente “`, assetDeleteCandidate.name, `”. Esta acción no se puede deshacer.`]
                    }), (0, k.jsxs)(`div`, {
                        className: `dialogactions`,
                        children: [(0, k.jsx)(`button`, {
                            onClick: () => {
                                setAssetDeleteCandidate(null), N(null)
                            },
                            children: `Cancelar`
                        }), (0, k.jsx)(`button`, {
                            className: `danger`,
                            onClick: () => void deleteAssetCandidate(),
                            children: `Eliminar activo`
                        })]
                    })]
                }), et === `article` && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Seleccionar artículo`
                    }), (0, k.jsx)(`h2`, {
                        children: `Buscar artículo`
                    }), (0, k.jsxs)(`label`, {
                        className: `search`,
                        children: [(0, k.jsx)(he, {}), (0, k.jsx)(`input`, {
                            autoFocus: !0,
                            value: at,
                            onChange: e => ot(e.target.value),
                            placeholder: `Contiene en código o descripción…`
                        })]
                    }), (0, k.jsx)(`div`, {
                        className: `tabs`,
                        children: [`Resultados`, `Habituales`, `Últimas ventas`].map(e => (0, k.jsx)(`button`, {
                            className: rt === e ? `active` : ``,
                            onClick: () => it(e),
                            children: e
                        }, e))
                    }), oi.map(e => (0, k.jsxs)(`div`, {
                        className: `result sale`,
                        children: [(0, k.jsx)(w, {}), (0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: e.code
                            }), (0, k.jsx)(`strong`, {
                                children: e.description
                            }), rt === `Últimas ventas` ? (0, k.jsxs)(`small`, {
                                children: [e.last, ` · Bruto `, j(e.price), ` · Dto. `, Ze(e.discount), ` `, `% · Neto `, j(e.price * (1 - e.discount / 100)), ` · IGIC`, ` `, e.igic, ` %`]
                            }) : (0, k.jsxs)(`small`, {
                                children: [e.family, ` ·`, ` `, rt === `Habituales` ? `${e.freq} ventas · ` : ``, `Stock `, e.stock, ` · Almacén `, e.warehouse]
                            })]
                        }), (0, k.jsx)(`b`, {
                            children: j(e.price)
                        }), (0, k.jsxs)(`button`, {
                            onClick: () => ii(e),
                            children: [(0, k.jsx)(D, {}), `Añadir`]
                        })]
                    }, e.code))]
                }), et === `article-master` && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Maestro de artículos`
                    }), (0, k.jsx)(`h2`, {
                        children: P.id ? `Editar artículo` : `Nuevo artículo`
                    }), (0, k.jsxs)(`div`, {
                        className: `order-grid`,
                        children: [(0, k.jsxs)(`label`, {
                            children: [`Código de artículo`, (0, k.jsx)(`input`, {
                                autoFocus: !0,
                                value: P.code,
                                onChange: e => dt(t => ({
                                    ...t,
                                    code: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Familia`, (0, k.jsx)(`input`, {
                                value: P.family,
                                onChange: e => dt(t => ({
                                    ...t,
                                    family: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            className: `wide`,
                            children: [`Descripción`, (0, k.jsx)(`input`, {
                                value: P.description,
                                onChange: e => dt(t => ({
                                    ...t,
                                    description: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Coste de referencia`, (0, k.jsx)(`input`, {
                                inputMode: `decimal`,
                                onFocus: Ye,
                                value: P.cost,
                                onChange: e => dt(t => ({
                                    ...t,
                                    cost: A(Je(e.target.value))
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`IGIC por defecto`, (0, k.jsx)(`input`, {
                                inputMode: `decimal`,
                                onFocus: Ye,
                                value: P.igic,
                                onChange: e => dt(t => ({
                                    ...t,
                                    igic: A(Je(e.target.value))
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`ID externo futuro`, (0, k.jsx)(`input`, {
                                value: P.externalId,
                                onChange: e => dt(t => ({
                                    ...t,
                                    externalId: e.target.value
                                }))
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [(0, k.jsx)(`input`, {
                                type: `checkbox`,
                                checked: P.serial,
                                onChange: e => dt(t => ({
                                    ...t,
                                    serial: e.target.checked
                                }))
                            }), ` Requiere número de serie`]
                        })]
                    }), (0, k.jsxs)(`div`, {
                        className: `close-actions`,
                        children: [P.id > 0 && (0, k.jsx)(`button`, {
                            className: P.active ? `danger` : void 0,
                            onClick: async () => {
                                let e = await M(`/api/articles.php`, {
                                        method: `PATCH`,
                                        headers: {
                                            "Content-Type": `application/json`,
                                            Accept: `application/json`
                                        },
                                        body: JSON.stringify({
                                            id: P.id,
                                            version: P.version,
                                            active: !P.active
                                        })
                                    }),
                                    t = await e.json();
                                if (!e.ok) {
                                    B(t.error || `No se pudo cambiar el artículo`);
                                    return
                                }
                                N(null), await Rr(), B(t.article.active ? `Artículo activado` : `Artículo desactivado`)
                            },
                            children: P.active ? `Desactivar` : `Activar`
                        }), (0, k.jsx)(`button`, {
                            onClick: () => N(null),
                            children: `Cancelar`
                        }), (0, k.jsx)(`button`, {
                            className: `primary`,
                            onClick: async () => {
                                let e = await M(`/api/articles.php`, {
                                        method: P.id ? `PUT` : `POST`,
                                        headers: {
                                            "Content-Type": `application/json`,
                                            Accept: `application/json`
                                        },
                                        body: JSON.stringify(P)
                                    }),
                                    t = await e.json();
                                if (!e.ok) {
                                    B(t.error || `No se pudo guardar el artículo`);
                                    return
                                }
                                N(null), await Rr(), B(`Guardado`)
                            },
                            children: `Guardar`
                        })]
                    })]
                }), et === `convert` && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Conversión parcial`
                    }), (0, k.jsxs)(`h2`, {
                        children: [`Convertir `, u.kind]
                    }), (0, k.jsx)(`p`, {
                        children: `Se propone la cantidad pendiente. La sobreentrega está permitida y queda visible.`
                    }), (0, k.jsxs)(`div`, {
                        className: `dest`,
                        children: [u.kind === `Oferta` && (0, k.jsxs)(`button`, {
                            onClick: () => void Zr(`Pedido`),
                            children: [(0, k.jsx)(E, {}), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: `Crear pedido`
                                }), (0, k.jsx)(`small`, {
                                    children: `Numeración independiente`
                                })]
                            }), (0, k.jsx)(S, {})]
                        }), (0, k.jsxs)(`button`, {
                            onClick: () => void Zr(`Albarán`),
                            children: [(0, k.jsx)(be, {}), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: `Crear albarán`
                                }), (0, k.jsx)(`small`, {
                                    children: `Numeración independiente`
                                })]
                            }), (0, k.jsx)(S, {})]
                        })]
                    }), _.map(e => (0, k.jsxs)(`div`, {
                        className: `partial`,
                        children: [(0, k.jsxs)(`span`, {
                            children: [(0, k.jsx)(`b`, {
                                children: e.description || `Línea libre`
                            }), (0, k.jsxs)(`small`, {
                                children: [`Origen `, e.qty, ` · convertida `, e.converted || `0,00`, ` · pendiente`, ` `, e.conversionPending ?? e.qty]
                            })]
                        }), !e.note && (0, k.jsx)(`input`, {
                            inputMode: `decimal`,
                            onFocus: Ye,
                            value: m[e.id] ?? `0,00`,
                            onChange: t => g(n => ({
                                ...n,
                                [e.id]: Je(t.target.value)
                            }))
                        })]
                    }, e.id))]
                }), et === `conversion-complete` && f && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Conversión completada`
                    }), (0, k.jsx)(`h2`, {
                        children: `Conversión completada`
                    }), (0, k.jsxs)(`p`, {
                        children: [`Se ha creado correctamente el documento `, f.target.number, `.`]
                    }), (0, k.jsxs)(`div`, {
                        className: `dialogactions`,
                        children: [(0, k.jsx)(`button`, {
                            onClick: () => N(null),
                            children: `Aceptar`
                        }), (0, k.jsx)(`button`, {
                            className: `primary`,
                            onClick: () => {
                                let e = f.target;
                                N(null), $r(e)
                            },
                            children: `Abrir documento creado`
                        })]
                    })]
                }), et === `rectificative-preview` && mr && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Consulta de rectificativo`
                    }), (0, k.jsx)(`h2`, {
                        children: mr.number
                    }), (0, k.jsxs)(`div`, {
                        className: `order-grid`,
                        children: [(0, k.jsxs)(`p`, {
                            children: [(0, k.jsx)(`b`, {
                                children: `Fecha`
                            }), (0, k.jsx)(`br`, {}), mr.date]
                        }), (0, k.jsxs)(`p`, {
                            children: [(0, k.jsx)(`b`, {
                                children: `Estado`
                            }), (0, k.jsx)(`br`, {}), mr.status]
                        }), (0, k.jsxs)(`p`, {
                            children: [(0, k.jsx)(`b`, {
                                children: `Cliente`
                            }), (0, k.jsx)(`br`, {}), mr.client]
                        }), (0, k.jsxs)(`p`, {
                            children: [(0, k.jsx)(`b`, {
                                children: `Rectifica a`
                            }), (0, k.jsx)(`br`, {}), mr.rectifiesNumber || mr.sourceRefs?.[0]?.number || `—`]
                        }), (0, k.jsxs)(`p`, {
                            className: `wide`,
                            children: [(0, k.jsx)(`b`, {
                                children: `Motivo de rectificación`
                            }), (0, k.jsx)(`br`, {}), mr.correctionReason || `—`]
                        })]
                    }), (0, k.jsx)(`div`, {
                        className: `preview-lines`,
                        children: e.map(e => (0, k.jsxs)(`div`, {
                            className: `partial`,
                            children: [(0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: e.description || `Línea libre`
                                }), (0, k.jsxs)(`small`, {
                                    children: [e.code || `Sin referencia`, ` · Cantidad `, e.qty, ` · Precio `, j(A(e.price)), ` · IGIC `, e.igic, ` %`]
                                })]
                            }), (0, k.jsx)(`b`, {
                                children: j(A(e.qty) * A(e.price) * (1 - A(e.discount) / 100))
                            })]
                        }, e.id))
                    }), (0, k.jsxs)(`div`, {
                        className: `summary`,
                        children: [(0, k.jsxs)(`p`, {
                            children: [`Base imponible `, (0, k.jsx)(`b`, {
                                children: j(n)
                            })]
                        }), (0, k.jsxs)(`p`, {
                            children: [`IGIC `, (0, k.jsx)(`b`, {
                                children: j(r)
                            })]
                        }), (0, k.jsxs)(`p`, {
                            children: [`Total `, (0, k.jsx)(`b`, {
                                children: j(n + r)
                            })]
                        })]
                    }), mr.signerName && (0, k.jsxs)(`p`, {
                        children: [(0, k.jsx)(`b`, {
                            children: `Firmado por`
                        }), (0, k.jsx)(`br`, {}), mr.signerName, mr.signedAt ? ` · ${mr.signedAt}` : ``]
                    }), mr.signatureUrl && (0, k.jsx)(`img`, {
                        className: `signature-preview`,
                        src: mr.signatureUrl,
                        alt: `Firma del rectificativo`
                    }), (0, k.jsxs)(`div`, {
                        className: `dialogactions`,
                        children: [(0, k.jsx)(`button`, {
                            onClick: () => {
                                N(null), hr(null)
                            },
                            children: `Cerrar`
                        }), (0, k.jsx)(`button`, {
                            className: `primary`,
                            onClick: () => {
                                let e = mr;
                                N(null), hr(null), $r(e)
                            },
                            children: `Abrir albarán`
                        })]
                    })]
                }), et === `print-delivery` && printDocument && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Impresión de albarán`
                    }), (0, k.jsx)(`h2`, {
                        children: `¿Cómo quieres imprimirlo?`
                    }), (0, k.jsx)(`p`, {
                        children: `El modo de impresión no modifica ni elimina la información económica guardada.`
                    }), (0, k.jsxs)(`div`, {
                        className: `dest`,
                        children: [(0, k.jsxs)(`button`, {
                            type: `button`,
                            onClick: () => {
                                let e = printDocument;
                                setPrintDocument(null), N(null), openCommercialPrintPreview({
                                    ...e,
                                    valued: !0
                                })
                            },
                            children: [(0, k.jsx)(pe, {}), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: `Valorado`
                                }), (0, k.jsx)(`small`, {
                                    children: `Incluye precios, impuestos y totales.`
                                })]
                            })]
                        }), (0, k.jsxs)(`button`, {
                            type: `button`,
                            onClick: () => {
                                let e = printDocument;
                                setPrintDocument(null), N(null), openCommercialPrintPreview({
                                    ...e,
                                    valued: !1
                                })
                            },
                            children: [(0, k.jsx)(pe, {}), (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`b`, {
                                    children: `No valorado`
                                }), (0, k.jsx)(`small`, {
                                    children: `Sin información económica para el cliente.`
                                })]
                            })]
                        })]
                    }), (0, k.jsx)(`div`, {
                        className: `dialogactions`,
                        children: (0, k.jsx)(`button`, {
                            type: `button`,
                            onClick: () => {
                                setPrintDocument(null), N(null)
                            },
                            children: `Cancelar`
                        })
                    })]
                }), et === `economics` && ecoDraft && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Documento comercial`
                    }), (0, k.jsx)(`h2`, {
                        children: `Descuentos y gastos`
                    }), (0, k.jsxs)(`div`, {
                        className: `economics-form`,
                        children: [(0, k.jsxs)(`label`, {
                            children: [`Descuento`, (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`input`, {
                                    type: `number`,
                                    min: `0`,
                                    step: `0.01`,
                                    value: ecoDraft.globalDiscountValue,
                                    onChange: e => setEcoDraft({
                                        ...ecoDraft,
                                        globalDiscountValue: e.target.value
                                    })
                                }), (0, k.jsxs)(`select`, {
                                    value: ecoDraft.globalDiscountMode,
                                    onChange: e => setEcoDraft({
                                        ...ecoDraft,
                                        globalDiscountMode: e.target.value
                                    }),
                                    children: [(0, k.jsx)(`option`, {
                                        value: `PERCENT`,
                                        children: `%`
                                    }), (0, k.jsx)(`option`, {
                                        value: `AMOUNT`,
                                        children: `€`
                                    })]
                                })]
                            })]
                        }), (0, k.jsxs)(`label`, {
                            children: [`Gastos`, (0, k.jsxs)(`span`, {
                                children: [(0, k.jsx)(`input`, {
                                    type: `number`,
                                    min: `0`,
                                    step: `0.01`,
                                    value: ecoDraft.expenseValue,
                                    onChange: e => setEcoDraft({
                                        ...ecoDraft,
                                        expenseValue: e.target.value
                                    })
                                }), (0, k.jsxs)(`select`, {
                                    value: ecoDraft.expenseMode,
                                    onChange: e => setEcoDraft({
                                        ...ecoDraft,
                                        expenseMode: e.target.value
                                    }),
                                    children: [(0, k.jsx)(`option`, {
                                        value: `PERCENT`,
                                        children: `%`
                                    }), (0, k.jsx)(`option`, {
                                        value: `AMOUNT`,
                                        children: `€`
                                    })]
                                })]
                            })]
                        })]
                    }), (0, k.jsxs)(`div`, {
                        className: `dialogactions`,
                        children: [(0, k.jsx)(`button`, {
                            onClick: () => {
                                setEcoDraft(null), N(null)
                            },
                            children: `Cancelar`
                        }), (0, k.jsx)(`button`, {
                            className: `primary`,
                            onClick: () => {
                                let e = {
                                    globalDiscountMode: ecoDraft.globalDiscountMode,
                                    globalDiscountValue: A(ecoDraft.globalDiscountValue),
                                    expenseMode: ecoDraft.expenseMode,
                                    expenseValue: A(ecoDraft.expenseValue)
                                };
                                try {
                                    calculateCommercialEconomics(_, e), d({
                                        ...u,
                                        ...e
                                    }), setEcoDraft(null), N(null)
                                } catch {
                                    B(`Revisa los valores de descuento y gastos`)
                                }
                            },
                            children: `Aplicar`
                        })]
                    })]
                }), et === `work-order-mail-history` && (0, k.jsxs)(k.Fragment, {
                        children: [(0, k.jsx)(`p`, { className: `eyebrow`, children: `Orden de Trabajo` }), (0, k.jsx)(`h2`, { children: `Histórico de envíos` }), (0, k.jsxs)(`p`, { children: [`OT `, I.number] }), (0, k.jsx)(`div`, { className: `work-order-mail-history-list`, children: workOrderMail.history.length ? workOrderMail.history.map(item => (0, k.jsxs)(`div`, { className: `settingrow`, children: [(0, k.jsxs)(`span`, { children: [(0, k.jsx)(`b`, { children: item.to }), (0, k.jsxs)(`small`, { children: [new Date(item.sentAt.replace(` `, `T`)).toLocaleString(`es-ES`), item.user ? ` · ${item.user}` : ``] })] }), (0, k.jsx)(`strong`, { className: item.result === `SENT` ? `mail-sent` : `mail-error`, children: item.result === `SENT` ? `ENVIADO` : `ERROR — ${item.error}` })] }, item.id)) : (0, k.jsx)(`p`, { className: `mail-empty`, children: `Todavía no hay envíos registrados.` }) }), (0, k.jsx)(`div`, { className: `dialogactions`, children: (0, k.jsx)(`button`, { onClick: () => N(null), children: `Cerrar` }) })]
                }), et === `work-order-email` && (0, k.jsxs)(k.Fragment, {
                        children: [(0, k.jsx)(`p`, { className: `eyebrow`, children: `Orden de Trabajo finalizada` }), (0, k.jsx)(`h2`, { children: `Enviar al cliente` }), (0, k.jsxs)(`label`, { className: `field`, children: [`Destinatario`, (0, k.jsx)(`input`, { type: `email`, autoFocus: !0, value: workOrderMail.recipient, onChange: e => setWorkOrderMail(value => ({ ...value, recipient: e.target.value })) })] }), (0, k.jsx)(`p`, { children: `Se adjuntará la Orden de Trabajo finalizada. Este destinatario se usa sólo para este envío.` }), (0, k.jsxs)(`div`, { className: `dialogactions`, children: [(0, k.jsx)(`button`, { onClick: () => N(null), children: `Cancelar` }), (0, k.jsx)(`button`, { className: `primary`, disabled: workOrderMail.sending || !workOrderMail.recipient.trim(), onClick: () => void sendWorkOrderMail(), children: workOrderMail.sending ? `Enviando…` : `Enviar al cliente` })] })]
                }), et === `task` && vi(), et === `sign` && yi(), et === `rectify` && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Trazabilidad`
                    }), (0, k.jsx)(`h2`, {
                        children: `Crear albarán rectificativo`
                    }), (0, k.jsxs)(`label`, {
                        className: `field`,
                        children: [`Motivo obligatorio`, (0, k.jsx)(`textarea`, {
                            value: Yt,
                            onChange: e => Xt(e.target.value)
                        })]
                    }), (0, k.jsx)(`p`, {
                        children: `El original permanecerá cerrado. Se crearán líneas negativas vinculadas.`
                    }), (0, k.jsx)(`button`, {
                        className: `primary full`,
                        onClick: () => void Kr(),
                        children: `Crear rectificativo`
                    })]
                }), et === `logout` && (0, k.jsxs)(k.Fragment, {
                    children: [(0, k.jsx)(`p`, {
                        className: `eyebrow`,
                        children: `Sesión`
                    }), (0, k.jsx)(`h2`, {
                        children: `Cerrar sesión`
                    }), (0, k.jsx)(`p`, {
                        children: `La información temporal de esta sesión se perderá.`
                    }), (0, k.jsxs)(`div`, {
                        className: `dialogactions`,
                        children: [(0, k.jsx)(`button`, {
                            onClick: () => N(null),
                            children: `Cancelar`
                        }), (0, k.jsxs)(`button`, {
                            className: `primary`,
                            onClick: async () => {
                                (await M(`/api/auth.php?action=logout`, {
                                    method: `POST`
                                })).ok ? (N(null), t()) : B(`No se pudo cerrar la sesión`)
                            },
                            children: [(0, k.jsx)(le, {}), `Cerrar sesión`]
                        })]
                    })]
                })]
            })
        })
    }

    function vi() {
        let e = Lt,
            t = Rt;
        return (0, k.jsxs)(k.Fragment, {
            children: [(0, k.jsxs)(`p`, {
                className: `eyebrow`,
                children: [e.version ? `Editar` : `Nueva`, ` tarea`]
            }), (0, k.jsx)(`h2`, {
                children: e.version ? `Detalle de tarea` : `Crear tarea`
            }), (0, k.jsxs)(`label`, {
                className: `field`,
                children: [`Título`, (0, k.jsx)(`input`, {
                    value: e.title,
                    onChange: n => t({
                        ...e,
                        title: n.target.value
                    })
                })]
            }), (0, k.jsxs)(`div`, {
                className: `formgrid`,
                children: [(0, k.jsxs)(`label`, {
                    className: `field`,
                    children: [`Responsable`, (0, k.jsxs)(`select`, {
                        value: e.owner,
                        onChange: n => t({
                            ...e,
                            owner: n.target.value
                        }),
                        children: [(0, k.jsx)(`option`, {
                            children: `Iván García`
                        }), (0, k.jsx)(`option`, {
                            children: `Laura Pérez`
                        })]
                    })]
                }), (0, k.jsxs)(`label`, {
                    className: `field`,
                    children: [`Fecha prevista`, (0, k.jsx)(`input`, {
                        type: `date`,
                        value: e.date,
                        onChange: n => t({
                            ...e,
                            date: n.target.value
                        })
                    })]
                }), (0, k.jsxs)(`label`, {
                    className: `field`,
                    children: [`Estado`, (0, k.jsx)(`select`, {
                        value: e.status,
                        onChange: n => t({
                            ...e,
                            status: n.target.value
                        }),
                        children: [`Pendiente`, `En curso`, `Completada`, `Cancelada`].map(e => (0, k.jsx)(`option`, {
                            children: e
                        }, e))
                    })]
                }), (0, k.jsxs)(`label`, {
                    className: `field`,
                    children: [`Cliente / documento`, (0, k.jsx)(`input`, {
                        value: e.link,
                        onChange: n => t({
                            ...e,
                            link: n.target.value
                        })
                    })]
                })]
            }), (0, k.jsxs)(`label`, {
                className: `field`,
                children: [`Comentario`, (0, k.jsx)(`textarea`, {
                    value: e.comment,
                    onChange: n => t({
                        ...e,
                        comment: n.target.value
                    })
                })]
            }), (0, k.jsxs)(`label`, {
                className: `field`,
                children: [`Resultado final`, (0, k.jsx)(`textarea`, {
                    value: e.result,
                    onChange: n => t({
                        ...e,
                        result: n.target.value
                    })
                })]
            }), (0, k.jsxs)(`div`, {
                className: `dialogactions`,
                children: [(0, k.jsx)(`button`, {
                    onClick: () => N(null),
                    children: `Cancelar`
                }), (0, k.jsx)(`button`, {
                    className: `primary`,
                    disabled: !e.title.trim(),
                    onClick: async () => {
                        try {
                            It(await Ar(e)), N(null), B(`Guardado`)
                        } catch (e) {
                            B(e instanceof Error && e.message === `VERSION_CONFLICT` ? `La tarea cambió en otra sesión; vuelve a abrirla` : `No se pudo guardar la tarea`)
                        }
                    },
                    children: `Guardar`
                })]
            })]
        })
    }

    function yi() {
        let e = e => {
            let t = _r.current;
            if (!t) return;
            let n = t.getBoundingClientRect(),
                r = t.getContext(`2d`),
                i = (e.clientX - n.left) * t.width / n.width,
                a = (e.clientY - n.top) * t.height / n.height;
            r && (e.type === `pointerdown` ? (br.current = !0, r.beginPath(), r.moveTo(i, a), Ht(!0)) : e.type === `pointermove` && br.current ? (r.lineTo(i, a), r.strokeStyle = `#10384f`, r.lineWidth = 3, r.stroke()) : br.current = !1)
        };
        return (0, k.jsxs)(k.Fragment, {
            children: [(0, k.jsx)(`p`, {
                className: `eyebrow`,
                children: `Cierre de entrega`
            }), (0, k.jsx)(`h2`, {
                children: `Firma del albarán`
            }), (0, k.jsxs)(`div`, {
                className: `summary`,
                children: [(0, k.jsxs)(`span`, {
                    children: [_.length, ` líneas`]
                }), (0, k.jsxs)(`span`, {
                    children: [Ze(_.reduce((e, t) => e + A(t.qty), 0)), ` unidades`]
                }), mt && (0, k.jsx)(`b`, {
                    children: j(Vr.total)
                })]
            }), (0, k.jsxs)(`label`, {
                className: `field`,
                children: [`Nombre y apellidos`, (0, k.jsx)(`input`, {
                    value: Gt,
                    onChange: e => Kt(e.target.value)
                })]
            }), (0, k.jsxs)(`label`, {
                className: `field`,
                children: [`NIF/CIF`, (0, k.jsx)(`input`, {
                    value: qt,
                    onChange: e => Jt(e.target.value)
                })]
            }), (0, k.jsxs)(`div`, {
                className: `sign`,
                children: [(0, k.jsx)(`canvas`, {
                    ref: _r,
                    width: `700`,
                    height: `210`,
                    onPointerDown: e,
                    onPointerMove: e,
                    onPointerUp: e,
                    onPointerLeave: e
                }), !Vt && (0, k.jsxs)(`span`, {
                    children: [(0, k.jsx)(ve, {}), `Firma aquí`]
                }), (0, k.jsxs)(`button`, {
                    onClick: () => {
                        _r.current?.getContext(`2d`)?.clearRect(0, 0, 700, 210), Ht(!1)
                    },
                    children: [(0, k.jsx)(O, {}), `Borrar`]
                })]
            }), (0, k.jsxs)(`label`, {
                className: `field conformity`,
                children: [(0, k.jsx)(`input`, {
                    type: `checkbox`,
                    checked: Ut,
                    onChange: e => Wt(e.target.checked)
                }), `He revisado y estoy conforme con los datos del albarán`]
            }), (0, k.jsx)(`button`, {
                className: `primary full`,
                onClick: () => void qr(),
                children: `Firmar y cerrar`
            })]
        })
    }

    function V({
        title: e,
        sub: t,
        action: n,
        onAction: r
    }) {
        return (0, k.jsxs)(`div`, {
            className: `title`,
            children: [(0, k.jsxs)(`div`, {
                children: [(0, k.jsx)(`h2`, {
                    children: e
                }), t && (0, k.jsx)(`p`, {
                    children: t
                })]
            }), n && (0, k.jsxs)(`button`, {
                onClick: r,
                children: [n, (0, k.jsx)(S, {})]
            })]
        })
    }

    function xi({
        d: e
    }) {
        return (0, k.jsxs)(`button`, {
            className: `doc`,
            onClick: () => $r(e),
            children: [(0, k.jsx)(`span`, {
                className: `dicon ${e.kind===`Oferta`?`c0`:e.kind===`Pedido`?`c1`:`c2`}`,
                children: e.kind === `Oferta` ? (0, k.jsx)(se, {}) : e.kind === `Pedido` ? (0, k.jsx)(E, {}) : (0, k.jsx)(be, {})
            }), (0, k.jsxs)(`span`, {
                children: [(0, k.jsx)(`b`, {
                    children: e.number
                }), (0, k.jsx)(`small`, {
                    children: e.client || `Cliente pendiente`
                })]
            }), (0, k.jsx)(`em`, {
                children: Qe(e.date)
            }), (0, k.jsx)(`i`, {
                children: e.status
            }), (0, k.jsx)(`strong`, {
                children: e.total ? j(e.total) : `—`
            }), (0, k.jsx)(oe, {})]
        })
    }
}


